import productStudioEditTranslations from "../views/catalogProductStudio/edit/editTranslations";
import labelPrintTranslations from "../components/Print/labelPrintTranslations";
import metaAdsTranslations from "../views/marketing/metaAdsTranslations";
import printCenterTranslations from "../views/printCenter/printCenterTranslations";
import analyticsTranslations from "../views/analytics/analyticsTranslations";

// Translations object containing all text in both languages
const translations = {
  productStudioEdit: productStudioEditTranslations,
  labelPrint: labelPrintTranslations,
  metaAds: metaAdsTranslations,
  printCenter: printCenterTranslations,
  analytics: analyticsTranslations,
  // Common
  common: {
    save: {
      sq: "Ruaj",
      en: "Save",
    },
    cancel: {
      sq: "Anulo",
      en: "Cancel",
    },
    back: {
      sq: "Kthehu",
      en: "Back",
    },
    delete: {
      sq: "Fshi",
      en: "Delete",
    },
    edit: {
      sq: "Ndrysho",
      en: "Edit",
    },
    search: {
      sq: "Kërko",
      en: "Search",
    },
    loading: {
      sq: "Duke u ngarkuar...",
      en: "Loading...",
    },
    error: {
      sq: "Gabim",
      en: "Error",
    },
    success: {
      sq: "Sukses",
      en: "Success",
    },
    confirm: {
      sq: "Konfirmo",
      en: "Confirm",
    },
    close: {
      sq: "Mbyll",
      en: "Close",
    },
    startDate: {
      sq: "Data e Fillimit",
      en: "Start Date",
    },
    endDate: {
      sq: "Data e Mbarimit",
      en: "End Date",
    },
    filter: {
      sq: "Filtro",
      en: "Filter",
    },
    showAll: {
      sq: "Shfaq të Gjitha",
      en: "Show All",
    },
    saving: {
      sq: "Duke u ruajtur...",
      en: "Saving...",
    },
    refresh: {
      sq: "Rifresko",
      en: "Refresh",
    },
    optional: {
      sq: "Opsionale",
      en: "Optional",
    },
    selectDate: {
      sq: "Zgjidh Datën",
      en: "Select Date",
    },
  },
  // Navigation
  navigation: {
    dashboard: {
      sq: "Dashboard",
      en: "Dashboard",
    },
    products: {
      sq: "Produktet",
      en: "Products",
    },
    addProducts: {
      sq: "Shto Produkte",
      en: "Add Products",
    },
    sales: {
      sq: "Shitjet",
      en: "Sales",
    },
    returns: {
      sq: "Kthimet",
      en: "Returns",
    },
    recentSales: {
      sq: "Shitjet e fundit",
      en: "Recent Sales",
    },
    recentReturns: {
      sq: "Kthimet e fundit",
      en: "Recent Returns",
    },
    exchanges: {
      sq: "Këmbimet",
      en: "Exchanges",
    },
    recentExchanges: {
      sq: "Këmbimet e fundit",
      en: "Recent Exchanges",
    },
    legacyIntake: {
      sq: "Hyrje e vjetër",
      en: "Legacy Intake",
    },
    legacyProducts: {
      sq: "Produkte të vjetra",
      en: "Legacy Products",
    },
    createOrder: {
      sq: "Krijo porosi",
      en: "Create Order",
    },
    transactions: {
      sq: "Transaksionet",
      en: "Transactions",
    },
    orders: {
      sq: "Porositë",
      en: "Orders",
    },
    customers: {
      sq: "Klientët",
      en: "Customers",
    },
    cmsPanels: {
      sq: "Paneli CMS",
      en: "CMS Panels",
    },
    referenceData: {
      sq: "Të dhëna referencë",
      en: "Reference Data",
    },
    stockCheck: {
      sq: "Kontrolli i stokut",
      en: "Stock Check",
    },
    collections: {
      sq: "Koleksionet",
      en: "Collections",
    },
    marketing: {
      sq: "Marketingu",
      en: "Marketing",
    },
    metaAds: {
      sq: "Meta Ads",
      en: "Meta Ads",
    },
    printing: {
      sq: "Printimi",
      en: "Printing",
    },
    printCenter: {
      sq: "Qendra e printimit",
      en: "Print Center",
    },
    analytics: {
      sq: "Analitika",
      en: "Analytics",
    },
    administration: {
      sq: "Administrimi",
      en: "Administration",
    },
    settings: {
      sq: "Cilësimet",
      en: "Settings",
    },
    profile: {
      sq: "Profili",
      en: "Profile",
    },
    userProfile: {
      sq: "Profili i Përdoruesit",
      en: "User Profile",
    },
    companyProfile: {
      sq: "Profili i Kompanisë",
      en: "Company Profile",
    },
    notifications: {
      sq: "Njoftimet",
      en: "Notifications",
    },
    icons: {
      sq: "Ikona",
      en: "Icons",
    },
    tableList: {
      sq: "Lista e Tabelave",
      en: "Table List",
    },
    login: {
      sq: "Hyrje",
      en: "Log In",
    },
  },
  userProfilePage: {
    editProfileTitle: {
      sq: "Ndrysho profilin",
      en: "Edit profile",
    },
    securityTitle: {
      sq: "Siguria",
      en: "Security",
    },
    changePasswordSubtitle: {
      sq: "Përditëso fjalëkalimin me të cilin hyr në CMS.",
      en: "Update the password you use to sign in to the CMS.",
    },
    currentPassword: {
      sq: "Fjalëkalimi aktual",
      en: "Current password",
    },
    currentPasswordRequired: {
      sq: "Shkruani fjalëkalimin aktual.",
      en: "Enter your current password.",
    },
    newPassword: {
      sq: "Fjalëkalimi i ri",
      en: "New password",
    },
    confirmPassword: {
      sq: "Konfirmo fjalëkalimin e ri",
      en: "Confirm new password",
    },
    updatePassword: {
      sq: "Përditëso fjalëkalimin",
      en: "Update password",
    },
    passwordRequirements: {
      sq: "8–128 karaktere, me shkronjë të madhe, të vogël, numër dhe simbol.",
      en: "8–128 characters with uppercase, lowercase, a number, and a symbol.",
    },
    passwordsMustMatch: {
      sq: "Fjalëkalimet e reja duhet të përputhen.",
      en: "New password and confirmation must match.",
    },
    passwordChanged: {
      sq: "Fjalëkalimi u përditësua me sukses.",
      en: "Password updated successfully.",
    },
    showPassword: {
      sq: "Shfaq",
      en: "Show",
    },
    hidePassword: {
      sq: "Fsheh",
      en: "Hide",
    },
    saveProfile: {
      sq: "Ruaj profilin",
      en: "Save profile",
    },
    saving: {
      sq: "Duke ruajtur…",
      en: "Saving…",
    },
    profileUpdated: {
      sq: "Profili u përditësua me sukses.",
      en: "Profile updated successfully.",
    },
  },
  // Login page
  login: {
    title: {
      sq: "Hyr në Black & White CMS",
      en: "Sign in to Black & White CMS",
    },
    email: {
      sq: "Adresa e Email-it",
      en: "Email Address",
    },
    emailPlaceholder: {
      sq: "Shkruani email-in tuaj",
      en: "Enter your email",
    },
    password: {
      sq: "Fjalëkalimi",
      en: "Password",
    },
    passwordPlaceholder: {
      sq: "Shkruani fjalëkalimin",
      en: "Enter your password",
    },
    businessName: {
      sq: "Emri i Biznesit",
      en: "Business name",
    },
    businessNamePlaceholder: {
      sq: "Shkruani emrin e biznesit tuaj",
      en: "Enter your business name",
    },
    loginButton: {
      sq: "Hyr",
      en: "Login",
    },
    signUpButton: {
      sq: "Regjistrohu",
      en: "Sign Up",
    },
    createAccount: {
      sq: "Krijo Llogari të Re",
      en: "Create New Account",
    },
    loginExisting: {
      sq: "Hyr në llogari ekzistuese",
      en: "Login into existing account",
    },
    or: {
      sq: "OSE",
      en: "OR",
    },
    errorMessage: {
      sq: "Diçka shkoi keq! Ju lutem provoni përsëri",
      en: "Something goes wrong! Please Try Again",
    },
    registerUnavailable: {
      sq: "Formulari i regjistrimit nuk është i disponueshëm tani",
      en: "Register Form isn't available right now",
    },
  },
  // Table headers
  table: {
    id: {
      sq: "ID",
      en: "ID",
    },
    brand: {
      sq: "Marka",
      en: "Brand",
    },
    color: {
      sq: "Ngjyra",
      en: "Color",
    },
    number: {
      sq: "Numri",
      en: "Number",
    },
    type: {
      sq: "Lloji",
      en: "Type",
    },
    code: {
      sq: "Kodi",
      en: "Code",
    },
    quantity: {
      sq: "Sasia",
      en: "Quantity",
    },
    price: {
      sq: "Çmimi",
      en: "Price",
    },
    location: {
      sq: "Vendndodhja",
      en: "Location",
    },
    locations: {
      sq: "Vendndodhjet",
      en: "Locations",
    },
    actions: {
      sq: "Veprimet",
      en: "Actions",
    },
    paymentType: {
      sq: "Lloji i Pagesës",
      en: "Payment Type",
    },
    bankName: {
      sq: "Emri i Bankës",
      en: "Bank Name",
    },
    salePrice: {
      sq: "Çmimi i Shitjes",
      en: "Sale Price",
    },
    originalPrice: {
      sq: "Çmimi Origjinal",
      en: "Original Price",
    },
    refund: {
      sq: "Rimbursimi (€)",
      en: "Refund (€)",
    },
    reason: {
      sq: "Arsyeja",
      en: "Reason",
    },
    name: {
      sq: "Emri",
      en: "Name",
    },
    country: {
      sq: "Vendi",
      en: "Country",
    },
    city: {
      sq: "Qyteti",
      en: "City",
    },
    salary: {
      sq: "Paga",
      en: "Salary",
    },
    produced: {
      sq: "Prodhuesi",
      en: "Produced",
    },
    colorName: {
      sq: "Emri i Ngjyrës",
      en: "Color Name",
    },
    hexCode: {
      sq: "Ngjyra (HEX)",
      en: "Color (HEX)",
    },
    albanian: {
      sq: "Shqip",
      en: "Albanian",
    },
    english: {
      sq: "Anglisht",
      en: "English",
    },
    turkish: {
      sq: "Turqisht",
      en: "Turkish",
    },
    specificType: {
      sq: "Lloji Specifik",
      en: "Specific Type",
    },
  },
  // Dashboard
  dashboard: {
    salesOverview: {
      sq: "Pasqyra e shitjeve",
      en: "Sales overview",
    },
    salesByDate: {
      sq: "Shitjet sipas datës",
      en: "Sales by date",
    },
    salesByDateHint: {
      sq: "Zgjidh intervalin për të parë shitjet dhe totalin neto pas kthimeve.",
      en: "Choose a range to view sales and the net total after returns.",
    },
    dateFrom: {
      sq: "Prej datës",
      en: "From",
    },
    dateTo: {
      sq: "Deri më",
      en: "To",
    },
    applyRange: {
      sq: "Shfaq",
      en: "Apply",
    },
    loadingSales: {
      sq: "Duke ngarkuar…",
      en: "Loading…",
    },
    salesLoadError: {
      sq: "Statistikat e shitjeve nuk u ngarkuan. Provo përsëri.",
      en: "Sales statistics could not be loaded. Please try again.",
    },
    salesCount: {
      sq: "Numri i shitjeve",
      en: "Number of sales",
    },
    completedSales: {
      sq: "shitje të përfunduara",
      en: "completed sales",
    },
    netTotal: {
      sq: "Totali neto",
      en: "Net total",
    },
    afterReturns: {
      sq: "pas kthimeve",
      en: "after returns",
    },
    grossTotal: {
      sq: "Bruto",
      en: "Gross",
    },
    returnsTotal: {
      sq: "Kthime",
      en: "Returns",
    },
    totalShipments: {
      sq: "Total Dërgesat",
      en: "Total Shipments",
    },
    performance: {
      sq: "Performanca",
      en: "Performance",
    },
    onlineSales: {
      sq: "Shitjet Online",
      en: "Online Sales",
    },
    bankPayments: {
      sq: "Pagesat Bankare",
      en: "Bank Payments",
    },
    qty: {
      sq: "Sasia",
      en: "Qty",
    },
    tasks: {
      sq: "Detyrat",
      en: "Tasks",
    },
    today: {
      sq: "sot",
      en: "today",
    },
    action: {
      sq: "Veprim",
      en: "Action",
    },
    anotherAction: {
      sq: "Veprim tjetër",
      en: "Another action",
    },
    somethingElse: {
      sq: "Diçka tjetër",
      en: "Something else",
    },
    editTask: {
      sq: "Ndrysho Detyrën",
      en: "Edit Task",
    },
    simpleTable: {
      sq: "Tabelë e Thjeshtë",
      en: "Simple Table",
    },
    sales: {
      sq: "Shitjet",
      en: "Sales",
    },
    shoes: {
      sq: "Këpucët",
      en: "Shoes",
    },
    textile: {
      sq: "Tekstili",
      en: "Textile",
    },
    startYear: {
      sq: "Viti i Fillimit",
      en: "Start Year",
    },
    endYear: {
      sq: "Viti i Fundit",
      en: "End Year",
    },
    yearsBetween: {
      sq: "Vitet në mes",
      en: "Years between",
    },
    years: {
      sq: "vite",
      en: "years",
    },
  },
  // Products List
  products: {
    title: {
      sq: "Produktet",
      en: "Products",
    },
    selectProducts: {
      sq: "Zgjidh Produktet",
      en: "Select Products",
    },
    filterByCode: {
      sq: "Filtro me Kod",
      en: "Filter by Code",
    },
    filterByBrand: {
      sq: "Filtro me Markë",
      en: "Filter by Brand",
    },
    resetFilters: {
      sq: "Rivendos Filtra",
      en: "Reset Filters",
    },
    printSelected: {
      sq: "Printo të Zgjedhur",
      en: "Print Selected",
    },
    transfer: {
      sq: "Transfero",
      en: "Transfer",
    },
    noProducts: {
      sq: "Nuk ka produkte që përputhen me filtrin tuaj",
      en: "No products match your filter",
    },
    tryDifferentFilters: {
      sq: "Provoni filtra të ndryshëm ose skanoni një kod barkodi",
      en: "Try different filters or scan a barcode",
    },
    failedToLoad: {
      sq: "Dështoi ngarkimi i produkteve",
      en: "Failed to load products",
    },
    pleaseTryAgain: {
      sq: "Ju lutem provoni përsëri ose rregulloni filtrat",
      en: "Please try again or adjust filters",
    },
  },
  // Sales
  sales: {
    title: {
      sq: "Shitjet",
      en: "Sales",
    },
    selectProducts: {
      sq: "Zgjidh Produktet",
      en: "Select Products",
    },
    sellSelected: {
      sq: "Shit",
      en: "Sell",
    },
    salesList: {
      sq: "Lista e Shitjeve",
      en: "Sales List",
    },
    products: {
      sq: "Produktet",
      en: "Products",
    },
    noSales: {
      sq: "Nuk ka shitje për këtë ditë",
      en: "No sales for this day",
    },
    changeDay: {
      sq: "Përdorni shigjetat më sipër për të ndryshuar ditën",
      en: "Use the arrows above to change the day",
    },
    failedToLoadSales: {
      sq: "Dështoi ngarkimi i shitjeve",
      en: "Failed to load sales",
    },
    totalSales: {
      sq: "Total Shitjet",
      en: "Total Sales",
    },
    productsSold: {
      sq: "Produktet u regjistruan në shitje me sukses",
      en: "Products registered to sales successfully",
    },
    productSold: {
      sq: "Produkti u regjistrua në shitje me sukses",
      en: "Product registered to sales successfully",
    },
    errorSelling: {
      sq: "Gabim në shitjen e produkteve",
      en: "Error selling products",
    },
    saleModal: {
      sq: "Modal i Shitjes",
      en: "Sale Modal",
    },
    model: {
      sq: "Modeli",
      en: "Model",
    },
    regularPrice: {
      sq: "Çmimi i Rregullt",
      en: "Regular Price",
    },
    price: {
      sq: "Çmimi",
      en: "Price",
    },
    paymentType: {
      sq: "Lloji i Pagesës",
      en: "Payment Type",
    },
    saleType: {
      sq: "Lloji i Shitjes",
      en: "Sale Type",
    },
    store: {
      sq: "Dyqan",
      en: "Store",
    },
    online: {
      sq: "Online",
      en: "Online",
    },
    sell: {
      sq: "Shit",
      en: "Sell",
    },
    selectBank: {
      sq: "Zgjidh Bankën",
      en: "Select Bank",
    },
    bank: {
      sq: "Bankë",
      en: "Bank",
    },
    cash: {
      sq: "Para",
      en: "Cash",
    },
    priceRequired: {
      sq: "Çmimi duhet të jetë më i madh se 0",
      en: "Price must be greater than 0",
    },
    bankRequired: {
      sq: "Bankë është e nevojshme kur lloji i pagesës është bankë",
      en: "Bank is required when payment type is bank",
    },
    validationError: {
      sq: "Ju lutem plotësoni të gjitha fushat e kërkuara siç duhet",
      en: "Please fill in all required fields correctly",
    },
    noProductsSelected: {
      sq: "Ju lutem zgjidhni të paktën një produkt për të shitur",
      en: "Please select at least one product to sell",
    },
  },
  // Transactions
  transactions: {
    title: {
      sq: "Transaksionet",
      en: "Transactions",
    },
    selectProducts: {
      sq: "Zgjidh Produktet",
      en: "Select Products",
    },
    addTransaction: {
      sq: "Shto Transaksion",
      en: "Add Transaction",
    },
    transactionsList: {
      sq: "Lista e Transaksioneve",
      en: "Transactions List",
    },
    selectDate: {
      sq: "Zgjidh Datën",
      en: "Select Date",
    },
    noTransactions: {
      sq: "Nuk ka transaksione për këtë datë",
      en: "No transactions for this date",
    },
    failedToLoad: {
      sq: "Dështoi ngarkimi i transaksioneve",
      en: "Failed to load transactions",
    },
    products: {
      sq: "Produktet",
      en: "Products",
    },
    tryDifferentDate: {
      sq: "Provoni të zgjidhni një datë tjetër ose shtoni një transaksion",
      en: "Try selecting a different date or add a transaction",
    },
    total: {
      sq: "Total",
      en: "Total",
    },
    subType: {
      sq: "Nën-Lloji i Transaksionit",
      en: "Transaction SubType",
    },
    transactionType: {
      sq: "Lloji i Transaksionit",
      en: "Transaction Type",
    },
    paymentType: {
      sq: "Lloji i Pagesës",
      en: "Payment Type",
    },
    price: {
      sq: "Çmimi",
      en: "Price",
    },
    description: {
      sq: "Përshkrimi",
      en: "Description",
    },
    selectSubType: {
      sq: "Zgjidh Nën-Llojin",
      en: "Select SubType",
    },
    selectTransactionType: {
      sq: "Zgjidh Llojin",
      en: "Select Type",
    },
    selectPaymentType: {
      sq: "Zgjidh Llojin e Pagesës",
      en: "Select Payment Type",
    },
    outcome: {
      sq: "Dalje",
      en: "Outcome",
    },
    income: {
      sq: "Hyrje",
      en: "Income",
    },
    bank: {
      sq: "Bankë",
      en: "Bank",
    },
    cash: {
      sq: "Para",
      en: "Cash",
    },
    enterPrice: {
      sq: "Shkruani Çmimin",
      en: "Enter Price",
    },
    addDescription: {
      sq: "Shto Përshkrim",
      en: "Add Description",
    },
    subTypeRequired: {
      sq: "Nën-lloji i transaksionit është i nevojshëm",
      en: "Transaction subtype is required",
    },
    transactionTypeRequired: {
      sq: "Lloji i transaksionit është i nevojshëm",
      en: "Transaction type is required",
    },
    paymentTypeRequired: {
      sq: "Lloji i pagesës është i nevojshëm",
      en: "Payment type is required",
    },
    priceRequired: {
      sq: "Çmimi duhet të jetë më i madh se 0",
      en: "Price must be greater than 0",
    },
    validationError: {
      sq: "Ju lutem plotësoni të gjitha fushat e kërkuara siç duhet",
      en: "Please fill in all required fields correctly",
    },
    transactionAdded: {
      sq: "Transaksioni u shtua me sukses",
      en: "Transaction added successfully",
    },
    transactionUpdated: {
      sq: "Transaksioni u përditësua me sukses",
      en: "Transaction updated successfully",
    },
    errorSaving: {
      sq: "Gabim në ruajtjen e transaksionit",
      en: "Error saving transaction",
    },
    editTransaction: {
      sq: "Ndrysho Transaksionin",
      en: "Edit Transaction",
    },
  },
  // Returns
  returns: {
    title: {
      sq: "Kthimet",
      en: "Returns",
    },
    selectProducts: {
      sq: "Zgjidh Produktet",
      en: "Select Products",
    },
    returnSelected: {
      sq: "Kthe",
      en: "Return Selected",
    },
    returnsList: {
      sq: "Lista e Kthimeve",
      en: "Returns List",
    },
    noReturns: {
      sq: "Nuk ka kthime për këtë ditë",
      en: "No returns for this day",
    },
    changeDay: {
      sq: "Përdorni shigjetat më sipër për të ndryshuar ditën ose procesoni një kthim",
      en: "Use the arrows above to change the day or process a return",
    },
    failedToLoad: {
      sq: "Dështoi ngarkimi i kthimeve",
      en: "Failed to load returns",
    },
    totalRefunded: {
      sq: "Total i Rimbursuar",
      en: "Total refunded",
    },
    productReturned: {
      sq: "Produkti u kthye me sukses",
      en: "Product returned successfully",
    },
    productsReturned: {
      sq: "Produktet u kthyen me sukses",
      en: "Products returned successfully",
    },
    errorRecordingReturn: {
      sq: "Gabim në regjistrimin e kthimit",
      en: "Error recording return",
    },
    noProductsSelected: {
      sq: "Ju lutem zgjidhni të paktën një produkt për të kthyer",
      en: "Please select at least one product to return",
    },
    products: {
      sq: "Produktet",
      en: "Products",
    },
    modalTitle: {
      sq: "Kthe Produktet",
      en: "Return Products",
    },
    originalPrice: {
      sq: "Çmimi Origjinal",
      en: "Original Price",
    },
    totalRefund: {
      sq: "Total Rimbursimi",
      en: "Total Refund",
    },
    confirmReturn: {
      sq: "Konfirmo Kthimin",
      en: "Confirm Return",
    },
    cash: {
      sq: "Para",
      en: "Cash",
    },
    card: {
      sq: "Kartë",
      en: "Card",
    },
    bank: {
      sq: "Bankë",
      en: "Bank",
    },
    bankPlaceholder: {
      sq: "Shkruani emrin e bankës",
      en: "Enter bank name",
    },
    reasonPlaceholder: {
      sq: "Shkruani arsyen e kthimit",
      en: "Enter return reason",
    },
    invalidRefund: {
      sq: "Shuma e rimbursimit duhet të jetë më e madhe se 0",
      en: "Refund amount must be greater than 0",
    },
    bankRequired: {
      sq: "Bankë është e nevojshme kur lloji i pagesës është bankë",
      en: "Bank is required when payment type is bank",
    },
    selectDate: {
      sq: "Zgjidh Datën",
      en: "Select Date",
    },
  },
  // Add Products
  addProducts: {
    title: {
      sq: "Shto Produkte",
      en: "Add Products",
    },
    shoes: {
      sq: "Këpucët",
      en: "Shoes",
    },
    accessories: {
      sq: "Aksesorët",
      en: "Accessories",
    },
    code: {
      sq: "Kodi",
      en: "Code",
    },
    name: {
      sq: "Emri",
      en: "Name",
    },
    brand: {
      sq: "Marka",
      en: "Brand",
    },
    type: {
      sq: "Lloji",
      en: "Type",
    },
    color: {
      sq: "Ngjyra",
      en: "Color",
    },
    stockPrice: {
      sq: "Çmimi i Magazinës",
      en: "Stock Price",
    },
    importPrice: {
      sq: "Çmimi i Importit",
      en: "Import Price",
    },
    quantity: {
      sq: "Sasia",
      en: "Quantity",
    },
    addProduct: {
      sq: "Shto Produkt",
      en: "Add Product",
    },
    productAdded: {
      sq: "Produkti u shtua me sukses",
      en: "Product added successfully",
    },
    errorAddingProduct: {
      sq: "Gabim në shtimin e produktit",
      en: "Error adding product",
    },
    missingData: {
      sq: "Të dhënat e munguara",
      en: "Missing Data",
    },
    pleaseAddBrands: {
      sq: "Ju lutem shtoni marka në panelin CMS",
      en: "Please add brands in CMS panel",
    },
    pleaseAddColors: {
      sq: "Ju lutem shtoni ngjyra në panelin CMS",
      en: "Please add colors in CMS panel",
    },
    pleaseAddTypes: {
      sq: "Ju lutem shtoni lloje në panelin CMS",
      en: "Please add types in CMS panel",
    },
    uploadPhoto: {
      sq: "Ngarko Foto",
      en: "Upload Photo",
    },
    codeRequired: {
      sq: "Kodi është i nevojshëm",
      en: "Code is required",
    },
    brandRequired: {
      sq: "Marka është e nevojshme",
      en: "Brand is required",
    },
    typeRequired: {
      sq: "Lloji është i nevojshëm",
      en: "Type is required",
    },
    colorRequired: {
      sq: "Ngjyra është e nevojshme",
      en: "Color is required",
    },
    nameRequired: {
      sq: "Emri është i nevojshëm",
      en: "Name is required",
    },
    stockPriceRequired: {
      sq: "Çmimi i magazinës duhet të jetë më i madh se 0",
      en: "Stock price must be greater than 0",
    },
    importPriceRequired: {
      sq: "Çmimi i importit duhet të jetë më i madh se 0",
      en: "Import price must be greater than 0",
    },
    quantityRequired: {
      sq: "Sasia duhet të jetë më e madhe se 0",
      en: "Quantity must be greater than 0",
    },
    sizesRequired: {
      sq: "Të paktën një madhësi me sasi më të madhe se 0 është e nevojshme",
      en: "At least one size with quantity greater than 0 is required",
    },
  },
  // CMS Panels
  cms: {
    title: {
      sq: "Paneli CMS",
      en: "CMS Panel",
    },
    brands: {
      sq: "Markat",
      en: "Brands",
    },
    colors: {
      sq: "Ngjyrat",
      en: "Colors",
    },
    numbers: {
      sq: "Numrat",
      en: "Numbers",
    },
    types: {
      sq: "Llojet",
      en: "Types",
    },
    locations: {
      sq: "Vendndodhjet",
      en: "Locations",
    },
    addNew: {
      sq: "Shto të Ri",
      en: "Add New",
    },
    itemAdded: {
      sq: "Një artikull i ri u shtua me sukses në",
      en: "A new item has been added to",
    },
    successfully: {
      sq: "me sukses",
      en: "successfully",
    },
    addFirstItem: {
      sq: "Shtoni artikullin tuaj të parë për të populluar këtë tabelë",
      en: "Add your first item to populate this table",
    },
    validationError: {
      sq: "Ju lutem plotësoni të gjitha fushat e kërkuara siç duhet",
      en: "Please fill in all required fields correctly",
    },
    errorSaving: {
      sq: "Gabim në ruajtjen e të dhënave",
      en: "Error saving data",
    },
    enterBrandName: {
      sq: "Shkruani Emrin e Markës",
      en: "Enter Brand Name",
    },
    enterManufacturingCountry: {
      sq: "Shkruani Emrin e Vendit të Prodhimit",
      en: "Enter Manufacturing Country name",
    },
    enterBasicColorName: {
      sq: "Shkruani Emrin Bazë të Ngjyrës",
      en: "Enter basic color name",
    },
    enterHexColor: {
      sq: "Shkruani kodin HEX (#RRGGBB)",
      en: "Enter HEX code (#RRGGBB)",
    },
    invalidHexColor: {
      sq: "Kodi HEX duhet të jetë në formatin #RRGGBB",
      en: "HEX code must be in #RRGGBB format",
    },
    enterAlbanianColorName: {
      sq: "Shkruani Emrin Shqip të Ngjyrës",
      en: "Enter albanian color name",
    },
    enterEnglishColorName: {
      sq: "Shkruani Emrin Anglisht të Ngjyrës",
      en: "Enter english color name",
    },
    enterTurkishName: {
      sq: "Shkruani Emrin Turqisht",
      en: "Enter turkish name",
    },
    enterNumber: {
      sq: "Shkruani Numrin",
      en: "Enter Number",
    },
    enterSpecificType: {
      sq: "Shkruani Llojin Specifik",
      en: "Enter Specific Type",
    },
    enterName: {
      sq: "Shkruani Emrin",
      en: "Enter Name",
    },
    fieldRequired: {
      sq: "{field} është i nevojshëm",
      en: "{field} is required",
    },
  },
  // Administration Panel
  administration: {
    title: {
      sq: "Administrimi",
      en: "Administration",
    },
    sales: {
      sq: "Shitjet",
      en: "Sales",
    },
    articles: {
      sq: "Artikujt",
      en: "Articles",
    },
    quantity: {
      sq: "Sasia",
      en: "Quantity",
    },
    addArticle: {
      sq: "Shto Artikull",
      en: "Add Article",
    },
    addQuantity: {
      sq: "Shto Sasi",
      en: "Add Quantity",
    },
    recordSale: {
      sq: "Regjistro Shitje",
      en: "Record Sale",
    },
    failedToLoad: {
      sq: "Dështoi ngarkimi i të dhënave. Ju lutem provoni përsëri",
      en: "Failed to load data. Please try again",
    },
    articleName: {
      sq: "Emri i Artikullit",
      en: "Article Name",
    },
    articleId: {
      sq: "ID e Artikullit",
      en: "Article ID",
    },
    sellingPrice: {
      sq: "Çmimi i Shitjes",
      en: "Selling Price",
    },
    saleDate: {
      sq: "Data e Shitjes",
      en: "Sale Date",
    },
    noSales: {
      sq: "Nuk ka shitje ende",
      en: "No sales yet",
    },
    noSalesHint: {
      sq: "Kur regjistroni shitjen tuaj të parë, ajo do të shfaqet këtu",
      en: "When you record your first sale, it will appear here",
    },
    noArticles: {
      sq: "Nuk ka artikuj ende",
      en: "No articles yet",
    },
    noArticlesHint: {
      sq: "Krijoni artikullin tuaj të parë për të populluar këtë tabelë",
      en: "Create your first article to populate this table",
    },
    noStock: {
      sq: "Nuk ka përditësime stoku ende",
      en: "No stock updates yet",
    },
    noStockHint: {
      sq: "Shtoni ose rregulloni sasitë për të filluar ndjekjen e stokut",
      en: "Add or adjust quantities to start tracking stock",
    },
    nothingToShow: {
      sq: "Nuk ka asgjë për të shfaqur",
      en: "Nothing to show yet",
    },
  },
  // Navbar
  navbar: {
    search: {
      sq: "Kërko",
      en: "Search",
    },
    notifications: {
      sq: "Njoftimet",
      en: "Notifications",
    },
    newOrder: {
      sq: "Porosi e re",
      en: "New order",
    },
    variantOutOfStock: {
      sq: "Varianti u harxhua",
      en: "Variant out of stock",
    },
    noNotifications: {
      sq: "Nuk keni njoftime.",
      en: "You have no notifications.",
    },
    noUnreadNotifications: {
      sq: "Nuk keni njoftime të palexuara.",
      en: "You have no unread notifications.",
    },
    notificationFilters: {
      sq: "Filtro njoftimet",
      en: "Filter notifications",
    },
    allNotifications: {
      sq: "Të gjitha",
      en: "All",
    },
    unreadNotifications: {
      sq: "Të palexuara",
      en: "Unread",
    },
    markAllRead: {
      sq: "Shëno të gjitha si të lexuara",
      en: "Mark all as read",
    },
    markingAllRead: {
      sq: "Duke i shënuar…",
      en: "Marking…",
    },
    markAllReadError: {
      sq: "Njoftimet nuk mund të shënoheshin si të lexuara.",
      en: "Notifications could not be marked as read.",
    },
    loadMore: {
      sq: "Ngarko më shumë",
      en: "Load more",
    },
    loadingMore: {
      sq: "Duke ngarkuar…",
      en: "Loading…",
    },
    loadMoreError: {
      sq: "Njoftimet e tjera nuk mund të ngarkoheshin.",
      en: "More notifications could not be loaded.",
    },
    notificationsLoading: {
      sq: "Duke ngarkuar njoftimet…",
      en: "Loading notifications…",
    },
    notificationsError: {
      sq: "Njoftimet nuk mund të ngarkoheshin.",
      en: "Notifications could not be loaded.",
    },
    notificationReadError: {
      sq: "Njoftimi nuk mund të shënohej si i lexuar.",
      en: "The notification could not be marked as read.",
    },
    unreadNotification: {
      sq: "I palexuar",
      en: "Unread",
    },
    refreshing: {
      sq: "Duke rifreskuar",
      en: "Refreshing",
    },
    profile: {
      sq: "Profili",
      en: "Profile",
    },
    settings: {
      sq: "Cilësimet",
      en: "Settings",
    },
    logOut: {
      sq: "Dil",
      en: "Log out",
    },
  },
  // Common messages
  messages: {
    failedToLoad: {
      sq: "Dështoi ngarkimi",
      en: "Failed to load",
    },
    pleaseTryAgain: {
      sq: "Ju lutem provoni përsëri",
      en: "Please try again",
    },
    retry: {
      sq: "Provoni Përsëri",
      en: "Retry",
    },
    noData: {
      sq: "Nuk ka të dhëna",
      en: "No data",
    },
  },
  // Client-facing pages
  client: {
    home: {
      sq: "Faqja Kryesore",
      en: "Home",
    },
    products: {
      sq: "Produktet",
      en: "Products",
    },
    about: {
      sq: "Rreth Nesh",
      en: "About",
    },
    contact: {
      sq: "Kontakt",
      en: "Contact",
    },
    login: {
      sq: "Hyr",
      en: "Login",
    },
    welcome: {
      sq: "Mirë se vini në Black & White",
      en: "Welcome to Black & White",
    },
    welcomeDescription: {
      sq: "Zbuloni koleksionin tonë premium të produkteve me cilësi të lartë",
      en: "Discover our premium collection of quality products",
    },
    browseProducts: {
      sq: "Shfletoni koleksionin tonë të mrekullueshëm të produkteve",
      en: "Browse our amazing collection of products",
    },
    learnMore: {
      sq: "Mëso më shumë",
      en: "Learn More",
    },
    getInTouch: {
      sq: "Lidhuni me ne për çdo pyetje",
      en: "Get in touch with us for any inquiries",
    },
    whyChooseUs: {
      sq: "Pse të na zgjidhni ne?",
      en: "Why Choose Us?",
    },
    fastDelivery: {
      sq: "Dërgesë e Shpejtë",
      en: "Fast Delivery",
    },
    fastDeliveryDesc: {
      sq: "Shërbim i shpejtë dhe i besueshëm dërgimi",
      en: "Quick and reliable delivery service",
    },
    quality: {
      sq: "Produkte me Cilësi",
      en: "Quality Products",
    },
    qualityDesc: {
      sq: "Vetëm produktet me cilësinë më të mirë",
      en: "Only the best quality products",
    },
    support: {
      sq: "Mbështetje 24/7",
      en: "24/7 Support",
    },
    supportDesc: {
      sq: "Jemi këtu për t'ju ndihmuar në çdo kohë",
      en: "We're here to help you anytime",
    },
    productsDescription: {
      sq: "Shfletoni koleksionin tonë të mrekullueshëm të produkteve.",
      en: "Browse through our amazing collection of products.",
    },
    aboutDescription: {
      sq: "Mësoni më shumë për kompaninë tonë, misionin dhe vlerat tona.",
      en: "Learn more about our company, mission, and values.",
    },
    contactDescription: {
      sq: "Lidhuni me ne për çdo pyetje ose mbështetje.",
      en: "Get in touch with us for any inquiries or support.",
    },
    featuredProducts: {
      sq: "Produktet e Rekomanduara",
      en: "Featured Products",
    },
    featuredProductsDesc: {
      sq: "Shikoni disa nga produktet tona më të mira",
      en: "Check out some of our best products",
    },
    noProducts: {
      sq: "Nuk ka produkte të disponueshme",
      en: "No products available",
    },
    viewAllProducts: {
      sq: "Shiko të Gjitha Produktet",
      en: "View All Products",
    },
    readyToShop: {
      sq: "Gati për të Blerë?",
      en: "Ready to Shop?",
    },
    readyToShopDesc: {
      sq: "Eksploroni koleksionin tonë të plotë të produkteve premium",
      en: "Explore our full collection of premium products",
    },
    shopNow: {
      sq: "Bli Tani",
      en: "Shop Now",
    },
    searchProducts: {
      sq: "Kërko produkte sipas kodit, markës ose ngjyrës...",
      en: "Search products by code, brand, or color...",
    },
    allBrands: {
      sq: "Të Gjitha Markat",
      en: "All Brands",
    },
    noProductsFound: {
      sq: "Nuk u gjetën produkte. Provoni të rregulloni filtrat tuaj.",
      en: "No products found. Try adjusting your filters.",
    },
    showingResults: {
      sq: "Duke shfaqur",
      en: "Showing",
    },
    of: {
      sq: "nga",
      en: "of",
    },
  },
  // Orders
  orders: {
    title: {
      sq: "Dërgesat",
      en: "Shipments",
    },
    createOrder: {
      sq: "Krijo Dërgesë",
      en: "Create Shipment",
    },
    createOrderHint: {
      sq: "Krijo një dërgesë ABEX pa e lidhur këtë rrjedhë me faqen aktive të shitjeve.",
      en: "Create an ABEX shipment without coupling it to the live sales workflow.",
    },
    abexHint: {
      sq: "Kjo faqe menaxhon dërgesat e korrierit veçmas nga rrjedha aktive e shitjeve.",
      en: "This screen manages courier shipments separately from the live sales workflow.",
    },
    pod: {
      sq: "POD",
      en: "POD",
    },
    recipientName: {
      sq: "Pranuesi",
      en: "Recipient",
    },
    city: {
      sq: "Qyteti",
      en: "City",
    },
    country: {
      sq: "Shteti",
      en: "Country",
    },
    address: {
      sq: "Adresa",
      en: "Address",
    },
    phone: {
      sq: "Telefoni",
      en: "Phone",
    },
    pieces: {
      sq: "Copë",
      en: "Pieces",
    },
    weight: {
      sq: "Pesha (kg)",
      en: "Weight (kg)",
    },
    value: {
      sq: "Vlera (€)",
      en: "Value (€)",
    },
    status: {
      sq: "Statusi",
      en: "Status",
    },
    referenceCode: {
      sq: "Kodi Referues",
      en: "Reference Code",
    },
    createdAt: {
      sq: "Krijuar më",
      en: "Created At",
    },
    filterByPOD: {
      sq: "Filtro sipas POD...",
      en: "Filter by POD...",
    },
    allStatuses: {
      sq: "Të gjitha statuset",
      en: "All statuses",
    },
    paymentType: {
      sq: "Lloji i Pagesës",
      en: "Payment Type",
    },
    bank: {
      sq: "Banka",
      en: "Bank",
    },
    comments: {
      sq: "Komente",
      en: "Comments",
    },
    shipmentDetails: {
      sq: "Detajet e Dërgesës",
      en: "Shipment Details",
    },
    viewShipment: {
      sq: "Shiko Dërgesën",
      en: "View Shipment",
    },
    currentStatus: {
      sq: "Statusi Aktual",
      en: "Current Status",
    },
    statusHint: {
      sq: "Statusi dhe historiku merren live nga ABEX për këtë POD.",
      en: "Status and history are fetched live from ABEX for this POD.",
    },
    trackingHistory: {
      sq: "Historiku i Gjurmimit",
      en: "Tracking History",
    },
    noTrackingHistory: {
      sq: "Ende nuk ka histori gjurmimi.",
      en: "No tracking history is available yet.",
    },
    addComment: {
      sq: "Shto Koment",
      en: "Add Comment",
    },
    commentHint: {
      sq: "Shto një shënim operacional për korrierin ose pranuesin.",
      en: "Add an operational note for the courier or recipient.",
    },
    submitComment: {
      sq: "Dërgo Komentin",
      en: "Submit Comment",
    },
    commentAdded: {
      sq: "Komenti i dërgesës u shtua me sukses",
      en: "Shipment comment added successfully",
    },
    products: {
      sq: "Produktet",
      en: "Products",
    },
    searchProducts: {
      sq: "Kërko produkte...",
      en: "Search products...",
    },
    selectedProducts: {
      sq: "Produktet e Zgjedhura",
      en: "Selected Products",
    },
    total: {
      sq: "Totali",
      en: "Total",
    },
    price: {
      sq: "Çmimi",
      en: "Price",
    },
    selectBank: {
      sq: "Zgjidh Bankën",
      en: "Select Bank",
    },
    recipientNameRequired: {
      sq: "Emri i pranuesit është i detyrueshëm",
      en: "Recipient name is required",
    },
    cityRequired: {
      sq: "Qyteti është i detyrueshëm",
      en: "City is required",
    },
    addressRequired: {
      sq: "Adresa është e detyrueshme",
      en: "Address is required",
    },
    phoneRequired: {
      sq: "Telefoni është i detyrueshëm",
      en: "Phone is required",
    },
    productsRequired: {
      sq: "Duhet të zgjidhni të paktën një produkt",
      en: "At least one product is required",
    },
    validationError: {
      sq: "Ju lutem plotësoni të gjitha fushat e detyrueshme",
      en: "Please fill in all required fields",
    },
    orderCreated: {
      sq: "Porosia u krijua me sukses!",
      en: "Order created successfully!",
    },
    orderCreatedSuccess: {
      sq: "Porosia u krijua me sukses! POD: {pod}",
      en: "Order created successfully! POD: {pod}",
    },
    errorCreatingOrder: {
      sq: "Gabim në krijimin e porosisë",
      en: "Error creating order",
    },
    noProductsFound: {
      sq: "Nuk u gjetën produkte",
      en: "No products found",
    },
    failedToLoad: {
      sq: "Ngarkimi i dërgesave dështoi",
      en: "Failed to load shipments",
    },
    noOrders: {
      sq: "Nuk u gjet asnjë dërgesë",
      en: "No shipments found",
    },
    tryDifferentFilters: {
      sq: "Provo filtra të tjerë",
      en: "Try different filters",
    },
    createFirstOrder: {
      sq: "Krijo dërgesën tënde të parë",
      en: "Create your first shipment",
    },
    showing: {
      sq: "Duke shfaqur",
      en: "Showing",
    },
    of: {
      sq: "nga",
      en: "of",
    },
    orders: {
      sq: "dërgesa",
      en: "shipments",
    },
    recipientInformation: {
      sq: "Informacioni i Pranuesit",
      en: "Recipient Information",
    },
    orderDetails: {
      sq: "Detajet e Porosisë",
      en: "Order Details",
    },
    finalValue: {
      sq: "Vlera Finale",
      en: "Final Value",
    },
    bankRequired: {
      sq: "Banka është e detyrueshme",
      en: "Bank is required",
    },
    editPrice: {
      sq: "Ndrysho Çmimin",
      en: "Edit Price",
    },
    selectCity: {
      sq: "Zgjidh Qytetin",
      en: "Select City",
    },
    searchCity: {
      sq: "Kërko ose zgjidh qytet...",
      en: "Search or select city...",
    },
    scrollForMore: {
      sq: "Scroll për më shumë...",
      en: "Scroll for more...",
    },
    countryRequired: {
      sq: "Shteti është i detyrueshëm",
      en: "Country is required",
    },
  },
  commerceCommon: {
    location: { sq: "Lokacioni", en: "Location" },
    chooseLocation: { sq: "Zgjidh lokacionin", en: "Choose location" },
    allLocations: { sq: "Të gjitha lokacionet", en: "All locations" },
    locationFallback: { sq: "Lokacioni {id}", en: "Location {id}" },
    item: { sq: "artikull", en: "item" },
    items: { sq: "artikuj", en: "items" },
    itemHeader: { sq: "Artikulli", en: "Item" },
    qty: { sq: "Sasia", en: "Qty" },
    price: { sq: "Çmimi", en: "Price" },
    total: { sq: "Totali", en: "Total" },
    actions: { sq: "Veprimet", en: "Actions" },
    payment: { sq: "Pagesa", en: "Payment" },
    date: { sq: "Data", en: "Date" },
    number: { sq: "Numri", en: "Number" },
    time: { sq: "Ora", en: "Time" },
    method: { sq: "Metoda", en: "Method" },
    subtotal: { sq: "Nëntotali", en: "Subtotal" },
    discount: { sq: "Zbritja", en: "Discount" },
    refund: { sq: "Rimbursimi", en: "Refund" },
    scan: { sq: "Skano", en: "Scan" },
    scanning: { sq: "Duke skanuar…", en: "Scanning…" },
    search: { sq: "Kërko", en: "Search" },
    searching: { sq: "Duke kërkuar…", en: "Searching…" },
    add: { sq: "Shto", en: "Add" },
    apply: { sq: "Apliko", en: "Apply" },
    edit: { sq: "Ndrysho", en: "Edit" },
    clear: { sq: "Pastro", en: "Clear" },
    close: { sq: "Mbyll", en: "Close" },
    optional: { sq: "Opsionale", en: "Optional" },
    bankProvider: { sq: "Banka / ofruesi", en: "Bank / provider" },
    chooseLocationFirst: {
      sq: "Zgjidh lokacionin së pari",
      en: "Choose location first",
    },
    selectedLocation: { sq: "lokacioni i zgjedhur", en: "selected location" },
    scanInto: { sq: "Skano në {location}", en: "Scan into {location}" },
    typeToFilter: { sq: "Shkruaj për të filtruar…", en: "Type to filter…" },
    loading: { sq: "Duke u ngarkuar…", en: "Loading…" },
    preparing: { sq: "Duke përgatitur…", en: "Preparing…" },
    completing: { sq: "Duke përfunduar…", en: "Completing…" },
    lookingUp: { sq: "Duke kërkuar…", en: "Looking up…" },
    resultsCount: { sq: "{count} rezultate", en: "{count} results" },
    printReceipt: { sq: "Printo faturën", en: "Print receipt" },
    saleNumber: { sq: "Numri i shitjes", en: "Sale number" },
    returnNumber: { sq: "Numri i kthimit", en: "Return number" },
    exchangeNumber: { sq: "Numri i këmbimit", en: "Exchange number" },
    orderNumber: { sq: "Numri i porosisë", en: "Order number" },
    notSelected: { sq: "Nuk është zgjedhur", en: "Not selected" },
    wasPrice: { sq: "Ishte {amount}", en: "Was {amount}" },
    discountLine: { sq: "−{amount} zbritje", en: "−{amount} discount" },
    paymentCash: { sq: "Para", en: "Cash" },
    paymentCard: { sq: "Kartë", en: "Card" },
    paymentBankTransfer: { sq: "Transfer bankar", en: "Bank transfer" },
    scanLabel: { sq: "Skano etiketën", en: "Scan label" },
    optionColorLabel: { sq: "Ngjyra: {value}", en: "Color: {value}" },
    optionSizeLabel: { sq: "Nr. {value}", en: "Size: {value}" },
    availCount: { sq: " · {count} në dispozicion", en: " · {count} avail." },
    itemAddedToBasket: {
      sq: "{name} u shtua në shportë.",
      en: "{name} added to the basket.",
    },
    itemFallback: { sq: "Artikulli", en: "Item" },
    exchangeFallback: { sq: "këmbim", en: "exchange" },
    all: { sq: "Të gjitha", en: "All" },
    status: { sq: "Statusi", en: "Status" },
    source: { sq: "Burimi", en: "Source" },
    summary: { sq: "Përmbledhja", en: "Summary" },
    create: { sq: "Krijo", en: "Create" },
    save: { sq: "Ruaj", en: "Save" },
    unknownLocation: { sq: "Lokacion i panjohur", en: "Unknown location" },
    even: { sq: "Barazim", en: "Even" },
    balance: { sq: "Bilanci", en: "Balance" },
    collectAmount: { sq: "Mblidh {amount}", en: "Collect {amount}" },
    refundAmount: { sq: "Rimburso {amount}", en: "Refund {amount}" },
    evenExchange: { sq: "Këmbim i barabartë", en: "Even exchange" },
    openLinkedSale: { sq: "Hap shitjen e lidhur", en: "Open linked sale" },
    fromSale: { sq: "Nga shitja", en: "From sale" },
    originalSale: { sq: "Shitja origjinale", en: "Original sale" },
    originalTotal: { sq: "Totali origjinal", en: "Original total" },
    totalRefunded: { sq: "Totali i rimbursuar", en: "Total refunded" },
    returnable: { sq: "I kthyeshëm", en: "Returnable" },
    availableCount: { sq: "{count} në dispozicion", en: "{count} available" },
    alreadyReturnedCount: {
      sq: "{count} tashmë të kthyer",
      en: "{count} already returned",
    },
    selectedCount: { sq: "{count} të zgjedhur", en: "{count} selected" },
    useBarcodeLookup: {
      sq: "Përdor kërkim me barkod",
      en: "Use barcode lookup",
    },
    scanSoldLabelHint: {
      sq: "Skano etiketën e artikullit të shitur për ta kthyer në mënyrë të sigurt.",
      en: "Scan the sold item label to return this item safely.",
    },
    newReturn: { sq: "Kthim i ri", en: "New return" },
    newExchange: { sq: "Këmbim i ri", en: "New exchange" },
    newSale: { sq: "Shitje e re", en: "New sale" },
    clearBasket: { sq: "Pastro shportën", en: "Clear basket" },
    clearLookup: { sq: "Pastro kërkimin", en: "Clear lookup" },
    startReturn: { sq: "Fillo kthimin", en: "Start return" },
    viewPrintRefundSlip: {
      sq: "Shiko / printo fletë rimbursimi",
      en: "View / Print refund slip",
    },
    saleDetail: { sq: "Detajet e shitjes", en: "Sale detail" },
    returnDetail: { sq: "Detajet e kthimit", en: "Return detail" },
    exchangeDetail: { sq: "Detajet e këmbimit", en: "Exchange detail" },
    orderDetail: { sq: "Detajet e porosisë", en: "Order detail" },
    selectRowHint: {
      sq: "Zgjidh një rresht nga lista për të parë detajet këtu.",
      en: "Choose a row in the list to load full detail here.",
    },
    selectOrder: { sq: "Zgjidh një porosi", en: "Select an order" },
    showingOf: {
      sq: "Duke shfaqur {shown} nga {total}",
      en: "Showing {shown} of {total}",
    },
    notNeeded: { sq: "nuk nevojitet", en: "not needed" },
    returnedLabel: { sq: "Kthyer {number}", en: "Returned {number}" },
    replacementLabel: { sq: "Zëvendësim {number}", en: "Replacement {number}" },
    returnReplacement: { sq: "Kthim → zëvendësim", en: "Return → replacement" },
    noReturnedLines: {
      sq: "Nuk ka rreshta artikujsh të kthyer në këtë lexim.",
      en: "No returned item lines are available in this readback.",
    },
    noReplacementLines: {
      sq: "Nuk ka rreshta artikujsh zëvendësues në këtë lexim.",
      en: "No replacement item lines are available in this readback.",
    },
    settlement: { sq: "Barazimi", en: "Settlement" },
    netBalance: { sq: "Bilanci neto", en: "Net balance" },
    returnedItems: { sq: "Artikujt e kthyer", en: "Returned items" },
    replacementItems: { sq: "Artikujt zëvendësues", en: "Replacement items" },
    replacementSide: { sq: "Ana e zëvendësimit", en: "Replacement side" },
    returnSide: { sq: "Ana e kthimit", en: "Return side" },
    loadReturnedFirst: {
      sq: "Ngarko artikullin e kthyer së pari.",
      en: "Load the returned item first.",
    },
    scanReplacementAfterReturn: {
      sq: "Skano artikullin zëvendësues pasi të zgjedhësh anën e kthimit.",
      en: "Scan the replacement item after choosing the return side.",
    },
    noPaymentNeeded: {
      sq: "Nuk nevojitet pagesë apo rimbursim për këtë këmbim.",
      en: "No payment or refund is needed for this exchange.",
    },
    itemCount: { sq: "{count} artikuj", en: "{count} items" },
    quantityItems: { sq: "{count} artikull", en: "{count} item" },
    quantityItemsPlural: { sq: "{count} artikuj", en: "{count} items" },
  },
  storeSales: {
    title: { sq: "Shitje në dyqan", en: "Store sale" },
    titleCompleted: { sq: "Shitja u përfundua", en: "Sale completed" },
    subtitle: {
      sq: "Skano, kërko dhe përfundo transaksionet",
      en: "Scan, search, and complete transactions",
    },
    subtitleCompleted: {
      sq: "{saleNumber} u ruajt me sukses",
      en: "{saleNumber} saved successfully",
    },
    scanBarcode: { sq: "Skano barkodin", en: "Scan barcode" },
    hideSearch: { sq: "Fshih kërkimin ▴", en: "Hide search ▴" },
    showSearch: {
      sq: "Nuk skanon? Kërko manualisht ▾",
      en: "Can't scan? Search manually ▾",
    },
    searchPlaceholder: {
      sq: "Emri, SKU ose barkodi",
      en: "Name, SKU, or barcode",
    },
    basketLabel: {
      sq: "Shporta · {count} {unit}",
      en: "Basket · {count} {unit}",
    },
    completeSale: { sq: "Përfundo shitjen", en: "Complete sale" },
    createOrderFromBasket: { sq: "Krijo porosi", en: "Create order" },
    readyToSell: { sq: "Gati për shitje", en: "Ready to sell" },
    emptyBasketDesc: {
      sq: "Zgjidh një lokacion, pastaj skano artikullin e parë ose kërkoje manualisht.",
      en: "Choose a location, then scan the first item or search for it manually.",
    },
    chooseLocationBeforeScan: {
      sq: "Zgjidh një lokacion para se të skanosh.",
      en: "Choose a location before scanning.",
    },
    chooseLocationBeforeSearch: {
      sq: "Zgjidh një lokacion para se të kërkosh.",
      en: "Choose a location before searching.",
    },
    barcodeNotSold: {
      sq: "Ky barkod nuk mund të shitet.",
      en: "This barcode could not be sold.",
    },
    scanProcessError: {
      sq: "Nuk mund të përpunohet skanimi për momentin.",
      en: "Unable to process that scan right now.",
    },
    noSellableItem: {
      sq: "Nuk u gjet asnjë artikull i shitshëm.",
      en: "No matching sellable item was found.",
    },
    searchResultsSummary: {
      sq: "Duke shfaqur {shown} nga {total} rezultate",
      en: "Showing {shown} of {total} results",
    },
    loadMoreSearchResults: {
      sq: "Ngarko më shumë",
      en: "Load more",
    },
    searchError: {
      sq: "Nuk mund të kërkohen artikujt për momentin.",
      en: "Unable to search items right now.",
    },
    cannotAddManually: {
      sq: "Ky artikull nuk mund të shtohet manualisht.",
      en: "This item cannot be added manually.",
    },
    outOfStockAtLocation: {
      sq: "Ky artikull nuk ka stok në lokacionin e zgjedhur.",
      en: "This item is out of stock at the selected location.",
    },
    invalidUnitPrice: {
      sq: "Shkruaj një çmim unitar të vlefshëm.",
      en: "Enter a valid final unit price.",
    },
    negativeUnitPrice: {
      sq: "Çmimi unitar nuk mund të jetë negativ.",
      en: "Final unit price cannot be negative.",
    },
    priceExceedsOriginal: {
      sq: "Çmimi unitar nuk mund të tejkalojë çmimin origjinal në këtë fazë.",
      en: "Final unit price cannot exceed the original price in this wave.",
    },
    chooseLocationBeforeComplete: {
      sq: "Zgjidh një lokacion para se të përfundosh shitjen.",
      en: "Choose a location before completing the sale.",
    },
    addItemBeforeComplete: {
      sq: "Shto të paktën një artikull para se të përfundosh shitjen.",
      en: "Add at least one item before completing the sale.",
    },
    completeSaleError: {
      sq: "Nuk mund të përfundohet shitja.",
      en: "Unable to complete the sale.",
    },
    itemsUnavailable: {
      sq: "Një ose më shumë artikuj nuk janë më në dispozicion. Rifresko shportën dhe provo përsëri.",
      en: "One or more items are no longer available. Refresh the basket and try again.",
    },
    scanModeTab: { sq: "Skano produktin", en: "Scan item" },
    searchModeTab: { sq: "Kërko manualisht", en: "Search manually" },
    scanHint: {
      sq: "Skano ose shkruaj barkodin. Produkti shtohet automatikisht në shportë.",
      en: "Scan or type the barcode. The item is added to the basket automatically.",
    },
    cartTitle: { sq: "Shporta e shitjes", en: "Sale basket" },
    saleSummaryTitle: { sq: "Totali i shitjes", en: "Sale total" },
    removeItem: { sq: "Hiq artikullin", en: "Remove item" },
    editPrice: { sq: "Ndrysho çmimin", en: "Edit price" },
    increaseQty: { sq: "Shto sasinë", en: "Increase quantity" },
    decreaseQty: { sq: "Zvogëlo sasinë", en: "Decrease quantity" },
    serializedQtyHint: {
      sq: "Skano një njësi tjetër për të shtuar sasinë.",
      en: "Scan another unit to increase the quantity.",
    },
    saleCompletedTitle: {
      sq: "Shitja u krye me sukses!",
      en: "Sale completed successfully!",
    },
    saleCompletedSubtitle: {
      sq: "Shitja u regjistrua me sukses.",
      en: "The sale was recorded successfully.",
    },
    totalPaid: { sq: "Totali i paguar", en: "Total paid" },
    soldItems: { sq: "Artikujt e shitjes", en: "Sale items" },
    dateAndTime: { sq: "Data & Ora", en: "Date & time" },
    newSaleHint: {
      sq: "Fillo një transaksion të ri",
      en: "Start a new transaction",
    },
    printReceiptHint: {
      sq: "Shkarko ose printo këtë faturë",
      en: "Download or print this receipt",
    },
    addToBasket: { sq: "Shto në shportë", en: "Add to basket" },
    allInBasket: { sq: "Të gjitha në shportë", en: "All in basket" },
    maxStockReached: {
      sq: "Ke arritur stokun maksimal — {count} copë në stok.",
      en: "Maximum stock reached — {count} in stock.",
    },
    maxStockShort: { sq: "Maks. {count} në stok", en: "Max {count} in stock" },
    overStockShort: { sq: "Vetëm {count} në stok", en: "Only {count} in stock" },
    checkingStock: { sq: "Duke kontrolluar stokun…", en: "Checking stock…" },
    retryStockCheck: { sq: "Kontrollo përsëri", en: "Check again" },
    stockUnresolved: {
      sq: "Stoku për këtë lokacion ende nuk është kontrolluar.",
      en: "Stock for this location has not been checked yet.",
    },
    stockUnresolvedShort: {
      sq: "Stoku i pakontrolluar",
      en: "Stock not checked",
    },
    stockRevalidationError: {
      sq: "Nuk mund të kontrollohet stoku për këtë lokacion.",
      en: "Unable to check stock for this location.",
    },
    stockBelowBasket: {
      sq: "Në këtë lokacion ka më pak stok se sasia në shportë. Zvogëlo sasinë para se ta përfundosh shitjen.",
      en: "This location has less stock than the basket quantity. Reduce the quantity before completing the sale.",
    },
    outOfStock: { sq: "Pa stok", en: "Out of stock" },
    outOfStockShort: { sq: "Pa stok", en: "No stock" },
    inStockCount: { sq: "Në stok: {count}", en: "In stock: {count}" },
    doubleClickToAdd: {
      sq: "Kliko dy herë mbi produktin për ta shtuar",
      en: "Double-click the product to add it",
    },
    atLocation: { sq: "në {location}", en: "at {location}" },
    searchHint: {
      sq: "Shkruaj emrin, SKU-në ose barkodin, pastaj shtyp Enter.",
      en: "Type the name, SKU, or barcode, then press Enter.",
    },
    searchFoundCount: {
      sq: "U gjetën {count} produkte për “{query}”",
      en: "Found {count} products for “{query}”",
    },
    scanNotFound: {
      sq: "Nuk u gjet asnjë produkt i shitshëm për këtë barkod.",
      en: "No sellable product was found for this barcode.",
    },
    scanNotFoundHint: {
      sq: "Kontrollo barkodin ose provo me kërkim manual.",
      en: "Check the barcode or try a manual search.",
    },
    scanAmbiguous: {
      sq: "Ky barkod i përket edhe një produkti edhe një njësie me numër serik. Rregullo konfliktin e barkodit para se ta shesësh.",
      en: "This barcode matches both a product label and a serialized unit. Resolve the conflict before selling it.",
    },
    blockedDuplicateUnit: {
      sq: "Ky artikull është tashmë në shportë.",
      en: "This item is already in the basket.",
    },
    blockedNotSellable: {
      sq: "Ky artikull nuk mund të shitet për momentin.",
      en: "This item is not sellable right now.",
    },
    blockedWrongLocation: {
      sq: "Ky artikull nuk gjendet në lokacionin e zgjedhur.",
      en: "This item is not available at the selected location.",
    },
    blockedUnitUnavailable: {
      sq: "Ky artikull nuk është më i disponueshëm për shitje.",
      en: "This item is no longer available to sell.",
    },
    blockedMissingPrice: {
      sq: "Ky artikull nuk ka çmim të vendosur.",
      en: "This item has no sale price configured.",
    },
    blockedScanUnitLabel: {
      sq: "Skano etiketën e artikullit — ky produkt ka numër serik.",
      en: "Scan the item label — this product is serialized.",
    },
  },
  recentSales: {
    title: { sq: "Shitjet e fundit", en: "Recent sales" },
    subtitle: {
      sq: "Shfleto dhe rishiko transaksionet e përfunduara",
      en: "Browse and review completed transactions",
    },
    printDayInvoice: { sq: "Printo faturën ditore", en: "Print day invoice" },
    loadError: {
      sq: "Nuk mund të ngarkohet historiku i shitjeve.",
      en: "Unable to load sales history.",
    },
    detailLoadError: {
      sq: "Nuk mund të ngarkohen detajet e shitjes.",
      en: "Unable to load sale detail.",
    },
    noSalesFound: {
      sq: "Nuk u gjetën shitje për këtë ditë.",
      en: "No sales found for this day.",
    },
    searchPlaceholder: {
      sq: "Kërko numrin e shitjes…",
      en: "Search by sale number…",
    },
    clearFilters: { sq: "Pastro filtrat", en: "Clear filters" },
    salesCountLabel: { sq: "Shitje gjithsej", en: "Total sales" },
    totalValueLabel: { sq: "Vlera totale", en: "Total value" },
    averageLabel: { sq: "Mesatarja për shitje", en: "Average per sale" },
    netValueLabel: { sq: "Vlera neto", en: "Net value" },
    netValueReturnedHint: {
      sq: "−{amount} të kthyera",
      en: "−{amount} returned",
    },
    returnedBadge: { sq: "U kthye", en: "Returned" },
    partiallyReturnedBadge: {
      sq: "U kthye {returned} nga {quantity}",
      en: "Returned {returned} of {quantity}",
    },
    saleHasReturnBadge: { sq: "Ka kthim", en: "Has return" },
    returnedAmountLabel: { sq: "Të kthyera", en: "Returned" },
    netTotalLabel: { sq: "Totali neto", en: "Net total" },
    saleStatusCompleted: {
      sq: "Shitja është përfunduar me sukses.",
      en: "The sale was completed successfully.",
    },
    saleStatusVoided: {
      sq: "Kjo shitje është anuluar.",
      en: "This sale has been voided.",
    },
    startReturnHint: {
      sq: "Krijo një kthim për këtë shitje",
      en: "Create a return for this sale",
    },
    printReceiptHint: {
      sq: "Shkarko ose printo faturën e kësaj shitjeje",
      en: "Download or print this sale's receipt",
    },
    // "lineCount" from the sales list is a count of distinct sale lines
    // (products), not total units sold — the list payload only loads the
    // first two lines' quantities, so a units-sold total can't be computed
    // accurately here. Label it as products, not items/units.
    productCount: { sq: "{count} produkt", en: "{count} product" },
    productCountPlural: { sq: "{count} produkte", en: "{count} products" },
    productsColumnHeader: { sq: "Produktet", en: "Products" },
  },
  storeReturn: {
    title: { sq: "Kthim në dyqan", en: "Store return" },
    titleCompleted: { sq: "Kthimi u përfundua", en: "Return completed" },
    subtitle: {
      sq: "Kërko sipas numrit të shitjes, emrit të produktit, SKU ose barkodit, pastaj konfirmo kthimin.",
      en: "Search by sale number, product name, SKU, or barcode, then confirm the return.",
    },
    returnLocation: { sq: "Lokacioni i kthimit", en: "Return location" },
    lookupPlaceholder: {
      sq: "Numri i shitjes ose barkodi i artikullit",
      en: "Sale number or sold item barcode",
    },
    findSale: { sq: "Gjej shitjen", en: "Find sale" },
    returnableItems: { sq: "Artikuj të kthyeshëm", en: "Returnable items" },
    readyToLookup: { sq: "Gati për kërkim", en: "Ready to look up" },
    returnSaved: {
      sq: "Kthimi {returnNumber} u ruajt me sukses.",
      en: "Return {returnNumber} was saved successfully.",
    },
    saleLoaded: {
      sq: "Shitja {saleNumber} është ngarkuar. Zgjidh sasitë ose njësitë për t’i kthyer.",
      en: "Sale {saleNumber} is loaded. Choose quantities or units to return.",
    },
    lookupHint: {
      sq: "Përdor numrin e shitjes për artikuj agregat, ose skano etiketën për artikuj të serializuar.",
      en: "Use a sale number for aggregate items, or scan the sold item label for serialized ones.",
    },
    completeReturn: { sq: "Përfundo kthimin", en: "Complete return" },
    refundTotal: { sq: "Totali i rimbursimit", en: "Refund total" },
    saleLoadedForReturn: {
      sq: "Artikuj të kthyeshëm u ngarkuan për shitjen {saleNumber}.",
      en: "Returnable items loaded for sale {saleNumber}.",
    },
    nothingReturnable: {
      sq: "Nuk u gjet asgjë e kthyeshme.",
      en: "Nothing returnable was found.",
    },
    lookupLoadError: {
      sq: "Nuk mund të ngarkohen artikujt e kthyeshëm për momentin.",
      en: "Unable to load returnable items right now.",
    },
    saleNotFound: {
      sq: "Nuk u gjet shitje ose artikull i shitur në kompaninë tuaj.",
      en: "No matching sale or sold item was found in your company scope.",
    },
    chooseLocationBeforeReturn: {
      sq: "Zgjidh lokacionin e kthimit para se të përfundosh.",
      en: "Choose a return location before completing the return.",
    },
    findSaleBeforeReturn: {
      sq: "Gjej shitjen origjinale para se të përfundosh kthimin.",
      en: "Find the original sale before completing the return.",
    },
    chooseReturnableFirst: {
      sq: "Zgjidh të paktën një sasi të kthyeshme ose skano etiketën e artikullit së pari.",
      en: "Choose at least one returnable quantity or scan the sold item label first.",
    },
    completeReturnError: {
      sq: "Nuk mund të përfundohet kthimi.",
      en: "Unable to complete the return.",
    },
    saleNotFoundOnComplete: {
      sq: "Shitja origjinale ose një nga artikujt nuk u gjetën më.",
      en: "The original sale or one of its items could no longer be found.",
    },
    itemsNoLongerReturnable: {
      sq: "Një ose më shumë artikuj nuk janë më të kthyeshëm. Ngarko shitjen përsëri dhe provo.",
      en: "One or more items are no longer returnable. Load the sale again and try once more.",
    },
    aggregateOrScanHint: {
      sq: "Kërko shitjen me numrin e shitjes, emrin e produktit, SKU ose barkodin.",
      en: "Search for the sale using the sale number, product name, SKU, or barcode.",
    },
    uniqueLabelHint: {
      sq: "Për artikuj me etiketë unike, skano etiketën e produktit.",
      en: "For items with a unique label, scan the product's label.",
    },
    saleLookupLabel: {
      sq: "Gjej shitjen",
      en: "Find sale",
    },
    saleLookupPlaceholder: {
      sq: "Numri i shitjes, emri i produktit, SKU ose barkodi",
      en: "Sale number, product name, SKU, or barcode",
    },
    saleSearchResults: {
      sq: "{count} shitje për “{query}”",
      en: "{count} sales for “{query}”",
    },
    saleSearchReturnable: {
      sq: "Të kthyeshme: {count}",
      en: "Returnable: {count}",
    },
    chooseSaleFromSearch: {
      sq: "Zgjidh shitjen e saktë nga rezultatet e kërkimit.",
      en: "Choose the correct sale from the search results.",
    },
    noMatchingSales: {
      sq: "Nuk u gjetën shitje që përputhen me këtë kërkim.",
      en: "No matching sales were found for this search.",
    },
    saleSearchError: {
      sq: "Nuk mund të kërkohen shitjet për momentin.",
      en: "Unable to search sales right now.",
    },
    itemScanLabel: {
      sq: "Skano artikullin për kthim",
      en: "Scan item to return",
    },
    itemScanPlaceholder: {
      sq: "Barkodi i variantit, SKU ose etiketa e artikullit të shitur",
      en: "Variant barcode, SKU, or sold item label",
    },
    soldQty: {
      sq: "Shitur",
      en: "Sold",
    },
    returnedQty: {
      sq: "Kthyer",
      en: "Returned",
    },
    selectedQty: {
      sq: "Zgjedhur",
      en: "Selected",
    },
    selectedItems: {
      sq: "Artikujt e zgjedhur",
      en: "Selected items",
    },
    itemMatchedForReturn: {
      sq: "{name} u përputh për kthim.",
      en: "{name} matched for return.",
    },
    itemAlreadySelected: {
      sq: "Ky artikull është zgjedhur tashmë.",
      en: "This item is already selected.",
    },
    noReturnableQuantityLeft: {
      sq: "Nuk ka më sasi të kthyeshme për këtë artikull.",
      en: "No returnable quantity remains for this item.",
    },
    barcodeNotReturnable: {
      sq: "Ky barkod nuk është i kthyeshëm për shitjen e zgjedhur.",
      en: "This barcode is not returnable for the selected sale.",
    },
    barcodeLookupError: {
      sq: "Nuk mund të përpunohet barkodi për momentin.",
      en: "Unable to process the barcode right now.",
    },
    barcodeMatchFailed: {
      sq: "Barkodi u gjet, por artikulli nuk mund të zgjidhej.",
      en: "The barcode matched, but the item could not be selected.",
    },
    stepFindSale: { sq: "Gjej shitjen", en: "Find sale" },
    stepSelectItems: { sq: "Zgjidh artikujt", en: "Select items" },
    stepRefund: { sq: "Rimbursimi", en: "Refund" },
    canReturnCount: {
      sq: "Mund të kthesh: {count} copë",
      en: "You can return: {count}",
    },
    returnableUnitsShort: {
      sq: "{count} copë e kthyeshme",
      en: "{count} returnable",
    },
    saleFullyReturned: { sq: "Nuk ka më për kthim", en: "Nothing left to return" },
    clearLineSelection: { sq: "Hiq nga kthimi", en: "Remove from return" },
    refundMethodLabel: { sq: "Mënyra e rimbursimit", en: "Refund method" },
    refundSummaryTitle: { sq: "Përmbledhja e kthimit", en: "Return summary" },
    returnCompletedTitle: {
      sq: "Kthimi u krye me sukses!",
      en: "Return completed successfully!",
    },
    returnedItemsTitle: { sq: "Artikujt e kthyer", en: "Returned items" },
    newReturnHint: { sq: "Fillo një kthim tjetër", en: "Start another return" },
    printSlipHint: {
      sq: "Shkarko ose printo fletën e rimbursimit",
      en: "Download or print the refund slip",
    },
  },
  recentReturns: {
    title: { sq: "Kthimet e fundit", en: "Recent returns" },
    subtitle: {
      sq: "Sot si parazgjedhje; ndrysho ditën ose filtro sipas numrit të kthimit kur të duhet.",
      en: "Today by default; change the day or filter by return number when you need to look something up.",
    },
    loadError: {
      sq: "Nuk mund të ngarkohet historiku i kthimeve.",
      en: "Unable to load returns history right now.",
    },
    detailLoadError: {
      sq: "Nuk mund të ngarkohen detajet e këtij kthimi.",
      en: "Unable to load that return detail right now.",
    },
    noReturnsFound: {
      sq: "Nuk u gjetën kthime për këtë ditë. Provo një datë tjetër ose pastro filtrin e numrit.",
      en: "No returns were found for this day. Try another date or clear the number filter.",
    },
  },
  storeExchange: {
    title: { sq: "Këmbim në dyqan", en: "Store exchange" },
    titleCompleted: { sq: "Këmbimi u përfundua", en: "Exchange completed" },
    subtitle: {
      sq: "Kërko shitjen origjinale sipas numrit, emrit të produktit, SKU ose barkodit, pastaj skano zëvendësimin dhe përfundo.",
      en: "Search the original sale by number, product name, SKU, or barcode, then scan the replacement and finish.",
    },
    stepReturn: { sq: "1. Ana e kthimit", en: "1. Return side" },
    stepReplacement: { sq: "2. Ana e zëvendësimit", en: "2. Replacement side" },
    stepSettlement: { sq: "3. Barazimi", en: "3. Settlement" },
    loadReturnSide: { sq: "Ngarko anën e kthimit", en: "Load return side" },
    scanReplacementBarcode: {
      sq: "Skano barkodin e zëvendësimit",
      en: "Scan replacement barcode",
    },
    scanReplacementItem: {
      sq: "Skano artikullin zëvendësues",
      en: "Scan the replacement item",
    },
    chooseReturnedFirst: {
      sq: "Zgjidh artikullin e kthyer së pari",
      en: "Choose the returned item first",
    },
    addReplacement: { sq: "Shto zëvendësimin", en: "Add replacement" },
    exchangeSummary: { sq: "Përmbledhja e këmbimit", en: "Exchange summary" },
    exchangeSaved: {
      sq: "Këmbimi {exchangeNumber} u ruajt me sukses.",
      en: "Exchange {exchangeNumber} was saved successfully.",
    },
    flowHint: {
      sq: "Mbaj rrjedhën të thjeshtë: kthimi majtas, zëvendësimi djathtas, pastaj përfundo.",
      en: "Keep the flow simple: return on the left, replacement on the right, then complete.",
    },
    clearReplacement: { sq: "Pastro zëvendësimin", en: "Clear replacement" },
    completeExchange: { sq: "Përfundo këmbimin", en: "Complete exchange" },
    returnSideLoaded: {
      sq: "Shitja {saleNumber} u ngarkua.",
      en: "Sale {saleNumber} was loaded.",
    },
    returnSideLoadError: {
      sq: "Nuk mund të ngarkohet shitja për momentin.",
      en: "Unable to load the sale right now.",
    },
    chooseLocationBeforeReplacementScan: {
      sq: "Zgjidh një lokacion para se të skanosh artikuj zëvendësues.",
      en: "Choose a location before scanning replacement items.",
    },
    chooseReturnedThenScan: {
      sq: "Zgjidh artikullin e kthyer së pari, pastaj skano zëvendësimin.",
      en: "Choose the returned item first, then scan the replacement item.",
    },
    replacementAdded: {
      sq: "{name} u shtua si zëvendësim.",
      en: "{name} added as the replacement.",
    },
    replacementBarcodeInvalid: {
      sq: "Ky barkod nuk mund të shtohet si zëvendësim.",
      en: "This barcode could not be added as a replacement.",
    },
    replacementScanError: {
      sq: "Nuk mund të përpunohet skanimi i zëvendësimit për momentin.",
      en: "Unable to process that replacement scan right now.",
    },
    chooseLocationBeforeComplete: {
      sq: "Zgjidh një lokacion para se të përfundosh këmbimin.",
      en: "Choose a location before completing the exchange.",
    },
    loadReturnSideBeforeComplete: {
      sq: "Gjej shitjen origjinale para se të përfundosh këmbimin.",
      en: "Find the original sale before completing the exchange.",
    },
    chooseReturnedItemFirst: {
      sq: "Zgjidh të paktën një artikull të kthyer së pari.",
      en: "Choose at least one returned item first.",
    },
    scanReplacementFirst: {
      sq: "Skano të paktën një artikull zëvendësues së pari.",
      en: "Scan at least one replacement item first.",
    },
    chooseSettlementMethod: {
      sq: "Zgjidh metodën e barazimit për këtë këmbim.",
      en: "Choose the settlement method for this exchange.",
    },
    completeExchangeError: {
      sq: "Nuk mund të përfundohet këmbimi.",
      en: "Unable to complete the exchange.",
    },
    exchangeInvalidReload: {
      sq: "Njëra anë e këmbimit nuk është më e vlefshme. Ringarko dhe provo përsëri.",
      en: "One side of the exchange is no longer valid. Reload and try again.",
    },
    saleFromLocation: {
      sq: "Shitja {saleNumber} nga {location}",
      en: "Sale {saleNumber} from {location}",
    },
    // Step indicator — every subtitle below is derived from existing state
    // (returnLookupResult / selectedReturnLines / replacementBasket /
    // completedExchange), not new business logic.
    stepFindSale: { sq: "Gjej shitjen", en: "Find sale" },
    stepFindSaleHint: { sq: "Kërko shitjen origjinale", en: "Search for the original sale" },
    stepFindSalePickHint: {
      sq: "Zgjidh shitjen nga rezultatet",
      en: "Choose the sale from the results",
    },
    stepFindSaleDoneHint: { sq: "Shitja u gjet", en: "Sale found" },
    stepChooseReturn: { sq: "Zgjidh për kthim", en: "Choose to return" },
    stepChooseReturnHint: {
      sq: "Zgjidh artikullin që kthehet",
      en: "Choose the item being returned",
    },
    stepAddReplacement: { sq: "Shto produktin e ri", en: "Add the new product" },
    stepAddReplacementPendingHint: { sq: "Shto zëvendësimin", en: "Add the replacement" },
    stepAddReplacementActiveHint: { sq: "Zgjidh një produkt", en: "Choose a product" },
    stepComplete: { sq: "Përfundo", en: "Complete" },
    stepCompleteHint: { sq: "Rishiko dhe përfundo", en: "Review and complete" },
    productsSelectedCount: { sq: "{count} produkt i zgjedhur", en: "{count} product selected" },
    productsSelectedCountPlural: {
      sq: "{count} produkte të zgjedhura",
      en: "{count} products selected",
    },
    productsAddedCount: { sq: "{count} produkt i shtuar", en: "{count} product added" },
    productsAddedCountPlural: {
      sq: "{count} produkte të shtuara",
      en: "{count} products added",
    },
    // User-facing section titles — plain language, not "return side" /
    // "replacement side" system terminology.
    returnedProductTitle: { sq: "Produkti që po kthehet", en: "Product being returned" },
    newProductTitle: { sq: "Produkti i ri që po merret", en: "New product being received" },
    replacementSearchPlaceholder: {
      sq: "Kërko produktin e ri (emri, SKU ose barkodi)…",
      en: "Search the new product (name, SKU or barcode)…",
    },
    replacementNoResults: {
      sq: "Asnjë produkt nuk u gjet për këtë kërkim.",
      en: "No product found for this search.",
    },
    replacementSearchMore: {
      sq: "Shfaqen {shown} nga {total}. Saktëso kërkimin për të parë të tjerat.",
      en: "Showing {shown} of {total}. Refine the search to see the rest.",
    },
    chooseReturnedProductFirst: {
      sq: "Zgjidh fillimisht produktin që po kthehet.",
      en: "First choose the product being returned.",
    },
    scanNewProductPlaceholder: {
      sq: "Skano barkodin e produktit të ri",
      en: "Scan the new product's barcode",
    },
    canReturnCount: { sq: "Mund të kthesh: {count} copë", en: "You can return: {count}" },
    scanAgainForMoreHint: {
      sq: "Skano përsëri për të shtuar sasinë",
      en: "Scan again to add more",
    },
    saleFullyReturned: { sq: "Nuk ka më për kthim", en: "Nothing left to return" },
    returnableUnitsShort: { sq: "{count} copë e kthyeshme", en: "{count} returnable" },
    // Exchange summary panel — plain-language financial outcome instead of a
    // signed "net balance" the user has to interpret.
    exchangeSummaryTitle: { sq: "Përmbledhja e këmbimit", en: "Exchange summary" },
    returnedProductValueLabel: { sq: "Produkti i kthyer", en: "Returned product" },
    newProductValueLabel: { sq: "Produkti i ri", en: "New product" },
    selectReturnToSeeDifferenceHint: {
      sq: "Zgjidh produktin që po kthehet për të parë diferencën.",
      en: "Choose the product being returned to see the difference.",
    },
    noDifferenceLabel: { sq: "Pa diferencë", en: "No difference" },
    noDifferenceHint: {
      sq: "Nuk nevojitet pagesë ose rimbursim.",
      en: "No payment or refund is needed.",
    },
    customerMustPayLabel: { sq: "Klienti duhet të paguajë", en: "The customer must pay" },
    customerMustBeRefundedLabel: {
      sq: "Klientit duhet t'i jepet rimbursim",
      en: "The customer must be refunded",
    },
    paymentMethodContextLabel: {
      sq: "Si do të paguajë klienti?",
      en: "How will the customer pay?",
    },
    refundMethodContextLabel: {
      sq: "Si do të rimbursohet klienti?",
      en: "How will the customer be refunded?",
    },
    // Completed-exchange state
    exchangeCompletedTitle: {
      sq: "Këmbimi u krye me sukses!",
      en: "Exchange completed successfully!",
    },
    finalDifferenceLabel: { sq: "Diferenca finale", en: "Final difference" },
    customerPaidLabel: { sq: "Klienti pagoi", en: "The customer paid" },
    customerRefundedLabel: { sq: "Klienti u rimbursua", en: "The customer was refunded" },
    newExchangeHint: { sq: "Fillo një këmbim tjetër", en: "Start another exchange" },
  },
  recentExchanges: {
    title: { sq: "Këmbimet e fundit", en: "Recent exchanges" },
    subtitle: {
      sq: "Sot si parazgjedhje; filtro sipas numrit të këmbimit ose ndrysho ditën për auditim.",
      en: "Today by default; filter by exchange number or change the day when you need to audit a swap.",
    },
    exchangeNumber: { sq: "Numri i këmbimit", en: "Exchange number" },
    loadError: {
      sq: "Nuk mund të ngarkohet historiku i këmbimeve.",
      en: "Unable to load exchanges history right now.",
    },
    detailLoadError: {
      sq: "Nuk mund të ngarkohen detajet e këtij këmbimi.",
      en: "Unable to load that exchange detail right now.",
    },
    noExchangesFound: {
      sq: "Nuk u gjetën këmbime për këtë ditë. Provo një datë tjetër ose pastro filtrin e numrit.",
      en: "No exchanges were found for this day. Try another date or clear the number filter.",
    },
    openOriginalSale: {
      sq: "Hap shitjen origjinale",
      en: "Open original sale",
    },
  },
  // --- Orders v2: manual order wizard ---
  ordersWizard: {
    title: { sq: "Krijo porosi të re", en: "Create a new order" },
    subtitle: {
      sq: "Shto produktet, marrësin dhe të dhënat e dërgesës.",
      en: "Add the products, the recipient and the delivery details.",
    },
    stepCustomer: { sq: "Klienti", en: "Customer" },
    stepProducts: { sq: "Produktet", en: "Products" },
    stepDelivery: { sq: "Dërgesa & çmimi", en: "Delivery & price" },
    stepReview: { sq: "Përmbledhje", en: "Review" },
    stepCustomerHint: { sq: "Gjej ose shto klientin", en: "Find or add the customer" },
    stepProductsHint: { sq: "Shto produktet", en: "Add the products" },
    stepDeliveryHint: { sq: "Marrësi, adresa dhe transporti", en: "Recipient, address and shipping" },
    stepReviewHint: { sq: "Kontrollo dhe krijo", en: "Check and create" },
    findCustomer: { sq: "Kërko klient ekzistues", en: "Search existing customer" },
    findCustomerPlaceholder: { sq: "Telefoni ose emri…", en: "Phone or name…" },
    useTheseDetails: { sq: "Përdor këto të dhëna", en: "Use these details" },
    newCustomer: { sq: "Klient i ri", en: "New customer" },
    customerName: { sq: "Emri", en: "Name" },
    customerPhone: { sq: "Telefoni", en: "Phone" },
    customerCity: { sq: "Qyteti", en: "City" },
    customerCountry: { sq: "Shteti", en: "Country" },
    customerAddress: { sq: "Adresa", en: "Address" },
    orderSource: { sq: "Burimi i porosisë", en: "Order source" },
    ordersCount: { sq: "porosi", en: "orders" },
    historyDelivered: { sq: "dorëzuara", en: "delivered" },
    historyCancelled: { sq: "anuluara", en: "cancelled" },
    noCustomers: { sq: "Asnjë klient nuk u gjet", en: "No customer found" },
    scanLabel: { sq: "Barkodi", en: "Barcode" },
    scanPlaceholder: { sq: "Skano ose shkruaj barkodin…", en: "Scan or type the barcode…" },
    noPrice: { sq: "Pa çmim", en: "No price" },
    scanHint: {
      sq: "Vendose kursorin këtu dhe skano — produkti shtohet automatikisht.",
      en: "Put the cursor here and scan — the product is added automatically.",
    },
    searchProducts: { sq: "Kërko me emër ose SKU…", en: "Search by name or SKU…" },
    noProducts: { sq: "Asnjë produkt nuk u gjet", en: "No product found" },
    addProduct: { sq: "Shto", en: "Add" },
    inStock: { sq: "Stok", en: "Stock" },
    outOfStock: { sq: "Pa stok", en: "Out of stock" },
    orderProducts: { sq: "Produktet në porosi", en: "Products in the order" },
    basketEmpty: { sq: "Ende nuk është shtuar asnjë produkt.", en: "No product added yet." },
    remove: { sq: "Hiq", en: "Remove" },
    maxStockReached: { sq: "Ka arritur sasinë maksimale në stok.", en: "Maximum available stock reached." },
    deliveryAddress: { sq: "Adresa e klientit", en: "Customer address" },
    courier: { sq: "Korrieri", en: "Courier" },
    abexOnly: {
      sq: "Të gjitha porositë dërgohen me ABEX.",
      en: "All orders are delivered with ABEX.",
    },
    shippingCost: { sq: "Kosto e transportit", en: "Shipping cost" },
    shippingHint: {
      sq: "Kjo shumë i shtohet totalit të porosisë (COD).",
      en: "This amount is added to the order total (COD).",
    },
    nothingSentYet: { sq: "Asgjë nuk është dërguar ende te ABEX.", en: "Nothing has been sent to ABEX yet." },
    nothingSentYetHint: {
      sq: "Pas krijimit, stoku rezervohet. Dërgesa krijohet më vonë nga faqja e porosisë.",
      en: "After creation the stock is reserved. The shipment is created later from the order page.",
    },
    internalNote: { sq: "Shënim i brendshëm (opsional)", en: "Internal note (optional)" },
    afterCreation: { sq: "Pas krijimit të porosisë:", en: "After the order is created:" },
    afterCreationStock: { sq: "Stoku i produkteve rezervohet automatikisht.", en: "Product stock is reserved automatically." },
    afterCreationInbox: { sq: "Porosia shfaqet në Inbox me statusin “E re”.", en: "The order appears in the Inbox as “New”." },
    afterCreationNoAbex: {
      sq: "Porosia NUK dërgohet automatikisht te ABEX.",
      en: "The order is NOT sent to ABEX automatically.",
    },
    createOrder: { sq: "Krijo porosinë", en: "Create the order" },
    creating: { sq: "Duke krijuar…", en: "Creating…" },
    back: { sq: "Prapa", en: "Back" },
    continue: { sq: "Vazhdo", en: "Continue" },
    cancel: { sq: "Anulo", en: "Cancel" },
    createdSuccess: { sq: "Porosia {orderNumber} u krijua dhe stoku u rezervua.", en: "Order {orderNumber} was created and the stock reserved." },
    nameRequired: { sq: "Emri i klientit është i detyrueshëm.", en: "The customer name is required." },
    phoneRequired: { sq: "Telefoni është i detyrueshëm.", en: "The phone number is required." },
    cityRequired: { sq: "Qyteti është i detyrueshëm.", en: "The city is required." },
    addressRequired: { sq: "Adresa është e detyrueshme.", en: "The address is required." },
    productsRequired: { sq: "Shto të paktën një produkt.", en: "Add at least one product." },
    // Dërgesa & çmimi - recipient, source, ABEX, summary
    recipientSection: { sq: "Klienti / Marrësi", en: "Customer / Recipient" },
    recipientLookupLabel: { sq: "Emri ose telefoni", en: "Name or phone" },
    recipientLookupPlaceholder: { sq: "Kërko klient ekzistues…", en: "Search an existing customer…" },
    recipientLookupHint: {
      sq: "Opsionale. Për klient të ri, thjesht plotëso fushat më poshtë.",
      en: "Optional. For a new customer, just fill in the fields below.",
    },
    useThisCustomer: { sq: "Përdor këtë klient", en: "Use this customer" },
    noCustomersFound: {
      sq: "Asnjë klient ekzistues. Plotëso të dhënat më poshtë.",
      en: "No existing customer. Fill in the details below.",
    },
    customerOrders: { sq: "{count} porosi", en: "{count} orders" },
    recipientPrefilled: {
      sq: "Të dhënat u plotësuan nga klienti ekzistues. Ndryshimet vlejnë vetëm për këtë porosi.",
      en: "Filled from the existing customer. Changes apply to this order only.",
    },
    sourceSection: { sq: "Burimi i porosisë", en: "Order source" },
    abexSection: { sq: "Dërgesa ABEX", en: "ABEX delivery" },
    summarySection: { sq: "Përmbledhja", en: "Summary" },
    productsSummary: { sq: "{count} produkte · {total}", en: "{count} products · {total}" },
    changeProducts: { sq: "Ndrysho produktet", en: "Change products" },

    // Step 2 - product picker
    pickerIntroTitle: {
      sq: "Skano barkodin ose kërko produktin",
      en: "Scan the barcode or search for the product",
    },
    pickerIntroHint: {
      sq: "Skano barkodin, ose shkruaj emrin / SKU-në.",
      en: "Scan the barcode, or type the name / SKU.",
    },
    searching: { sq: "Duke kërkuar…", en: "Searching…" },
    colorLabel: { sq: "Ngjyra", en: "Color" },
    sizeLabel: { sq: "Nr.", en: "Size" },
    skuLabel: { sq: "SKU", en: "SKU" },
    stockCount: { sq: "{count} në stok", en: "{count} in stock" },
    scanNotFound: { sq: "Asnjë produkt me këtë barkod.", en: "No product with this barcode." },
    scanBlocked: {
      sq: "Ky produkt nuk mund të shtohet: nuk ka stok ose çmim.",
      en: "This product can't be added: no stock or no price.",
    },
    scanAdded: { sq: "U shtua: {name}", en: "Added: {name}" },

    // Sales -> Orders handoff
    handoffLoading: { sq: "Duke ngarkuar produktet nga shitja…", en: "Loading the products from the sale…" },
    handoffLoaded: {
      sq: "Produktet nga shitja u shtuan në porosi. Stoku rezervohet vetëm kur krijohet porosia.",
      en: "The products from the sale were added. Stock is reserved only when the order is created.",
    },
    handoffItemNotFound: {
      sq: "Produkti #{id} nuk ekziston më ose është arkivuar.",
      en: "Product #{id} no longer exists or is archived.",
    },
    handoffItemNoStock: { sq: "{name}: nuk ka stok të lirë.", en: "{name}: no free stock." },
    handoffItemNoPrice: { sq: "{name}: nuk ka çmim shitjeje.", en: "{name}: has no sale price." },
    handoffItemReduced: {
      sq: "{name}: sasia u ul në {count} sipas stokut të lirë.",
      en: "{name}: quantity reduced to {count} to match free stock.",
    },
    handoffFailed: {
      sq: "Produktet nga shitja nuk u ngarkuan (problem lidhjeje). Rifresko faqen për të provuar sërish.",
      en: "The products from the sale couldn't be loaded (connection problem). Refresh the page to try again.",
    },
  },

  customers: {
    title: { sq: "Klientët", en: "Customers" },
    subtitle: {
      sq: "Menaxho klientët dhe historinë e porosive",
      en: "Manage customers and their order history",
    },

    // Summary cards - each one counts customers, not orders.
    summaryTotal: { sq: "Gjithsej klientë", en: "Total customers" },
    summaryTotalHint: { sq: "Të gjithë klientët e regjistruar", en: "All registered customers" },
    summaryActive: { sq: "Me porosi aktive", en: "With active orders" },
    summaryActiveHint: {
      sq: "Klientë me porosi të re ose të konfirmuar",
      en: "Customers with a new or confirmed order",
    },
    summaryDelivered: { sq: "Me porosi të dorëzuara", en: "With delivered orders" },
    summaryDeliveredHint: {
      sq: "Klientë me të paktën një porosi të dorëzuar",
      en: "Customers with at least one delivered order",
    },
    summaryReturned: { sq: "Me kthim nga korrieri", en: "With courier returns" },
    summaryReturnedHint: {
      sq: "Klientë me të paktën një porosi të kthyer nga korrieri",
      en: "Customers with at least one order returned by the courier",
    },

    // List
    searchPlaceholder: { sq: "Kërko me emër ose telefon...", en: "Search by name or phone..." },
    allCities: { sq: "Të gjitha qytetet", en: "All cities" },
    activityAll: { sq: "Të gjithë klientët", en: "All customers" },
    activityActive: { sq: "Me porosi aktive", en: "With active orders" },
    activityDelivered: { sq: "Me porosi të dorëzuara", en: "With delivered orders" },
    activityCancelled: { sq: "Me anulime", en: "With cancellations" },
    activityReturned: { sq: "Me kthime nga korrieri", en: "With courier returns" },
    sortNewest: { sq: "Më të fundit", en: "Newest" },
    sortOldest: { sq: "Më të vjetrit", en: "Oldest" },
    sortMostOrders: { sq: "Më shumë porosi", en: "Most orders" },
    sortLastOrder: { sq: "Porosia e fundit", en: "Latest order" },
    colCustomer: { sq: "Klienti", en: "Customer" },
    colCity: { sq: "Qyteti", en: "City" },
    colTotal: { sq: "Total porosi", en: "Total orders" },
    colDelivered: { sq: "Të dorëzuara", en: "Delivered" },
    colCancelled: { sq: "Anuluara", en: "Cancelled" },
    colReturned: { sq: "U kthyen", en: "Returned" },
    colLastOrder: { sq: "Porosia e fundit", en: "Last order" },
    colActions: { sq: "Veprime", en: "Actions" },
    view: { sq: "Shiko", en: "View" },
    noCustomers: { sq: "Ende nuk ka klientë.", en: "There are no customers yet." },
    noCustomersHint: {
      sq: "Klientët krijohen automatikisht kur regjistrohet një porosi.",
      en: "Customers are created automatically when an order is placed.",
    },
    noResults: { sq: "Nuk u gjet asnjë klient.", en: "No customer found." },
    noResultsHint: {
      sq: "Provo një emër ose numër tjetër, ose hiq filtrat.",
      en: "Try another name or number, or clear the filters.",
    },
    loadError: { sq: "Klientët nuk u ngarkuan.", en: "The customers could not be loaded." },
    loadErrorHint: {
      sq: "Kjo nuk do të thotë që nuk ka klientë. Rifresko faqen ose provo përsëri pas pak.",
      en: "This does not mean there are no customers. Refresh or try again shortly.",
    },
    showingRange: {
      sq: "Duke shfaqur {from}–{to} nga {total} klientë",
      en: "Showing {from}–{to} of {total} customers",
    },
    previous: { sq: "Mbrapa", en: "Previous" },
    next: { sq: "Para", en: "Next" },

    // Detail
    backToList: { sq: "Kthehu te lista e klientëve", en: "Back to the customer list" },
    detailTitle: { sq: "Detajet e klientit", en: "Customer details" },
    detailSubtitle: {
      sq: "Shiko informacionin, porositë dhe adresat e klientit.",
      en: "See the customer's information, orders and addresses.",
    },
    customerSince: { sq: "Klient që nga {date}", en: "Customer since {date}" },
    editCustomer: { sq: "Redakto klientin", en: "Edit customer" },
    statTotal: { sq: "Gjithsej porosi", en: "Total orders" },
    statActive: { sq: "Porosi aktive", en: "Active orders" },
    statDelivered: { sq: "Të dorëzuara", en: "Delivered" },
    statCancelled: { sq: "Të anuluara", en: "Cancelled" },
    statReturned: { sq: "U kthye nga korrieri", en: "Returned by courier" },
    statLastOrder: { sq: "Porosia e fundit", en: "Last order" },
    addressesTitle: { sq: "Adresat e përdorura", en: "Addresses used" },
    addressesHint: {
      sq: "Adresat ku janë dërguar porositë e këtij klienti.",
      en: "Where this customer's orders were delivered to.",
    },
    addressUses: { sq: "Përdorur {count} herë", en: "Used {count} times" },
    addressUsedOnce: { sq: "Përdorur 1 herë", en: "Used once" },
    addressLastUsed: { sq: "hera e fundit {date}", en: "last on {date}" },
    noAddresses: { sq: "Ende nuk ka adresa nga porositë.", en: "No addresses from orders yet." },
    addressesLoadError: { sq: "Adresat nuk u ngarkuan.", en: "The addresses could not be loaded." },
    historyTitle: { sq: "Historiku i porosive", en: "Order history" },
    colOrder: { sq: "# Porosisë", en: "Order #" },
    colProducts: { sq: "Produktet", en: "Products" },
    colSource: { sq: "Burimi", en: "Source" },
    colDate: { sq: "Data", en: "Date" },
    colCod: { sq: "Shuma (COD)", en: "Amount (COD)" },
    colStatus: { sq: "Statusi", en: "Status" },
    viewOrder: { sq: "Shiko porosinë", en: "View order" },
    moreProducts: { sq: "+ {count} produkte tjera", en: "+ {count} more products" },
    moreProductsOne: { sq: "+ 1 produkt tjetër", en: "+ 1 more product" },
    noOrders: { sq: "Ky klient nuk ka ende porosi.", en: "This customer has no orders yet." },
    ordersLoadError: {
      sq: "Historiku i porosive nuk u ngarkua.",
      en: "The order history could not be loaded.",
    },
    ordersRange: {
      sq: "Duke shfaqur {from}–{to} nga {total} porosi",
      en: "Showing {from}–{to} of {total} orders",
    },
    notFound: { sq: "Klienti nuk u gjet.", en: "Customer not found." },
    notFoundHint: {
      sq: "Mund të mos ekzistojë ose nuk i përket kësaj kompanie.",
      en: "It may not exist or may not belong to this company.",
    },
    detailLoadError: { sq: "Të dhënat e klientit nuk u ngarkuan.", en: "The customer could not be loaded." },

    // Duplicates - warning only, never merged
    duplicateWarningTitle: {
      sq: "Mund të ekzistojë një klient tjetër me këtë numër.",
      en: "Another customer may already have this number.",
    },
    duplicateWarningHint: {
      sq: "Klientët nuk bashkohen automatikisht. Kontrollo nëse është i njëjti person.",
      en: "Customers are never merged automatically. Check whether it is the same person.",
    },
    duplicateOrders: { sq: "{count} porosi", en: "{count} orders" },
    openCustomer: { sq: "Hap klientin", en: "Open customer" },

    // Edit
    editTitle: { sq: "Redakto klientin", en: "Edit customer" },
    fieldName: { sq: "Emri", en: "Name" },
    fieldPhone: { sq: "Telefoni", en: "Phone" },
    fieldEmail: { sq: "Email (opsional)", en: "Email (optional)" },
    fieldCity: { sq: "Qyteti", en: "City" },
    fieldCountry: { sq: "Shteti", en: "Country" },
    fieldAddress: { sq: "Adresa e profilit", en: "Profile address" },
    profileOnlyNote: {
      sq: "Ndryshimet ruhen vetëm te profili i klientit. Porositë e mëparshme nuk ndryshojnë.",
      en: "Changes are saved to the customer profile only. Past orders do not change.",
    },
    save: { sq: "Ruaj ndryshimet", en: "Save changes" },
    saveAnyway: { sq: "Ruaj gjithsesi", en: "Save anyway" },
    saving: { sq: "Duke ruajtur…", en: "Saving…" },
    cancel: { sq: "Anulo", en: "Cancel" },
    saved: { sq: "Klienti u përditësua.", en: "The customer was updated." },
    nameRequired: { sq: "Emri është i detyrueshëm.", en: "The name is required." },
    phoneRequired: { sq: "Telefoni është i detyrueshëm.", en: "The phone is required." },
    phoneInvalid: { sq: "Shkruaj një numër telefoni të vlefshëm.", en: "Enter a valid phone number." },
    cityRequired: { sq: "Qyteti është i detyrueshëm.", en: "The city is required." },
    addressRequired: { sq: "Adresa është e detyrueshme.", en: "The address is required." },
    emailInvalid: { sq: "Email-i nuk është i vlefshëm.", en: "The email is not valid." },
    conflictExact: {
      sq: "Ekziston tashmë një klient me saktësisht këtë emër dhe telefon. Klientët nuk bashkohen automatikisht.",
      en: "A customer with exactly this name and phone already exists. Customers are never merged automatically.",
    },
    saveFailed: { sq: "Ndryshimet nuk u ruajtën. Provo përsëri.", en: "The changes were not saved. Try again." },
    permissionDenied: {
      sq: "Nuk ke leje për të redaktuar klientët.",
      en: "You don't have permission to edit customers.",
    },
    invalidData: {
      sq: "Disa të dhëna nuk janë të sakta. Kontrollo formularin.",
      en: "Some details are not valid. Check the form.",
    },
  },

  // Orders v2 - final UX polish (list, drawer, modals, wizard).
  ordersUi: {
    subtitle: {
      sq: "Rishiko porositë, klientët, produktet dhe dërgesat ABEX.",
      en: "Review orders, customers, products and ABEX deliveries.",
    },
    clearFilters: { sq: "Pastro filtrat", en: "Clear filters" },
    noResults: { sq: "Asnjë porosi nuk u gjet.", en: "No order found." },
    noResultsHint: {
      sq: "Provo një kërkim tjetër ose pastro filtrat.",
      en: "Try another search or clear the filters.",
    },
    showingRange: {
      sq: "Duke shfaqur {from}–{to} nga {total} porosi",
      en: "Showing {from}–{to} of {total} orders",
    },
    oneItem: { sq: "1 artikull", en: "1 item" },
    manyItems: { sq: "{count} artikuj", en: "{count} items" },

    // Drawer
    itemsTitle: { sq: "Artikujt", en: "Items" },
    summaryTitle: { sq: "Përmbledhje", en: "Summary" },
    perUnit: { sq: "{amount} / copë", en: "{amount} each" },
    abexShipment: { sq: "Dërgesa ABEX", en: "ABEX delivery" },
    abexStatus: { sq: "Statusi te ABEX", en: "ABEX status" },
    courierNote: { sq: "Shënim për korrierin", en: "Note for the courier" },
    stateCancelled: { sq: "Porosia është anuluar", en: "The order is cancelled" },
    stateReturnedHint: {
      sq: "Nuk është kthim nga klienti. Produktet u rikthyen në stok pasi stafi konfirmoi që pakoja arriti në dyqan. Nuk është krijuar shitje.",
      en: "This is not a customer return. The products went back to stock after staff confirmed the parcel arrived at the store. No sale was created.",
    },
    stateDelivered: { sq: "Porosia u dorëzua", en: "The order was delivered" },
    stateConfirmed: { sq: "Porosia është konfirmuar", en: "The order is confirmed" },
    stateConfirmedHint: {
      sq: "Stoku u zbrit nga magazina. Dërgesa ABEX krijohet nga butoni më poshtë.",
      en: "The stock was deducted. The ABEX delivery is created with the button below.",
    },
    stateInDelivery: { sq: "Porosia është në dërgesë me ABEX", en: "The order is out for delivery with ABEX" },
    stateInDeliveryHint: {
      sq: "Të dhënat e porosisë nuk mund të ndryshohen më.",
      en: "The order details can no longer be changed.",
    },
    stateShipmentFailed: { sq: "Dërgesa ABEX nuk u krijua", en: "The ABEX delivery was not created" },
    stateShipmentFailedHint: {
      sq: "Provo përsëri me butonin “Riprovo dërgesën”.",
      en: "Try again with “Retry shipment”.",
    },
    stateCheckStock: { sq: "Kontrollo stokun", en: "Check the stock" },
    stateCheckStockHint: {
      sq: "Kjo porosi nuk ka rezervim aktiv të stokut. Kontrollo stokun para konfirmimit.",
      en: "This order has no active stock reservation. Check the stock before confirming.",
    },

    // History (every real OrderEventType)
    eventCreated: { sq: "Porosia u krijua", en: "Order created" },
    eventEdited: { sq: "Porosia u editua", en: "Order edited" },
    eventConfirmed: { sq: "Porosia u konfirmua", en: "Order confirmed" },
    eventReopened: { sq: "Porosia u rihap për editim", en: "Order reopened for editing" },
    eventCancelled: { sq: "Porosia u anulua", en: "Order cancelled" },
    eventShipmentRequested: { sq: "Kërkesa për dërgesë u dërgua te ABEX", en: "Delivery requested from ABEX" },
    eventShipmentCreated: { sq: "Dërgesa u krijua në ABEX", en: "Delivery created at ABEX" },
    eventShipmentFailed: { sq: "Dërgesa ABEX dështoi", en: "ABEX delivery failed" },
    eventDelivered: { sq: "Porosia u shënua si e dorëzuar", en: "Order marked as delivered" },
    eventReturnedToSender: { sq: "Porosia u kthye nga korrieri", en: "Order returned by the courier" },
    eventSaleCreated: { sq: "Shitja u regjistrua", en: "Sale recorded" },
    eventSaleFailed: { sq: "Shitja nuk u regjistrua", en: "Sale not recorded" },
    eventOther: { sq: "Përditësim i porosisë", en: "Order update" },
    eventCreatedFrom: { sq: "Nga {source}", en: "From {source}" },
    eventPriceChangedCount: { sq: "Çmim i ndryshuar në {count} produkt(e)", en: "Price changed on {count} product(s)" },
    eventEditedProducts: { sq: "Produktet ose çmimet u përditësuan", en: "Products or prices updated" },
    eventEditedDetails: { sq: "Të dhënat e porosisë u përditësuan", en: "Order details updated" },
    eventCodAmount: { sq: "Totali (COD): {amount}", en: "Total (COD): {amount}" },
    eventConfirmedHint: { sq: "Stoku u zbrit nga magazina.", en: "The stock was deducted." },
    eventReopenedHint: { sq: "Duhet të konfirmohet përsëri.", en: "It must be confirmed again." },
    eventReason: { sq: "Arsyeja: {reason}", en: "Reason: {reason}" },
    eventPod: { sq: "POD: {pod}", en: "POD: {pod}" },
    eventShipmentFailedHint: {
      sq: "Dërgesa nuk u krijua. Mund të provohet përsëri.",
      en: "The delivery was not created. It can be retried.",
    },
    eventReturnedHint: { sq: "Produktet u rikthyen në stok.", en: "The products went back to stock." },
    eventSaleNumber: { sq: "Shitja {number}", en: "Sale {number}" },
    eventSaleFailedHint: {
      sq: "Provo përsëri nga butoni te porosia.",
      en: "Try again with the button on the order.",
    },

    // Edit modal
    editSubtitle: {
      sq: "Përditëso të dhënat e porosisë, produktet dhe çmimet.",
      en: "Update the order details, products and prices.",
    },
    editRecipientSection: { sq: "Të dhënat e klientit", en: "Customer details" },
    editRecipientHint: {
      sq: "Ndryshimet vlejnë vetëm për këtë porosi. Profili i klientit nuk ndryshon.",
      en: "Changes apply to this order only. The customer profile does not change.",
    },
    fullName: { sq: "Emri i plotë", en: "Full name" },
    colProduct: { sq: "Produkti", en: "Product" },
    colQuantity: { sq: "Sasia", en: "Quantity" },
    colTotal: { sq: "Totali", en: "Total" },
    decreaseQuantity: { sq: "Ul sasinë", en: "Decrease quantity" },
    increaseQuantity: { sq: "Rrit sasinë", en: "Increase quantity" },
    orderSummary: { sq: "Përmbledhje e porosisë", en: "Order summary" },

    // Wizard
    doubleClickHint: {
      sq: "Kliko dy herë mbi një produkt për ta shtuar shpejt.",
      en: "Double-click a product to add it quickly.",
    },
    scanLabel: { sq: "Skano barkodin", en: "Scan the barcode" },
    scanPlaceholder: { sq: "Skano barkodin…", en: "Scan the barcode…" },
    or: { sq: "ose", en: "or" },
    searchLabel: { sq: "Kërko produktin", en: "Search the product" },
    searchResults: { sq: "Rezultatet e kërkimit", en: "Search results" },
    productsFound: { sq: "U gjetën {count} produkte", en: "{count} products found" },
    noProductFound: { sq: "Asnjë produkt nuk u gjet.", en: "No product found." },
    inStockCount: { sq: "Në stok ({count})", en: "In stock ({count})" },
    noStock: { sq: "Nuk ka stok", en: "Out of stock" },
    productsSummaryOne: { sq: "1 produkt · {total}", en: "1 product · {total}" },
    recipientSubtitle: {
      sq: "Kërko klient ekzistues ose plotëso të dhënat manualisht.",
      en: "Search an existing customer or fill in the details manually.",
    },
    customerDetails: { sq: "Të dhënat e klientit", en: "Customer details" },
    useCustomer: { sq: "Përdor", en: "Use" },
    noCustomerFound: {
      sq: "Asnjë klient nuk u gjet. Plotëso të dhënat më poshtë.",
      en: "No customer found. Fill in the details below.",
    },
    shippingCostCod: { sq: "Kosto e transportit (COD)", en: "Shipping cost (COD)" },
    shippingAbex: { sq: "Transporti (ABEX)", en: "Shipping (ABEX)" },
    paymentSummary: { sq: "Përmbledhje e pagesës", en: "Payment summary" },
    fullAddress: { sq: "Adresa e plotë", en: "Full address" },
    courierNoteOptional: { sq: "Shënim për korrierin (opsional)", en: "Note for the courier (optional)" },
    courierNotePlaceholder: {
      sq: "P.sh. telefono para dorëzimit…",
      en: "E.g. call before delivery…",
    },
    courierNoteHint: {
      sq: "Ky shënim i dërgohet ABEX bashkë me dërgesën.",
      en: "This note is sent to ABEX with the delivery.",
    },
  },

  ordersErrors: {
    generic: { sq: "Diçka nuk shkoi. Provo përsëri.", en: "Something went wrong. Please try again." },
    actionFailed: { sq: "Veprimi nuk u krye. Provo përsëri.", en: "The action failed. Please try again." },
    createFailed: { sq: "Porosia nuk u krijua.", en: "The order was not created." },
    untrackedReturn: {
      sq: "Stoku nuk mund të rikthehet automatikisht për këtë porosi të vjetër. Bëje rregullimin manual të stokut.",
      en: "Stock can't be restored automatically for this older order. Adjust the stock manually.",
    },
    session: { sq: "Sesioni ka skaduar. Hyr përsëri.", en: "Your session has expired. Please sign in again." },
    permission: { sq: "Nuk ke leje për këtë veprim.", en: "You don't have permission for this action." },
    network: {
      sq: "Nuk ka lidhje me serverin. Kontrollo internetin dhe provo përsëri.",
      en: "Can't reach the server. Check the connection and try again.",
    },
    stock: {
      sq: "Një ose më shumë produkte nuk kanë më stok të mjaftueshëm. Kontrollo sasitë.",
      en: "One or more products no longer have enough stock. Check the quantities.",
    },
    price: {
      sq: "Një produkt nuk ka çmim shitjeje. Kontrollo katalogun.",
      en: "A product has no sale price. Check the catalog.",
    },
    priceOverride: {
      sq: "Çmimi nuk mund të ndryshohet pa leje menaxheri.",
      en: "The price can't be changed without manager access.",
    },
    state: {
      sq: "Porosia ka ndryshuar ndërkohë. Rifresko faqen dhe provo përsëri.",
      en: "The order changed in the meantime. Refresh and try again.",
    },
    shipment: {
      sq: "Dërgesa ABEX nuk mund të krijohet tani. Provo përsëri më vonë.",
      en: "The ABEX shipment can't be created right now. Try again later.",
    },
    productMissing: {
      sq: "Produkti ose porosia nuk u gjet, ose nuk është më aktive.",
      en: "The product or order was not found, or is no longer active.",
    },
    invalidData: {
      sq: "Disa të dhëna nuk janë të sakta. Kontrollo formularin dhe provo përsëri.",
      en: "Some details are not valid. Check the form and try again.",
    },
    server: { sq: "Gabim në server. Provo përsëri pas pak.", en: "Server error. Try again shortly." },
    listLoad: { sq: "Porositë nuk u ngarkuan.", en: "The orders could not be loaded." },
    listLoadHint: {
      sq: "Kjo nuk do të thotë që nuk ka porosi. Rifresko faqen ose provo përsëri pas pak.",
      en: "This does not mean there are no orders. Refresh or try again shortly.",
    },
    detailLoad: { sq: "Detajet e porosisë nuk u ngarkuan.", en: "The order details could not be loaded." },
    alreadyCancelled: { sq: "Kjo porosi është anuluar tashmë.", en: "This order is already cancelled." },
    lockedAfterShipment: {
      sq: "Porosia është dërguar te ABEX dhe nuk mund të ndryshohet ose anulohet më këtu.",
      en: "The order has been sent to ABEX and can no longer be changed or cancelled here.",
    },
    reopenRequired: {
      sq: "Porosia është e konfirmuar. Rihape për editim para se të ndryshosh produktet ose çmimet.",
      en: "The order is confirmed. Reopen it for editing before changing products or prices.",
    },
    priceAboveCatalog: {
      sq: "Çmimi final nuk mund të jetë më i lartë se çmimi aktual i katalogut.",
      en: "The final price can't be higher than the current catalog price.",
    },
  },

  shippingLabel: {
    title: { sq: "Etiketa e dërgesës", en: "Shipping label" },
    print: { sq: "Printo", en: "Print" },
    printing: { sq: "Duke dërguar…", en: "Sending…" },
    preview: { sq: "Shiko PDF", en: "View PDF" },
    download: { sq: "Shkarko PDF", en: "Download PDF" },
    opening: { sq: "Duke hapur…", en: "Opening…" },
    sendAndPrint: { sq: "Dërgo në ABEX dhe printo", en: "Send to ABEX and print" },
    sentToPrinter: {
      sq: "Etiketa u dërgua te printeri.",
      en: "The label was sent to the printer.",
    },
    shipmentCreatedPrintFailed: {
      sq: "Dërgesa u krijua në ABEX, por etiketa nuk u dërgua te printeri:",
      en: "The ABEX shipment was created, but the label was not sent to the printer:",
    },
    missingPod: {
      sq: "Etiketa krijohet vetëm pasi porosia të dërgohet në ABEX dhe të ketë POD.",
      en: "The label is available once the order is sent to ABEX and has a POD.",
    },
    shipmentNotActive: {
      sq: "Dërgesa në ABEX nuk është aktive, prandaj etiketa nuk mund të krijohet.",
      en: "The ABEX shipment is not active, so no label can be produced.",
    },
    orderCancelled: {
      sq: "Porosia është anuluar, prandaj nuk ka etiketë.",
      en: "The order is cancelled, so there is no label.",
    },
    unavailable: { sq: "Etiketa nuk është e disponueshme.", en: "The label is not available." },
    printerNotConfigured: {
      sq: "Printeri nuk është konfiguruar ende. PDF-ja mund të shikohet ose shkarkohet.",
      en: "The printer is not configured yet. The PDF can still be viewed or downloaded.",
    },
    lastSent: { sq: "Dërguar te printeri", en: "Sent to printer" },
    lastSending: { sq: "Duke u dërguar te printeri", en: "Sending to printer" },
    lastFailed: { sq: "Dërgimi te printeri dështoi", en: "Sending to printer failed" },
    lastUnknown: {
      sq: "Nuk dihet nëse arriti te printeri",
      en: "Unknown whether it reached the printer",
    },
    repeatTitle: { sq: "Printo përsëri?", en: "Print again?" },
    repeatBody: {
      sq: "Kjo etiketë është dërguar më parë te printeri. Kontrolloni printerin para se ta dërgoni sërish.",
      en: "This label was already sent to the printer. Check the printer before sending it again.",
    },
    repeatConfirm: { sq: "Po, printo përsëri", en: "Yes, print again" },
    repeatCancel: { sq: "Jo", en: "No" },
    errorInProgress: {
      sq: "Etiketa po dërgohet tashmë te printeri. Prisni pak.",
      en: "The label is already being sent to the printer. Please wait.",
    },
    errorUnknown: {
      sq: "Nuk u konfirmua nëse etiketa arriti te printeri. Kontrolloni printerin para se ta provoni sërish.",
      en: "It could not be confirmed that the label reached the printer. Check the printer before trying again.",
    },
    errorSendFailed: {
      sq: "Etiketa nuk u dërgua te printeri. Mund ta provoni sërish.",
      en: "The label could not be sent to the printer. You can try again.",
    },
    errorPrinterNotConfigured: {
      sq: "Printimi me email nuk është konfiguruar në server.",
      en: "Email printing is not configured on the server.",
    },
    errorNotFound: { sq: "Porosia nuk u gjet.", en: "The order was not found." },
    errorGeneric: {
      sq: "Etiketa nuk mund të përgatitet tani. Provoni sërish.",
      en: "The label could not be prepared right now. Please try again.",
    },
    popupBlocked: {
      sq: "Shfletuesi bllokoi dritaren. PDF-ja u shkarkua në vend të saj.",
      en: "The browser blocked the window, so the PDF was downloaded instead.",
    },
  },
  storefrontOrders: {
    // --- Orders v2 ---
    tabInbox: { sq: "Inbox", en: "Inbox" },
    tabAll: { sq: "Të gjitha", en: "All" },
    tabInDelivery: { sq: "Në dërgesë", en: "In delivery" },
    tabDelivered: { sq: "Dorëzuara", en: "Delivered" },
    tabCancelled: { sq: "Anuluara", en: "Cancelled" },
    statusNew: { sq: "E re", en: "New" },
    statusConfirmed: { sq: "E konfirmuar", en: "Confirmed" },
    statusInDelivery: { sq: "Në dërgesë", en: "In delivery" },
    statusDelivered: { sq: "Dorëzuar", en: "Delivered" },
    statusCancelled: { sq: "Anuluar", en: "Cancelled" },
    statusReturnedToSender: { sq: "U kthye nga korrieri", en: "Returned by courier" },
    searchPlaceholder: {
      sq: "Kërko porosi, klient, telefon…",
      en: "Search order, customer, phone…",
    },
    dateFrom: { sq: "Prej", en: "From" },
    dateTo: { sq: "Deri", en: "To" },
    today: { sq: "Sot", en: "Today" },
    yesterday: { sq: "Dje", en: "Yesterday" },
    last7Days: { sq: "7 ditët e fundit", en: "Last 7 days" },
    thisMonth: { sq: "Ky muaj", en: "This month" },
    allSources: { sq: "Të gjitha burimet", en: "All sources" },
    allStatuses: { sq: "Të gjitha statuset", en: "All statuses" },
    channelWebshop: { sq: "Webshop", en: "Webshop" },
    channelInstagram: { sq: "Instagram", en: "Instagram" },
    channelFacebook: { sq: "Facebook", en: "Facebook" },
    channelPhone: { sq: "Telefon", en: "Phone" },
    channelOther: { sq: "Tjetër", en: "Other" },
    codAmount: { sq: "Shuma (COD)", en: "Amount (COD)" },
    productsSubtotal: { sq: "Nëntotali i produkteve", en: "Products subtotal" },
    shippingFee: { sq: "Transporti", en: "Shipping" },
    codTotal: { sq: "Totali për pagesë (COD)", en: "Total to collect (COD)" },
    stockReserved: { sq: "Stoku është rezervuar", en: "Stock is reserved" },
    stockReservedHint: {
      sq: "Produktet e kësaj porosie janë të rezervuara dhe nuk mund të blihen nga klientë të tjerë.",
      en: "This order's products are reserved and cannot be bought by other customers.",
    },
    stockCommitted: { sq: "Stoku është zbritur", en: "Stock has been deducted" },
    edit: { sq: "Edito", en: "Edit" },
    editData: { sq: "Edito të dhënat", en: "Edit details" },
    reopenForEditing: { sq: "Rihap për editim", en: "Reopen for editing" },
    reopenRequiredHint: {
      sq: "Për të ndryshuar produktet ose çmimet e një porosie të konfirmuar, rihape për editim.",
      en: "To change products or prices of a confirmed order, reopen it for editing.",
    },

    // Cancel modal
    cancelModalTitle: { sq: "Anulo porosinë {orderNumber}", en: "Cancel order {orderNumber}" },
    cancelReasonRequired: { sq: "Zgjidh arsyen e anulimit.", en: "Choose a cancellation reason." },
    cancelReleasesStock: {
      sq: "Pas anulimit, stoku i rezervuar do të lirohet.",
      en: "After cancelling, the reserved stock will be released.",
    },
    cancelRestoresCommittedStock: {
      sq: "Kjo porosi është e konfirmuar: stoku i zbritur do të kthehet në magazinë.",
      en: "This order is confirmed: the deducted stock will be returned to inventory.",
    },
    noteRequiredLabel: { sq: "Shënim *", en: "Note *" },
    confirmCancel: { sq: "Konfirmo anulimin", en: "Confirm cancellation" },
    keepOrder: { sq: "Mos anulo", en: "Don't cancel" },
    cancelSuccess: {
      sq: "Porosia u anulua dhe stoku u lirua.",
      en: "The order was cancelled and the stock released.",
    },

    // Edit modal
    editOrder: { sq: "Edito porosinë", en: "Edit order" },
    editModalTitle: { sq: "Edito porosinë {orderNumber}", en: "Edit order {orderNumber}" },
    recipientSection: { sq: "Marrësi", en: "Recipient" },
    productsSection: { sq: "Produktet", en: "Products" },
    shippingSection: { sq: "Transporti", en: "Shipping" },
    shippingFeeConfirmed: { sq: "Tarifa e dërgesës u konfirmua", en: "Delivery fee confirmed" },
    shippingFeeConfirmedHint: {
      sq: "Shënojeni vetëm kur tarifa është e saktë, edhe kur është 0 €. Klienti e sheh atëherë si të konfirmuar.",
      en: "Tick only when the fee is correct, including €0. The customer then sees it as confirmed.",
    },
    originalPrice: { sq: "Çmimi origjinal", en: "Original price" },
    finalPrice: { sq: "Çmimi final", en: "Final price" },
    priceOverridden: { sq: "Çmim i ndryshuar", en: "Price changed" },
    productsLockedLegacy: {
      sq: "Produktet e kësaj porosie nuk mund të ndryshohen këtu.",
      en: "This order's products can't be changed here.",
    },
    totalsPreviewHint: {
      sq: "Parapamje. Totalet përfundimtare llogariten nga serveri.",
      en: "Preview. Final totals are calculated by the server.",
    },
    saveChanges: { sq: "Ruaj ndryshimet", en: "Save changes" },
    savingChanges: { sq: "Duke ruajtur…", en: "Saving…" },
    discardChanges: { sq: "Anulo", en: "Discard" },
    editSuccess: { sq: "Porosia u përditësua.", en: "The order was updated." },
    shippingFeeInvalid: {
      sq: "Kostoja e transportit duhet të jetë 0 ose më shumë.",
      en: "Shipping must be 0 or more.",
    },
    quantityInvalid: { sq: "Sasia duhet të jetë të paktën 1.", en: "Quantity must be at least 1." },
    quantityAboveStock: {
      sq: "Nuk ka stok të mjaftueshëm për këtë sasi.",
      en: "Not enough stock for this quantity.",
    },
    finalPriceRequired: { sq: "Shkruaj çmimin final.", en: "Enter the final price." },
    finalPriceInvalid: {
      sq: "Çmimi final duhet të jetë 0 ose më shumë.",
      en: "The final price must be 0 or more.",
    },
    finalPriceAboveOriginal: {
      sq: "Çmimi final nuk mund të jetë më i lartë se çmimi origjinal.",
      en: "The final price can't be higher than the original price.",
    },
    reopenHint: {
      sq: "Kthen porosinë në gjendje editimi dhe kërkon konfirmim përsëri.",
      en: "Returns the order to an editable state and requires confirming again.",
    },
    sendToAbex: { sq: "Dërgo te ABEX", en: "Send to ABEX" },
    markDelivered: { sq: "Shëno si dorëzuar", en: "Mark as delivered" },
    markReturnedToSender: { sq: "Shëno si të kthyer nga korrieri", en: "Mark as returned by courier" },
    confirmParcelReturned: { sq: "Konfirmo që pakoja u kthye", en: "Confirm the parcel returned" },
    confirmParcelReturnedTitle: { sq: "Konfirmo kthimin e pakos", en: "Confirm the parcel return" },
    confirmParcelReturnedHint: {
      sq: "Përdore vetëm pasi pakoja të ketë arritur fizikisht në dyqan. Pas konfirmimit, produktet do të rikthehen në stok.",
      en: "Use this only after the parcel has physically arrived at the store. After confirming, the products return to stock.",
    },
    stockRestored: { sq: "Produktet janë rikthyer në stok.", en: "The products were returned to stock." },
    noSaleForReturned: {
      sq: "Nuk është krijuar shitje për këtë porosi.",
      en: "No sale was created for this order.",
    },
    linkedSale: { sq: "Shitja e lidhur", en: "Linked sale" },
    viewSale: { sq: "Shiko shitjen", en: "View sale" },
    saleCreatedFromOrder: {
      sq: "Krijuar automatikisht nga kjo porosi.",
      en: "Created automatically from this order.",
    },
    salePending: { sq: "Shitja nuk është regjistruar ende.", en: "The sale has not been recorded yet." },
    retrySale: { sq: "Provo përsëri", en: "Try again" },
    orderHistory: { sq: "Historia e porosisë", en: "Order history" },
    internalNote: { sq: "Shënim i brendshëm", en: "Internal note" },
    readOnlyAfterShipment: {
      sq: "Pas krijimit të dërgesës, të dhënat kryesore nuk mund të ndryshohen më.",
      en: "Once the shipment is created, core details can no longer be changed.",
    },
    cancellationReason: { sq: "Arsyeja e anulimit", en: "Cancellation reason" },
    reasonCustomerCancelled: { sq: "Klienti e anuloi", en: "Customer cancelled" },
    reasonCustomerUnreachable: { sq: "Klienti nuk u përgjigj", en: "Customer unreachable" },
    reasonInvalidData: { sq: "Të dhëna të pasakta", en: "Invalid details" },
    reasonStockIssue: { sq: "Problem me stokun", en: "Stock problem" },
    reasonOther: { sq: "Tjetër", en: "Other" },
    noteOptional: { sq: "Shënim (opsional)", en: "Note (optional)" },
    noteRequiredForOther: {
      sq: "Ju lutem shkruani arsyen kur zgjidhni “Tjetër”.",
      en: "Please describe the reason when choosing “Other”.",
    },
    showingRange: { sq: "Duke shfaqur {shown} nga {total} porosi", en: "Showing {shown} of {total} orders" },
    previousPage: { sq: "E mëparshme", en: "Previous" },
    nextPage: { sq: "Tjetra", en: "Next" },
    inboxEmpty: { sq: "Asnjë porosi për rishikim", en: "No orders to review" },
    inboxEmptyHint: {
      sq: "Porositë e reja nga webshop-i dhe rrjetet sociale shfaqen këtu.",
      en: "New orders from the webshop and social channels appear here.",
    },
    title: { sq: "Porositë", en: "Orders" },
    subtitle: {
      sq: "Rishiko dërgesat, kontekstin ABEX dhe artikujt — i njëjti ritëm si historiku i shitjeve.",
      en: "Review shipments, ABEX context, and line items — same rhythm as sales history.",
    },
    createOrder: { sq: "Krijo porosi", en: "Create order" },
    loadError: {
      sq: "Nuk mund të ngarkohen porositë për momentin.",
      en: "Unable to load orders right now.",
    },
    detailLoadError: {
      sq: "Nuk mund të ngarkohen detajet e porosisë për momentin.",
      en: "Unable to load that order detail right now.",
    },
    order: { sq: "Porosia", en: "Order" },
    orderStatus: { sq: "Statusi i porosisë", en: "Order status" },
    shipment: { sq: "Dërgesa", en: "Shipment" },
    filterAsYouType: {
      sq: "Filtro ndërsa shkruan…",
      en: "Filter as you type…",
    },
    pending: { sq: "Në pritje", en: "Pending" },
    confirmed: { sq: "Konfirmuar", en: "Confirmed" },
    cancelled: { sq: "Anuluar", en: "Cancelled" },
    notRequested: { sq: "Pa kërkuar", en: "Not requested" },
    requested: { sq: "E kërkuar", en: "Requested" },
    created: { sq: "Krijuar", en: "Created" },
    failed: { sq: "Dështoi", en: "Failed" },
    admin: { sq: "Admin", en: "Admin" },
    storefront: { sq: "Dyqani online", en: "Storefront" },
    pendingReview: { sq: "Në pritje të rishikimit", en: "Pending review" },
    reservedStock: { sq: "Stok i rezervuar", en: "Reserved stock" },
    clearOperationalFilters: {
      sq: "Pastro filtrat operacionalë",
      en: "Clear operational filters",
    },
    reviewingCod: {
      sq: "Duke rishikuar porositë COD nga dyqani online, më të vjetrat në pritje së pari.",
      en: "Reviewing storefront COD orders across dates, oldest waiting first.",
    },
    placedOnStorefront: {
      sq: "Vendosur në dyqanin online",
      en: "Placed on the storefront",
    },
    review: { sq: "Rishiko", en: "Review" },
    ready: { sq: "Gati", en: "Ready" },
    noOrders: { sq: "Nuk ka porosi", en: "No orders" },
    loosenFilters: {
      sq: "Provo një datë tjetër ose zbut filtrat. Kërkimi sipas numrit përditësohet pas një pushimi të shkurtër.",
      en: "Try another date or loosen filters. Order number search updates after a short pause.",
    },
    inventory: { sq: "Inventari", en: "Inventory" },
    reviewSection: { sq: "Rishikimi", en: "Review" },
    confirming: { sq: "Duke konfirmuar…", en: "Confirming…" },
    confirmOrder: { sq: "Konfirmo porosinë", en: "Confirm order" },
    releasing: { sq: "Duke lëshuar…", en: "Releasing…" },
    rejectOrder: { sq: "Refuzo porosinë", en: "Reject order" },
    cancelOrder: { sq: "Anulo porosinë", en: "Cancel order" },
    requesting: { sq: "Duke kërkuar…", en: "Requesting…" },
    requestShipment: { sq: "Kërko dërgesën", en: "Request shipment" },
    retrying: { sq: "Duke riprovuar…", en: "Retrying…" },
    retryShipment: { sq: "Riprovo dërgesën", en: "Retry shipment" },
    refreshing: { sq: "Duke rifreskuar…", en: "Refreshing…" },
    refreshStatus: { sq: "Rifresko statusin", en: "Refresh status" },
    actionSuccess: {
      sq: "Veprimi i porosisë u përfundua me sukses.",
      en: "Order action completed successfully.",
    },
    actionFailed: {
      sq: "Veprimi i porosisë nuk mund të përfundohej.",
      en: "Order action could not be completed.",
    },
    storefrontCod: { sq: "Dyqani online · COD", en: "Storefront · COD" },
    customer: { sq: "Klienti", en: "Customer" },
    recipient: { sq: "Marrësi", en: "Recipient" },
    phone: { sq: "Telefoni", en: "Phone" },
    email: { sq: "Email-i", en: "Email" },
    shipping: { sq: "Dërgesa", en: "Shipping" },
    createdRef: {
      sq: "Krijuar {date} · Ref {code}",
      en: "Created {date} · Ref {code}",
    },
    shipmentContext: { sq: "Konteksti i dërgesës", en: "Shipment context" },
    provider: { sq: "Ofruesi", en: "Provider" },
    reference: { sq: "Referenca", en: "Reference" },
    providerStatus: { sq: "Statusi i ofruesit", en: "Provider status" },
    pieces: { sq: "Copë", en: "Pieces" },
    notes: { sq: "Shënimet", en: "Notes" },
    unit: { sq: "Njësia", en: "Unit" },
    noLineSnapshot: {
      sq: "Nuk ka pamje rreshtash për këtë porosi (regjistrimet e vjetra mund të kenë vetëm header).",
      en: "No line snapshot on this order (older records may be header-only).",
    },
    cod: { sq: "COD", en: "COD" },
    pendingReviewBadge: { sq: "Në pritje të rishikimit", en: "Pending review" },
    readyForShipmentBadge: { sq: "Gati për dërgesë", en: "Ready for shipment" },
    inventoryReservedBadge: {
      sq: "Stok i rezervuar",
      en: "Inventory reserved",
    },
    inventoryCommittedBadge: {
      sq: "Stok i angazhuar",
      en: "Inventory committed",
    },
    inventoryReleasedBadge: { sq: "Stok i lëshuar", en: "Inventory released" },
    inventoryCheckNeeded: {
      sq: "Duhet kontroll stoku",
      en: "Inventory check needed",
    },
    notShippedYet: { sq: "Ende pa dërguar", en: "Not shipped yet" },
    notRequestedYet: { sq: "Ende pa kërkuar", en: "Not requested yet" },
    waitingConfirmation: {
      sq: "Në pritje të konfirmimit",
      en: "Waiting for confirmation",
    },
    notCreated: { sq: "Nuk është krijuar", en: "Not created" },
    waitingUpdate: {
      sq: "Në pritje të përditësimit",
      en: "Waiting for update",
    },
    requestFailed: { sq: "Kërkesa dështoi", en: "Request failed" },
    reviewRequiredTitle: {
      sq: "Porosi nga dyqani online · kërkon rishikim",
      en: "Storefront order · review required",
    },
    reviewRequiredMessage: {
      sq: "Kjo porosi është ende në pritje të rishikimit, por aktualisht nuk tregon një rezervim aktiv të inventarit.",
      en: "This order is still pending review, but it does not currently show an active tracked inventory hold.",
    },
    reviewRequiredHint: {
      sq: "Rishiko stokun manualisht para konfirmimit. Nëse rezervimi nuk është i besueshëm, refuzo porosinë në vend që ta dërgosh.",
      en: "Review stock manually before confirming it. If the hold cannot be trusted, reject the order instead of shipping it.",
    },
    awaitingReviewTitle: {
      sq: "Porosi nga dyqani online · në pritje të rishikimit",
      en: "Storefront order · awaiting review",
    },
    awaitingReviewMessage: {
      sq: "Kjo porosi u vendos në dyqanin online dhe po mban inventarin derisa ta konfirmosh ose refuzosh.",
      en: "This order was placed on the storefront and is actively holding inventory until you confirm or reject it.",
    },
    awaitingReviewHint: {
      sq: "Rishiko marrësin, artikujt dhe totalin, pastaj konfirmo për të angazhuar stokun ose refuzo për ta liruar.",
      en: "Review the recipient, items, and total, then confirm it to commit stock or reject it to release the hold.",
    },
    readyShipmentTitle: {
      sq: "Porosi nga dyqani online · gati për dërgesë",
      en: "Storefront order · ready for shipment",
    },
    readyShipmentMessage: {
      sq: "Kjo porosi është konfirmuar, inventari është angazhuar dhe mbetet lokale derisa të kërkosh dërgesën me korrier.",
      en: "This order is confirmed, its inventory is committed, and it stays local until you request the courier shipment.",
    },
    readyShipmentHint: {
      sq: "Kërko dërgesën kur të jesh gati ta dorëzosh korrierit.",
      en: "Request shipment when you're ready to hand it to the courier.",
    },
    shipmentHeldTitle: {
      sq: "Dërgesa në pritje deri pas konfirmimit",
      en: "Shipment held until confirmed",
    },
    shipmentHeldMessageActive: {
      sq: "Nuk kërkohet dërgesë ndërsa porosia nga dyqani është në pritje të rishikimit dhe stoku i mbajtur mbetet i padisponueshëm për klientë të tjerë.",
      en: "No shipment is requested while this storefront order is pending review, and the held stock stays unavailable to other customers.",
    },
    shipmentHeldMessage: {
      sq: "Nuk kërkohet dërgesë ndërsa porosia nga dyqani online është në pritje të rishikimit.",
      en: "No shipment is requested while this storefront order is pending review.",
    },
    shipmentHeldHintActive: {
      sq: "Konfirmo ose refuzo porosinë më sipër para se të vazhdosh me dërgesën.",
      en: "Confirm or reject the order above before moving on to shipment.",
    },
    shipmentHeldHint: {
      sq: "Zgjidh rishikimin e inventarit së pari, pastaj konfirmo porosinë para se të kërkosh dërgesën.",
      en: "Resolve the inventory review first, then confirm the order before requesting shipment.",
    },
    shipmentNotRequestedTitle: {
      sq: "Dërgesa ende pa kërkuar",
      en: "Shipment not requested yet",
    },
    shipmentNotRequestedMessage: {
      sq: "Kjo porosi ruhet lokalisht dhe ende nuk është kërkuar dërgesa.",
      en: "This order is saved locally and no shipment has been requested yet.",
    },
    shipmentNotRequestedHint: {
      sq: "Përdor Kërko dërgesën kur të jesh gati.",
      en: "Use Request shipment when you're ready.",
    },
    awaitingProviderTitle: {
      sq: "Në pritje të konfirmimit nga ofruesi",
      en: "Awaiting provider confirmation",
    },
    awaitingProviderMessage: {
      sq: "Kërkesa për dërgesë u nis, por konfirmimi nga ofruesi nuk është regjistruar ende lokalisht.",
      en: "Shipment request was started, but provider confirmation is not recorded locally yet.",
    },
    awaitingProviderHint: {
      sq: "Riprovo mbetet i fshehur ndërsa kërkesa aktuale është ende e pazgjidhur.",
      en: "Retry stays hidden while the current request is still unresolved.",
    },
    shipmentFailedTitle: {
      sq: "Kërkesa për dërgesë dështoi",
      en: "Shipment request failed",
    },
    shipmentFailedMessage: {
      sq: "Porosia lokale është ende e ruajtur. Mund ta riprovosh kërkesën për dërgesë kur të jesh gati.",
      en: "The local order is still saved. You can retry the shipment request when you're ready.",
    },
    shipmentCreatedTitle: { sq: "Dërgesa u krijua", en: "Shipment created" },
    shipmentCreatedMessage: {
      sq: "Një dërgesë nga ofruesi është regjistruar për këtë porosi dhe mund të rifreskohet kur të duhet.",
      en: "A provider shipment has been recorded for this order and can be refreshed when needed.",
    },
    shipmentCreatedMeta: {
      sq: "Referenca {ref} · POD {pod}",
      en: "Reference {ref} · POD {pod}",
    },
    shipmentCreatedMetaPod: { sq: "POD {pod}", en: "POD {pod}" },
    shipmentCancelledTitle: {
      sq: "Dërgesa u anulua",
      en: "Shipment cancelled",
    },
    shipmentCancelledMessage: {
      sq: "Kjo dërgesë është shënuar si e anuluar lokalisht.",
      en: "This shipment is marked as cancelled locally.",
    },
    shipmentStatusRecordedTitle: {
      sq: "Statusi i dërgesës u regjistrua",
      en: "Shipment status recorded",
    },
    shipmentStatusRecordedMessage: {
      sq: "Informacioni i dërgesës është i disponueshëm për këtë porosi.",
      en: "Shipment information is available for this order.",
    },
    reservationActiveTitle: {
      sq: "Inventari i rezervuar",
      en: "Inventory reserved",
    },
    reservationActiveMessageQty: {
      sq: "Në pritje të rishikimit. {quantity} është rezervuar për këtë porosi.",
      en: "Waiting for review. {quantity} is reserved for this order.",
    },
    reservationActiveMessageQtyPlural: {
      sq: "Në pritje të rishikimit. {quantity} janë rezervuar për këtë porosi.",
      en: "Waiting for review. {quantity} are reserved for this order.",
    },
    reservationActiveMessage: {
      sq: "Në pritje të rishikimit. Inventari është rezervuar për këtë porosi.",
      en: "Waiting for review. Inventory is reserved for this order.",
    },
    reservationActiveHint: {
      sq: "Konfirmimi angazhon stokun e rezervuar. Anulimi e liron. Dërgesa kërkohet pas konfirmimit.",
      en: "Confirming this order will commit the reserved stock. Cancelling this order will release the reserved stock. Shipment can be requested after confirmation.",
    },
    reservationCommittedTitle: {
      sq: "Inventari i angazhuar",
      en: "Inventory committed",
    },
    reservationCommittedMessageQty: {
      sq: "{quantity} është tashmë angazhuar për këtë porosi.",
      en: "{quantity} has already been committed to this order.",
    },
    reservationCommittedMessageQtyPlural: {
      sq: "{quantity} janë tashmë angazhuar për këtë porosi.",
      en: "{quantity} have already been committed to this order.",
    },
    reservationCommittedMessage: {
      sq: "Stoku i rezervuar është tashmë angazhuar për këtë porosi.",
      en: "Reserved stock has already been committed to this order.",
    },
    reservationCommittedHintShip: {
      sq: "Dërgesa mund të kërkohet tani. Nëse anulon para dërgesës, stoku i angazhuar do të kthehet.",
      en: "Shipment can be requested now. If you cancel here before shipping, the committed stock will be reversed.",
    },
    reservationCommittedHint: {
      sq: "Dërgesa vazhdon me rrjedhën e porosisë së konfirmuar.",
      en: "Shipment follows the confirmed order flow from here.",
    },
    reservationReleasedTitle: {
      sq: "Inventari i lëshuar",
      en: "Inventory released",
    },
    reservationReleasedMessageQty: {
      sq: "{quantity} u lirua dhe u kthye në dispozicion.",
      en: "{quantity} was released back to availability.",
    },
    reservationReleasedMessageQtyPlural: {
      sq: "{quantity} u liruan dhe u kthyen në dispozicion.",
      en: "{quantity} were released back to availability.",
    },
    reservationReleasedMessage: {
      sq: "Çdo stok i mbajtur nga dyqani online është liruar.",
      en: "Any held storefront stock has already been released back to availability.",
    },
    reservationReleasedHint: {
      sq: "Kjo porosi duhet të mbetet e mbyllur, përveç nëse rikrijohet përmes rrjedhës normale.",
      en: "This order should stay closed unless it is recreated through the normal flow.",
    },
    reservationUnavailableTitle: {
      sq: "Rezervimi i inventarit i padisponueshëm",
      en: "Inventory reservation unavailable",
    },
    reservationUnavailableMessage: {
      sq: "Kjo porosi nga dyqani online aktualisht nuk tregon një rezervim aktiv të gjurmuar.",
      en: "This storefront order does not currently show an active tracked reservation.",
    },
    reservationUnavailableHint: {
      sq: "Rishiko stokun manualisht para konfirmimit. Nëse rezervimi nuk është i besueshëm, refuzoje në vend që ta çosh përpara.",
      en: "Review stock manually before confirming or progressing this order. If the hold cannot be trusted, reject it instead of moving it forward.",
    },
  },
  catalogProducts: {
    title: { sq: "Produktet", en: "Products" },
    subtitle: {
      sq: "Shfleto, menaxho dhe ndrysho katalogun e produkteve.",
      en: "Browse, manage, and edit your product catalog.",
    },
    receivingMode: { sq: "Modaliteti i pranimit", en: "Receiving mode" },
    scanBarcode: { sq: "Skano barkodin", en: "Scan barcode" },
    quickPrint: { sq: "Printim i shpejtë", en: "Quick print" },
    addProduct: { sq: "Shto produkt", en: "Add product" },
    draft: { sq: "Draft", en: "Draft" },
    published: { sq: "Publikuar", en: "Published" },
    archived: { sq: "Arkivuar", en: "Archived" },
    inStock: { sq: "Në stok", en: "In stock" },
    allProducts: { sq: "Të gjitha produktet", en: "All products" },
    productsCount: { sq: "{count} produkte", en: "{count} products" },
    matchingFilters: { sq: "që përputhen me filtrat", en: "matching filters" },
    clearFilters: { sq: "Pastro filtrat", en: "Clear filters" },
    hideImports: { sq: "Fshih importet", en: "Hide imports" },
    importFromLegacy: { sq: "Importo nga i vjetri", en: "Import from legacy" },
    searchByName: { sq: "Kërko sipas emrit…", en: "Search by name…" },
    allStatuses: { sq: "Të gjitha statuset", en: "All statuses" },
    loadError: {
      sq: "Nuk mund të ngarkohen produktet.",
      en: "Unable to load products.",
    },
    product: { sq: "Produkti", en: "Product" },
    stock: { sq: "Stoku", en: "Stock" },
    variants: { sq: "Variantet", en: "Variants" },
    updated: { sq: "Përditësuar", en: "Updated" },
    action: { sq: "Veprimi", en: "Action" },
    available: { sq: "në dispozicion", en: "available" },
    variant: { sq: "variant", en: "variant" },
    variantsPlural: { sq: "variante", en: "variants" },
    open: { sq: "Hap", en: "Open" },
    restock: { sq: "Shto Stok", en: "Restock" },
    noProductsMatch: {
      sq: "Asnjë produkt nuk përputhet me filtrat.",
      en: "No products match your filters.",
    },
    legacyImport: { sq: "Import nga i vjetri", en: "Legacy import" },
    legacyImportDesc: {
      sq: "Sjell produktet ekzistuese në katalogun e ri.",
      en: "Bring existing products into the new catalog.",
    },
    importLoadError: {
      sq: "Nuk mund të ngarkohen të dhënat e importit.",
      en: "Unable to load import data.",
    },
    ready: { sq: "Gati", en: "Ready" },
    blocked: { sq: "Bllokuar", en: "Blocked" },
    done: { sq: "Kryer", en: "Done" },
    readyToImport: { sq: "Gati për import.", en: "Ready to import." },
    importing: { sq: "Duke importuar…", en: "Importing…" },
    import: { sq: "Importo", en: "Import" },
    view: { sq: "Shiko", en: "View" },
    importSuccess: {
      sq: "Produkti u importua me sukses.",
      en: "Product imported successfully.",
    },
    importNoRecord: {
      sq: "Importi u ekzekutua pa krijuar regjistrim të ri.",
      en: "Migration executed without creating a new record.",
    },
    importError: {
      sq: "Nuk mund të importohet ky produkt.",
      en: "Unable to import this product.",
    },
    barcodeResolveError: {
      sq: "Nuk mund të gjendet ky barkod.",
      en: "Unable to resolve that barcode.",
    },
    noPrintableBarcode: {
      sq: "Ky variant ende nuk ka barkod të printueshëm.",
      en: "This variant does not have a printable barcode yet.",
    },
    serializedScanNeedsUnit: {
      sq: "Ky produkt është i serializuar: skano etiketën e copës, jo barkodin e variantit, për ta riprintuar.",
      en: "This product is serialized: scan the item's own unit label, not the variant barcode, to reprint it.",
    },
    scanProcessError: {
      sq: "Nuk mund të përpunohet barkodi i skanuar.",
      en: "Unable to process the scanned barcode.",
    },
    undoScanError: {
      sq: "Nuk mund të zhbëhet skanimi i pranimit.",
      en: "Unable to reverse that receiving scan.",
    },
    labelsSentToPrint: {
      sq: "Etiketat e barkodit u dërguan në printim.",
      en: "Barcode labels sent to print.",
    },
    noPrintableVariants: {
      sq: "Ende nuk ka variante të pranueshme për printim në këtë sesion.",
      en: "No printable received variants are available in this session yet.",
    },
    sortOperational: {
      sq: "Sipas publikimit",
      en: "By publishing status",
    },
    sortRecentlyUpdated: { sq: "Përditësuar së fundi", en: "Recently updated" },
    sortNewest: { sq: "Më të rinjtë së pari", en: "Newest first" },
    sortRecentlyPublished: {
      sq: "Publikuar së fundi",
      en: "Recently published",
    },
    sortTitleAz: { sq: "Titulli A–Z", en: "Title A–Z" },
    statusPublished: { sq: "Publikuar", en: "Published" },
    statusPos: { sq: "POS", en: "POS" },
    statusDraft: { sq: "Draft", en: "Draft" },
    statusArchived: { sq: "Arkivuar", en: "Archived" },
    hasPhotos: { sq: "Ka foto", en: "Has photos" },
    noPhotos: { sq: "Pa foto", en: "No photos" },
    inMetaCatalog: { sq: "Meta catalog", en: "Meta catalog" },
    notInMetaCatalog: { sq: "Jo në Meta", en: "Not in Meta" },
    stockOut: { sq: "Pa stok", en: "Out of stock" },
    stockLow: { sq: "Stok i ulët", en: "Low stock" },
    stockOk: { sq: "Në stok", en: "In stock" },
    imported: { sq: "Importuar", en: "Imported" },
    printBarcodeLabels: {
      sq: "Printo etiketa barkodi",
      en: "Print barcode labels",
    },
    quickPrintRecent: {
      sq: "Printim i shpejtë i varianteve të fundit",
      en: "Quick print recent variants",
    },
    printResolvedVariant: {
      sq: "Printo etiketat për variantin e shitshëm të gjetur.",
      en: "Print labels for the resolved sellable variant.",
    },
    quickPrintBatch: {
      sq: "Zgjidh variante të krijuara së fundmi dhe printo etiketat në një batch.",
      en: "Select recently created sellable variants across products and print their labels in one batch.",
    },
    bucketSerialized: {
      sq: "Kandidat variant i serializuar",
      en: "Serialized variant candidate",
    },
    bucketAggregate: {
      sq: "Kandidat i thjeshtë agregat",
      en: "Aggregate simple candidate",
    },
    bucketImported: { sq: "Tashmë i importuar", en: "Already imported" },
    selectProducts: { sq: "Zgjidh produkte", en: "Select products" },
    cancelSelection: { sq: "Anulo zgjedhjen", en: "Cancel selection" },
    selectionToolbarAria: {
      sq: "Veprimet e zgjedhjes së produkteve",
      en: "Product selection actions",
    },
    selectAllVisible: {
      sq: "Zgjidh të gjitha të dukshmet",
      en: "Select all visible",
    },
    allBrands: { sq: "Të gjitha markat", en: "All brands" },
    allProductTypes: { sq: "Të gjitha llojet", en: "All product types" },
    allCategories: { sq: "Të gjitha kategoritë", en: "All categories" },
    allStockStates: { sq: "Të gjitha gjendjet e stokut", en: "All stock states" },
    filterBrand: { sq: "Filtro sipas markës", en: "Filter by brand" },
    filterProductType: { sq: "Filtro sipas llojit", en: "Filter by product type" },
    filterCategory: { sq: "Filtro sipas kategorisë", en: "Filter by category" },
    filterStatus: { sq: "Filtro sipas statusit", en: "Filter by status" },
    filterStock: { sq: "Filtro sipas stokut", en: "Filter by stock" },
    filterSort: { sq: "Rendit produktet", en: "Sort products" },
    previousPage: { sq: "Faqja e mëparshme", en: "Previous" },
    nextPage: { sq: "Faqja tjetër", en: "Next" },
    pageOf: { sq: "Faqja {page} nga {totalPages}", en: "Page {page} of {totalPages}" },
    selectProduct: {
      sq: "Zgjidh {title}",
      en: "Select {title}",
    },
    selectedProductsCount: {
      sq: "{count} produkte të zgjedhura",
      en: "{count} products selected",
    },
    clearSelection: { sq: "Pastro zgjedhjen", en: "Clear selection" },
    printAllVariants: {
      sq: "Printo të gjitha variantet",
      en: "Print all variants",
    },
    bulkPrintLoading: {
      sq: "Duke ngarkuar…",
      en: "Loading…",
    },
    bulkPrintLoadingVariants: {
      sq: "Duke ngarkuar variantet e printueshme…",
      en: "Loading printable variants…",
    },
    loadingRecentVariants: {
      sq: "Duke ngarkuar variantet e fundit…",
      en: "Loading recent variants…",
    },
    noRecentPrintableVariants: {
      sq: "Nuk u gjetën variante të printueshme në listën e fundit.",
      en: "No printable variants found in the recent list.",
    },
    bulkPrintTitle: {
      sq: "Printo etiketa për produktet e zgjedhura",
      en: "Print labels for selected products",
    },
    bulkPrintDescription: {
      sq: "Të gjitha variantet e gjalla me barkod nga produktet e zgjedhura përfshihen automatikisht.",
      en: "All live variants with barcodes from the selected products are included automatically.",
    },
    bulkPrintLimit: {
      sq: "Zgjidhni deri në {limit} produkte për printim në grup.",
      en: "Select up to {limit} products for bulk printing.",
    },
    bulkPrintLoadFailed: {
      sq: "Nuk u ngarkuan produktet",
      en: "Could not load products",
    },
    bulkPrintNoVariants: {
      sq: "Pa variante të printueshme",
      en: "No printable variants",
    },
    bulkPrintNothingPrintable: {
      sq: "Asnjë variant i printueshëm nuk u gjet për produktet e zgjedhura.",
      en: "No printable variants were found for the selected products.",
    },
  },
  catalogProductStudio: {
    untitled: { sq: "Pa titull", en: "Untitled" },
    untitledProduct: { sq: "Produkt pa titull", en: "Untitled product" },
    defaultProduct: { sq: "Produkt i parazgjedhur", en: "Default product" },
    colorOption: { sq: "Ngjyra", en: "Color" },
    sizeOption: { sq: "Madhësia", en: "Size" },
    sectionOverview: { sq: "Përmbledhje", en: "Overview" },
    sectionStory: { sq: "Histori", en: "Story" },
    sectionMedia: { sq: "Imazhe", en: "Images" },
    sectionOptions: { sq: "Variante", en: "Variants" },
    sectionInventory: { sq: "Stok", en: "Stock" },
    sectionPublishing: { sq: "Publikim", en: "Publish" },
    familyShoes: { sq: "Këpucë", en: "Shoes" },
    familyTextile: { sq: "Tekstil", en: "Textile" },
    familyAccessories: { sq: "Aksesorë", en: "Accessories" },
    stockRiskOut: { sq: "Pa stok", en: "Out of stock" },
    stockRiskLow: { sq: "Stok i ulët", en: "Low stock" },
    stockRiskOk: { sq: "Në stok", en: "In stock" },
    mediaRoleHero: { sq: "Kryesor", en: "Hero" },
    mediaRoleGallery: { sq: "Galeri", en: "Gallery" },
    mediaRoleDetail: { sq: "Detaj", en: "Detail" },
    mediaRoleTexture: { sq: "Teksturë", en: "Texture" },
    mediaRoleModel: { sq: "Model", en: "Model" },
    mediaRolePackaging: { sq: "Paketim", en: "Packaging" },
    mediaRoleLifestyle: { sq: "Stil jetese", en: "Lifestyle" },
    mediaRoleOther: { sq: "Tjetër", en: "Other" },
    guidanceFootwearHeadline: {
      sq: "E rekomanduar për këpucë",
      en: "Recommended for footwear",
    },
    guidanceFootwearCopy: {
      sq: "Përdorni ngjyrat e ruajtura me numra madhësish këpucësh që variantet të mbeten konsistente gjatë rimbushjeve dhe menaxhimit të barkodeve.",
      en: "Use saved colors with numeric shoe sizes so variants stay consistent across restocks and barcode handling.",
    },
    guidanceApparelHeadline: {
      sq: "E rekomanduar për veshje",
      en: "Recommended for apparel",
    },
    guidanceApparelCopy: {
      sq: "Filloni me madhësitë standarde të veshjeve dhe shtoni ngjyrat nga grupi i ngjyrave të ruajtura.",
      en: "Start with standard apparel sizes and add colors from the saved color set.",
    },
    guidanceAccessoriesHeadline: {
      sq: "E rekomanduar për aksesorë",
      en: "Recommended for accessories",
    },
    guidanceAccessoriesCopy: {
      sq: "Aksesorët zakonisht nuk kanë nevojë për variante madhësie. Shtoni ngjyra vetëm kur artikulli vjen në disa finish.",
      en: "Accessories usually do not need size variants. Add colors only if the item comes in multiple finishes.",
    },
    guidanceDefaultHeadline: {
      sq: "Konfigurim i rekomanduar",
      en: "Recommended setup",
    },
    guidanceDefaultCopy: {
      sq: "Zgjidhni madhësitë dhe ngjyrat që klientët mund të blejnë realisht. Çdo kombinim bëhet një variant i shitshëm.",
      en: "Choose the sizes and colors that customers can actually buy. Each combination becomes a real sellable variant.",
    },
    mediaHintAddPrimary: {
      sq: "Shtoni të paktën një imazh kryesor të qartë.",
      en: "Add at least one clear primary image.",
    },
    mediaHintMarkCover: {
      sq: "Shënoni një imazh kryesor që të bëhet kopertina e produktit.",
      en: "Mark a primary image so it becomes the product cover.",
    },
    mediaHintAddGallery: {
      sq: "Shtoni disa foto galerie ose detaji për thellësi dhe përshtatje.",
      en: "Add a few gallery or detail shots for depth and fit.",
    },
    mediaHintAltOne: {
      sq: "Një imazh nuk ka tekst alternativ. Teksti alt ndihmon aksesueshmërinë dhe SEO-n.",
      en: "One image is missing alt text. Alt text helps accessibility and SEO.",
    },
    mediaHintAltMany: {
      sq: "{count} imazhe nuk kanë tekst alternativ. Teksti alt ndihmon aksesueshmërinë dhe SEO-n.",
      en: "{count} images are missing alt text. Alt text helps accessibility and SEO.",
    },
    mediaHintAddDetail: {
      sq: "Shtoni një foto detaji për të treguar teksturën, përshtatjen ose finish-in.",
      en: "Add a detail shot to show texture, fit, or finish.",
    },
    mediaHintAssignVariants: {
      sq: "Caktoni imazhet te variantet që klientët të shohin ngjyrën e zgjedhur së pari.",
      en: "Assign images to variants so customers see the selected color first.",
    },
    mediaUploading: { sq: "Duke ngarkuar imazhet…", en: "Uploading images…" },
    mediaUpload: { sq: "Ngarko imazhe", en: "Upload images" },
    mediaUploadHelp: {
      sq: "Tërhiqni skedarët ose klikoni për të shtuar imazhe produkti JPG, PNG ose WebP.",
      en: "Drag files in or click to add JPG, PNG, or WebP product images.",
    },
    mediaHintsTitle: {
      sq: "Sugjerime për cilësinë e imazheve",
      en: "Image quality suggestions",
    },
    mediaProductAlt: { sq: "Media e produktit", en: "Product media" },
    mediaPreviewUnavailable: {
      sq: "Parapamja nuk disponohet",
      en: "Preview unavailable",
    },
    mediaImageN: { sq: "Imazhi {n}", en: "Image {n}" },
    mediaAltPlaceholder: { sq: "Tekst alternativ", en: "Alt text" },
    mediaRoleLabel: { sq: "Roli", en: "Role" },
    mediaAssignVariants: { sq: "Cakto te variantet", en: "Assign to variants" },
    mediaCoverImage: { sq: "Imazh kopertinë", en: "Cover image" },
    mediaSetCover: { sq: "Vendos si kopertinë", en: "Set as cover" },
    mediaCoverBadge: { sq: "Kopertinë", en: "Cover" },
    mediaProductCoverBadge: {
      sq: "Kopertina e produktit",
      en: "Product cover",
    },
    mediaColorCoverLabel: { sq: "Kopertina e ngjyrës", en: "Colour cover" },
    mediaColorCoverBadge: {
      sq: "Kopertina e ngjyrës: {color}",
      en: "Colour cover: {color}",
    },
    mediaColorCoverHint: {
      sq: "Zgjidh një imazh përfaqësues për secilën ngjyrë. Përdoret te zgjedhësi i ngjyrave në dyqan dhe te katalogu Meta për të gjitha madhësitë e asaj ngjyre. Nuk e ndryshon kopertinën e produktit dhe nuk e rirendit galerinë.",
      en: "Pick one representative image per colour. Used by the storefront colour selector and by the Meta catalog for every size of that colour. It does not change the product cover and does not reorder the gallery.",
    },
    mediaColorCoverSet: {
      sq: "Vendos si kopertinë për {color}",
      en: "Set as {color} cover",
    },
    mediaColorCoverClear: {
      sq: "Hiq kopertinën e ngjyrës për {color}",
      en: "Clear {color} cover",
    },
    mediaColorCoverIneligible: {
      sq: "Ky imazh nuk i është caktuar asnjë varianti të ngjyrës {color}.",
      en: "This image is not assigned to any {color} variant.",
    },
    mediaHintSetColorCovers: {
      sq: "Cakto një kopertinë ngjyre për secilën ngjyrë që zgjedhësi i ngjyrave dhe Meta të përdorin imazhin e duhur.",
      en: "Set a colour cover for each colour so the colour selector and Meta use the intended image.",
    },
    mediaUp: { sq: "Lart", en: "Up" },
    mediaDown: { sq: "Poshtë", en: "Down" },
    mediaRemove: { sq: "Hiq", en: "Remove" },
    mediaEmptyAlert: {
      sq: "Ende nuk janë ngarkuar imazhe. Imazhi i parë i ngarkuar bëhet kopertina sipas parazgjedhjes.",
      en: "No images uploaded yet. The first uploaded image becomes the cover by default.",
    },
    enrichmentProductStory: { sq: "Historia e produktit", en: "Product story" },
    enrichmentProductStoryPlaceholder: {
      sq: "Një pjesë e përditshme e rafinuar me siluetë të strukturuar dhe finish të butë.",
      en: "A refined everyday piece designed with a structured silhouette and soft finish.",
    },
    enrichmentProductStoryHint: {
      sq: "Tekst redaksional për faqen e produktit në dyqan. Lëreni bosh nëse përshkrimi i shkurtër mjafton.",
      en: "Editorial copy for the storefront product page. Leave empty if the short description is enough.",
    },
    enrichmentDetailChips: { sq: "Etiketa detaji", en: "Detail chips" },
    enrichmentDetailChipsPlaceholder: {
      sq: "Pjesë e limituar\nPërshtatje e strukturuar",
      en: "Limited piece\nStructured fit",
    },
    enrichmentDetailChipsHint: {
      sq: "Një etiketë e shkurtër për rresht. Opsionale.",
      en: "One short badge per line. Optional.",
    },
    enrichmentMaterial: { sq: "Materiali", en: "Material" },
    enrichmentMaterialPlaceholder: {
      sq: "Pëlhurë e endur e strukturuar",
      en: "Structured woven fabric",
    },
    enrichmentComposition: { sq: "Përmbajtja", en: "Composition" },
    enrichmentCompositionPlaceholder: {
      sq: "78% poliester, 18% viskozë, 4% elastan",
      en: "78% polyester, 18% viscose, 4% elastane",
    },
    enrichmentCare: { sq: "Udhëzime kujdesi", en: "Care instructions" },
    enrichmentCarePlaceholder: {
      sq: "Lani butësisht në temperaturë të ulët ose pastroni në pastrim kimik kur nevojitet.",
      en: "Wash gently at low temperature or dry clean when needed.",
    },
    enrichmentHighlights: { sq: "Theksime", en: "Highlights" },
    enrichmentHighlightsPlaceholder: {
      sq: "Siluetë e strukturuar\nFinish me prekje të butë\nStilim nga dita në mbrëmje",
      en: "Structured silhouette\nSoft-touch finish\nEasy day-to-evening styling",
    },
    enrichmentHighlightsHint: {
      sq: "Një theksim i shkurtër për rresht.",
      en: "One concise highlight per line.",
    },
    enrichmentFitNotes: { sq: "Shënime përshtatjeje", en: "Fit notes" },
    enrichmentFitPlaceholder: {
      sq: "Përshtatje e rregullt me profil të butë të strukturuar.",
      en: "Regular fit with a softly structured profile.",
    },
    enrichmentSizeGuide: {
      sq: "Shënime udhëzues madhësie",
      en: "Size guide notes",
    },
    enrichmentSizeGuidePlaceholder: {
      sq: "Zgjidhni madhësinë tuaj të rregullt.",
      en: "Choose your regular size.",
    },
    enrichmentStyling: { sq: "Shënime stilimi", en: "Styling notes" },
    enrichmentStylingPlaceholder: {
      sq: "Stiloni me pantallona të përshtatura ose një fustan minimal.",
      en: "Style with tailored trousers or a minimal dress.",
    },
    enrichmentDetailSections: {
      sq: "Seksione shtesë detaji",
      en: "Additional detail sections",
    },
    enrichmentDetailSectionsCopy: {
      sq: "Seksione opsionale në dyqan për dimensione ose shënime specifike të produktit.",
      en: "Optional storefront sections for dimensions or product-specific notes.",
    },
    enrichmentAddSection: { sq: "Shto seksion", en: "Add section" },
    enrichmentSectionTitle: { sq: "Titulli i seksionit", en: "Section title" },
    enrichmentSectionTitlePlaceholder: { sq: "Dimensionet", en: "Dimensions" },
    enrichmentSectionCopy: { sq: "Teksti i seksionit", en: "Section copy" },
    enrichmentSectionCopyPlaceholder: {
      sq: "Një shënim i shkurtër që ndihmon klientët të zgjedhin me besim.",
      en: "A compact note that helps customers choose confidently.",
    },
    enrichmentNoDetailSections: {
      sq: "Nuk ka seksione detaji të personalizuara. Shtoni një vetëm kur produkti ka nevojë për tekst të strukturuar shtesë.",
      en: "No custom detail sections. Add one only when the product needs extra structured copy.",
    },
    createNewProduct: { sq: "Produkt i ri", en: "New product" },
    createAddProduct: { sq: "Shto produkt", en: "Add a product" },
    createSubtitle: {
      sq: "Plotësoni bazat dhe publikoni kur të jeni gati.",
      en: "Fill in the basics and publish when ready.",
    },
    createBackToProducts: { sq: "Kthehu te produktet", en: "Back to products" },
    createStepBasic: { sq: "Informacion bazë", en: "Basic info" },
    createStepStory: { sq: "Histori", en: "Story" },
    createStepImages: { sq: "Imazhe", en: "Images" },
    createStepSizesColors: { sq: "Madhësi & ngjyra", en: "Sizes & colors" },
    createStepStock: { sq: "Stok", en: "Stock" },
    createStepVisibility: { sq: "Dukshmëri", en: "Visibility" },
    createBasicTitle: { sq: "Informacion bazë", en: "Basic info" },
    createBasicCopy: {
      sq: "Emri, kategoria dhe çmimi.",
      en: "Name, category, and pricing.",
    },
    createProductName: { sq: "Emri i produktit", en: "Product name" },
    createProductNamePlaceholder: {
      sq: "Classic Runner",
      en: "Classic Runner",
    },
    createBrand: { sq: "Marka", en: "Brand" },
    createCategory: { sq: "Kategoria", en: "Category" },
    createShortDescription: {
      sq: "Përshkrim i shkurtër",
      en: "Short description",
    },
    createShortDescriptionPlaceholder: {
      sq: "Një këpucë e pastër për çdo ditë me finish premium.",
      en: "A clean everyday runner with a premium finish.",
    },
    createProductType: { sq: "Lloji i produktit", en: "Product type" },
    createChooseProductType: {
      sq: "Zgjidhni llojin e produktit",
      en: "Choose product type",
    },
    createProductTypeHint: {
      sq: "Udhëzon madhësitë e rekomanduara dhe strukturën e varianteve për këtë produkt.",
      en: "Guides recommended sizes and variant structure for this product.",
    },
    createPrice: { sq: "Çmimi", en: "Price" },
    createCompareAt: { sq: "Çmimi krahasues", en: "Compare-at price" },
    createStoryTitle: {
      sq: "Historia & detajet e produktit",
      en: "Product Story & Details",
    },
    createStoryCopy: {
      sq: "Tekst opsional në dyqan për material, kujdes, përshtatje dhe theksime.",
      en: "Optional storefront copy for material, care, fit, and highlights.",
    },
    createImagesTitle: { sq: "Imazhe", en: "Images" },
    createImagesCopy: {
      sq: "Ngarkoni foto dhe zgjidhni një imazh kopertinë.",
      en: "Upload photos and choose a cover image.",
    },
    createSizesTitle: { sq: "Madhësi & ngjyra", en: "Sizes & colors" },
    createSizesCopy: {
      sq: "Shtoni variante nëse produkti vjen në madhësi ose ngjyra të ndryshme.",
      en: "Add variants if this product comes in different sizes or colors.",
    },
    createHasOptions: {
      sq: "A ka ky produkt madhësi ose ngjyra?",
      en: "Does this product have sizes or colors?",
    },
    createNo: { sq: "Jo", en: "No" },
    createYes: { sq: "Po", en: "Yes" },
    createSizes: { sq: "Madhësitë", en: "Sizes" },
    createUseSuggestedSizes: {
      sq: "Përdor madhësitë e sugjeruara",
      en: "Use suggested sizes",
    },
    createNoSizeVariants: {
      sq: "Ky lloj produkti zakonisht nuk ka nevojë për variante madhësie.",
      en: "This product type usually does not need size variants.",
    },
    createNoSizePreset: {
      sq: "Nuk rekomandohet asnjë preset madhësie për këtë lloj.",
      en: "No size preset is recommended for this type.",
    },
    createCustomSizes: { sq: "Madhësi të personalizuara", en: "Custom sizes" },
    createCustomSizePlaceholder: {
      sq: "Shto madhësi jo standarde",
      en: "Add an unusual size",
    },
    createColors: { sq: "Ngjyrat", en: "Colors" },
    createAddSavedColors: {
      sq: "Shtoni ngjyra të ruajtura në panelet CMS për të udhëzuar krijimin e produktit.",
      en: "Add saved colors in CMS panels to guide product creation.",
    },
    createCustomColors: { sq: "Ngjyra të personalizuara", en: "Custom colors" },
    createCustomColorPlaceholder: {
      sq: "Shto ngjyrë të personalizuar",
      en: "Add a custom color",
    },
    createUseSavedColor: {
      sq: "Përdorni ngjyrën e ruajtur „{color}“ për ta mbajtur katalogun të pastër.",
      en: "Use the saved color “{color}” to keep the catalog clean.",
    },
    createColorsMatchPalette: {
      sq: "Ngjyrat e zgjedhura përputhen me paletën e ruajtur.",
      en: "Selected colors match the saved color palette.",
    },
    createColorsNormalized: {
      sq: "Ngjyrat e personalizuara normalizohen automatikisht. Preferoni ngjyrat e ruajtura kur është e mundur.",
      en: "Custom colors are normalized automatically. Prefer saved colors when possible.",
    },
    createVariantCount: {
      sq: "Kjo do të krijojë {count} variant{suffix}. Barkodet gjenerohen automatikisht për çdo variant.",
      en: "This will create {count} variant{suffix}. Barcodes will be generated automatically for each variant.",
    },
    createVariantSuffixOne: { sq: "", en: "" },
    createVariantSuffixMany: { sq: "e", en: "s" },
    createAddSizeOrColor: {
      sq: "Shtoni të paktën një madhësi ose ngjyrë për të gjeneruar variante.",
      en: "Add at least one size or color to generate variants.",
    },
    createSimpleProduct: {
      sq: "Kjo do të krijohet si produkt i thjeshtë me një rresht stoku.",
      en: "This will be created as a simple product with one stock row.",
    },
    createStockTitle: { sq: "Stok", en: "Stock" },
    createStockCopy: {
      sq: "Vendosni sasitë për variant.",
      en: "Set quantities per variant.",
    },
    createStockLocation: { sq: "Lokacioni i stokut", en: "Stock location" },
    createChooseLocation: { sq: "Zgjidhni lokacionin", en: "Choose location" },
    createVariant: { sq: "Varianti", en: "Variant" },
    createQuantity: { sq: "Sasia", en: "Quantity" },
    createSkuOverride: { sq: "SKU e personalizuar", en: "SKU override" },
    createBarcodeOverride: {
      sq: "Barkod i personalizuar",
      en: "Barcode override",
    },
    createBarcodeAutoHint: {
      sq: "Lëreni bosh për të gjeneruar automatikisht një barkod unik varianti.",
      en: "Leave blank to auto-generate a unique variant barcode.",
    },
    createBarcodeAutoPlaceholder: {
      sq: "Auto-gjeneruar",
      en: "Auto-generated",
    },
    createPriceOverride: { sq: "Çmim i personalizuar", en: "Price override" },
    createUseBasePrice: { sq: "Përdor çmimin bazë", en: "Use base price" },
    createVisibilityTitle: { sq: "Dukshmëri", en: "Visibility" },
    createVisibilityCopy: {
      sq: "Ruaj si draft ose publiko menjëherë.",
      en: "Save as draft or publish immediately.",
    },
    createVisibilityLabel: { sq: "Dukshmëri", en: "Visibility" },
    createSaveDraft: { sq: "Ruaj draft", en: "Save draft" },
    createSaveProduct: { sq: "Ruaj produktin", en: "Save product" },
    createHideAdvanced: {
      sq: "Fshih cilësimet e avancuara",
      en: "Hide advanced settings",
    },
    createAdvancedSettings: {
      sq: "Cilësimet e avancuara",
      en: "Advanced settings",
    },
    createAdvancedCopy: {
      sq: "Anashkaloni identifikuesit e auto-gjeneruar kur nevojitet.",
      en: "Override auto-generated identifiers when needed.",
    },
    createBaseSku: { sq: "SKU bazë", en: "Base SKU" },
    createCustomSlug: { sq: "Slug i personalizuar", en: "Custom slug" },
    createCreating: { sq: "Duke krijuar…", en: "Creating…" },
    createAndPublish: { sq: "Krijo & publiko", en: "Create & publish" },
    createAsDraft: { sq: "Krijo si draft", en: "Create as draft" },
    errorUploadImage: {
      sq: "Nuk mund të ngarkohet imazhi.",
      en: "Unable to upload image.",
    },
    errorNameRequired: {
      sq: "Emri i produktit është i detyrueshëm.",
      en: "Product name is required.",
    },
    errorPriceRequired: {
      sq: "Çmimi është i detyrueshëm.",
      en: "Price is required.",
    },
    errorSizeOrColorRequired: {
      sq: "Shtoni të paktën një madhësi ose ngjyrë para krijimit të varianteve.",
      en: "Add at least one size or color before creating variants.",
    },
    errorStockLocation: {
      sq: "Zgjidhni një lokacion stoku.",
      en: "Choose a stock location.",
    },
    successCreatedPublished: {
      sq: "Produkti u krijua dhe u publikua.",
      en: "Product created and published.",
    },
    errorCodeTaken: {
      sq: "Ky kod ekziston tashmë: “{title}”. Përdor një kod tjetër.",
      en: "This code is already used by “{title}”. Use another code.",
    },
    openExistingProduct: { sq: "Hape produktin", en: "Open the product" },
    createAnother: { sq: "Krijo një produkt tjetër pas këtij", en: "Create another product after this one" },
    batchCreatedTitle: { sq: "Krijuar tani ({count})", en: "Created just now ({count})" },
    batchPrintLabels: { sq: "Printo {count} etiketa", en: "Print {count} labels" },
    batchStartBlank: { sq: "Fillo nga e para", en: "Start from scratch" },
    successCreatedPosOnly: {
      sq: "Produkti u krijua dhe shitet vetëm në shitore.",
      en: "Product created and sold in the shop only.",
    },
    successCreatedDraft: {
      sq: "Produkti u krijua si draft.",
      en: "Product created as a draft.",
    },
    errorCreateProduct: {
      sq: "Nuk mund të krijohet produkti.",
      en: "Unable to create the product.",
    },
    editEditing: { sq: "Duke redaktuar", en: "Editing" },
    editSectionsAria: {
      sq: "Seksionet e studio të produktit",
      en: "Product studio sections",
    },
    editBack: { sq: "Kthehu", en: "Back" },
    editVariants: { sq: "Variante", en: "Variants" },
    editInStock: { sq: "Në stok", en: "In stock" },
    editPublished: { sq: "Publikuar", en: "Published" },
    editInternalOnly: { sq: "Vetëm POS", en: "POS only" },
    editArchived: { sq: "Arkivuar", en: "Archived" },
    editDraft: { sq: "Draft", en: "Draft" },
    editReady: { sq: "Gati", en: "Ready" },
    editPublishing: { sq: "Duke publikuar…", en: "Publishing…" },
    editPublish: { sq: "Publiko", en: "Publish" },
    editUnpublish: { sq: "Hiq nga publikimi", en: "Unpublish" },
    editVariantsCount: { sq: " · {count} variante", en: " · {count} variants" },
    overviewTitle: { sq: "Përmbledhje", en: "Overview" },
    overviewCopy: {
      sq: "Identiteti dhe detajet e produktit.",
      en: "Product identity and details.",
    },
    overviewSaving: { sq: "Duke ruajtur…", en: "Saving…" },
    overviewName: { sq: "Emri", en: "Name" },
    overviewNone: { sq: "Asnjë", en: "None" },
    overviewSlug: { sq: "Slug URL", en: "URL slug" },
    overviewSlugPlaceholder: { sq: "auto-gjeneruar", en: "auto-generated" },
    overviewDescription: { sq: "Përshkrimi", en: "Description" },
    overviewBaseSkuHint: {
      sq: "Përdoret për të gjeneruar SKU-të e varianteve.",
      en: "Used to generate variant SKUs.",
    },
    overviewMetaCatalogLabel: {
      sq: "Përfshij në Meta Catalog",
      en: "Include in Meta Catalog",
    },
    overviewMetaCatalogHint: {
      sq: "Kontrollon vetëm shfaqjen në katalogun e Facebook/Instagram. Nuk ndikon në dukshmërinë e webshop-it.",
      en: "Controls only Facebook/Instagram catalog inclusion. Does not affect website visibility.",
    },
    storyTitle: {
      sq: "Historia & detajet e produktit",
      en: "Product Story & Details",
    },
    storyCopy: {
      sq: "Përmbajtje opsionale në dyqan që shpjegon materialin, kujdesin, përshtatjen dhe stilimin.",
      en: "Optional storefront content that explains material, care, fit, and styling.",
    },
    mediaTitle: { sq: "Media", en: "Media" },
    mediaCopy: {
      sq: "Ngarkoni, renditni dhe caktoni imazhet e shfaqura në dyqan.",
      en: "Upload, order, and assign the images shown in the storefront.",
    },
    mediaNote: {
      sq: "Imazhi kryesor bëhet kopertina e dyqanit. Përdorni rolet dhe caktimet e varianteve që klientët të shohin imazhin e duhur për ngjyrën e zgjedhur.",
      en: "The primary image becomes the storefront cover. Use roles and variant assignments so customers see the right image for the selected color.",
    },
    optionsTitle: { sq: "Opsione & variante", en: "Options & Variants" },
    optionsCopy: {
      sq: "Përcaktoni madhësi, ngjyra ose opsione të tjera. Variantet gjenerohen automatikisht.",
      en: "Define sizes, colors, or other options. Variants are generated automatically.",
    },
    optionsStructureHint: {
      sq: "Shtoni vlera të reja ngjyrë ose madhësi në opsionet më poshtë, pastaj klikoni Ruaj opsionet. Variantet e reja krijohen pas ruajtjes. Stoku dhe imazhet e varianteve konfigurohen më poshtë.",
      en: "Add new color or size values in the options below, then click Save options. New variants are created after you save. Stock and variant images can be configured in the sections below.",
    },
    optionsAddVariantValues: {
      sq: "Shto vlera varianti",
      en: "Add variant values",
    },
    optionsSave: { sq: "Ruaj opsionet", en: "Save options" },
    optionsCost: { sq: "Kostoja", en: "Cost" },
    optionsHasVariants: {
      sq: "Ky produkt ka variante",
      en: "This product has variants",
    },
    optionsSimpleAlert: {
      sq: "Produkt i thjeshtë me një rresht stoku.",
      en: "Simple product with a single stock line.",
    },
    optionsSection: { sq: "Opsionet", en: "Options" },
    optionsAddOption: { sq: "Shto opsion", en: "Add option" },
    optionsOptionName: { sq: "Emri i opsionit", en: "Option name" },
    optionsOptionNamePlaceholder: {
      sq: "p.sh. Ngjyra, Madhësia",
      en: "e.g. Color, Size",
    },
    optionsValues: { sq: "Vlerat", en: "Values" },
    optionsValuesPlaceholder: {
      sq: "E zezë, E bardhë, E kuqe",
      en: "Black, White, Red",
    },
    optionsValuesHint: {
      sq: "Listë vlerash të ndara me presje.",
      en: "Comma-separated list of values.",
    },
    optionsCombinations: {
      sq: "Kombinime specifike",
      en: "Specific combinations",
    },
    optionsAddCombination: { sq: "Shto kombinim", en: "Add combination" },
    optionsManualAlert: {
      sq: "Vetëm kombinimet që shtoni këtu do të bëhen variante.",
      en: "Only the combinations you add here will become variants.",
    },
    optionsSelect: { sq: "Zgjidh", en: "Select" },
    optionsAdvancedSummary: {
      sq: "Të avancuara: mënyra gjenerimi & gjurmim inventari",
      en: "Advanced: generation mode & inventory tracking",
    },
    optionsGeneration: {
      sq: "Gjenerimi i varianteve",
      en: "Variant generation",
    },
    optionsGenCartesian: { sq: "Të gjitha kombinimet", en: "All combinations" },
    optionsGenManual: {
      sq: "Vetëm kombinime specifike",
      en: "Specific combinations only",
    },
    optionsInventoryTracking: {
      sq: "Gjurmimi i inventarit",
      en: "Inventory tracking",
    },
    optionsInvAggregate: { sq: "Bazuar në sasi", en: "Quantity-based" },
    optionsInvSerialized: { sq: "Copë individuale", en: "Individual pieces" },
    variantsHeading: { sq: "Variante ({count})", en: "Variants ({count})" },
    variantsRowHint: {
      sq: "Klikoni një rresht për ta përfshirë në printim batch. Kutiza = batch printimi, radio = varianti i parazgjedhur në dyqan.",
      en: "Click a row to include it in batch print. Checkbox = print batch, radio = storefront default.",
    },
    variantsClearSelection: {
      sq: "Pastro zgjedhjen e printimit",
      en: "Clear print selection",
    },
    variantsSelectPrintable: {
      sq: "Zgjidh të printueshmet",
      en: "Select printable",
    },
    variantsPrintSelected: { sq: "Printo të zgjedhurat", en: "Print selected" },
    variantsSave: { sq: "Ruaj variantet", en: "Save variants" },
    variantsPrint: { sq: "Printo", en: "Print" },
    variantsDefault: { sq: "Parazgjedhur", en: "Default" },
    variantsVariant: { sq: "Varianti", en: "Variant" },
    variantsSku: { sq: "SKU", en: "SKU" },
    variantsBarcode: { sq: "Barkodi", en: "Barcode" },
    variantsLabel: { sq: "Etiketa", en: "Label" },
    variantsBarcodePlaceholder: { sq: "Auto nëse bosh", en: "Auto if empty" },
    variantsPriceBase: { sq: "Bazë", en: "Base" },
    variantsStatusDraft: { sq: "Draft", en: "Draft" },
    variantsStatusActive: { sq: "Aktiv", en: "Active" },
    variantsStatusArchived: { sq: "Arkivuar", en: "Archived" },
    variantsAriaPrint: {
      sq: "Përfshi në printim batch",
      en: "Include in batch print",
    },
    variantsAriaDefault: {
      sq: "Varianti i parazgjedhur për dyqanin",
      en: "Default variant for storefront",
    },
    variantsArchivedHeading: {
      sq: "Variante të arkivuara ({count})",
      en: "Archived variants ({count})",
    },
    variantsArchivedHint: {
      sq: "Këto kombinime janë hequr nga struktura aktuale. Nuk shfaqen në dyqan. Shtoni përsëri vlerën në opsionet dhe ruajeni strukturën për t'i rikthyer.",
      en: "These combinations were removed from the current structure. They are hidden on the storefront. Add the value back in options and save structure to restore them.",
    },
    inventoryTitle: { sq: "Inventari", en: "Inventory" },
    inventoryCopy: {
      sq: "Rimbushni variantet ekzistuese dhe rishikoni stokun sipas lokacioneve.",
      en: "Restock existing variants and review stock across locations.",
    },
    inventoryRestockTitle: { sq: "Rimbush variantet", en: "Restock variants" },
    inventoryRestockCopy: {
      sq: "Regjistroni stok hyrës dhe kaloni menjëherë në printimin e etiketave kur nevojitet.",
      en: "Record incoming stock and move straight into label printing when needed.",
    },
    inventoryAdjustStock: { sq: "Rregullo stokun", en: "Adjust stock" },
    inventoryRestock: { sq: "Shto Stok", en: "Restock" },
    inventorySerializedAlert: {
      sq: "Rimbushja e serializuar krijon njësi të reja në dispozicion dhe e mban gjenerimin automatik të barkodeve të kutisë.",
      en: "Serialized restock creates new available units and keeps box barcode generation automatic.",
    },
    inventoryAggregateAlert: {
      sq: "Rimbushja agregate rrit sasitë ekzistuese të varianteve në lokacionin e zgjedhur.",
      en: "Aggregate restock increases existing variant quantities at the chosen location.",
    },
    inventoryByLocation: {
      sq: "Stoku sipas lokacionit",
      en: "Stock by location",
    },
    inventoryOnHand: { sq: "Në dorë", en: "On hand" },
    inventoryReserved: { sq: "I rezervuar", en: "Reserved" },
    inventoryAvailable: { sq: "Në dispozicion", en: "Available" },
    inventoryRiskByVariant: {
      sq: "Rreziku i stokut sipas variantit",
      en: "Stock risk by variant",
    },
    inventoryRisk: { sq: "Rreziku", en: "Risk" },
    inventoryByVariant: { sq: "Stoku sipas variantit", en: "Stock by variant" },
    inventorySold: { sq: "Shitur", en: "Sold" },
    inventoryEmpty: {
      sq: "Ende nuk ka të dhëna inventari. Përdorni panelin e rimbushjes për të shtuar stok te variantet ekzistuese.",
      en: "No inventory data yet. Use the restock panel to add stock to existing variants.",
    },
    inventoryHistoryTitle: {
      sq: "Historiku i lëvizjeve të fundit",
      en: "Recent movement history",
    },
    inventoryHistoryCopy: {
      sq: "Rishikoni kush ndryshoi stokun, ku ndryshoi dhe sa u lëviz.",
      en: "Review who changed stock, where it changed, and how much moved.",
    },
    inventoryAllVariants: { sq: "Të gjitha variantet", en: "All variants" },
    inventoryWhen: { sq: "Kur", en: "When" },
    inventoryType: { sq: "Lloji", en: "Type" },
    inventoryChange: { sq: "Ndryshimi", en: "Change" },
    inventoryActor: { sq: "Aktori", en: "Actor" },
    inventorySystem: { sq: "Sistemi", en: "System" },
    inventoryNoHistory: {
      sq: "Ende nuk ka historik lëvizjesh inventari. Rimbushjet do të shfaqen këtu automatikisht.",
      en: "No inventory movement history yet. Restocks will appear here automatically.",
    },
    publishingTitle: { sq: "Publikimi", en: "Publishing" },
    publishingCopy: {
      sq: "Kontrolloni dukshmërinë në dyqan.",
      en: "Control visibility in the storefront.",
    },
    publishingMoveDraft: { sq: "Kalo në draft", en: "Move to draft" },
    publishingUnpublishStorefront: {
      sq: "Hiq nga storefront",
      en: "Unpublish from storefront",
    },
    publishingActivatePosOnly: {
      sq: "Aktivizo vetëm për POS",
      en: "Activate for POS only",
    },
    publishingArchive: { sq: "Arkivo", en: "Archive" },
    publishingCannotPublish: {
      sq: "Nuk mund të publikohet ende:",
      en: "Cannot publish yet:",
    },
    publishingReady: { sq: "Gati për publikim.", en: "Ready to publish." },
    errorRestockLocation: {
      sq: "Zgjidhni një lokacion stoku para rimbushjes.",
      en: "Choose a stock location before restocking.",
    },
    errorRestockQuantity: {
      sq: "Shtoni një sasi hyrëse për të paktën një variant.",
      en: "Add an incoming quantity for at least one variant.",
    },
    successRestock: {
      sq: "Inventari u shtua te variantet e zgjedhura.",
      en: "Inventory added to the selected variants.",
    },
    errorRestock: {
      sq: "Nuk mund të rimbushet inventari.",
      en: "Unable to restock inventory",
    },
    successAdjustment: {
      sq: "Rregullimi i inventarit u ruajt.",
      en: "Inventory adjustment saved.",
    },
    errorAdjustment: {
      sq: "Nuk mund të ruhet rregullimi i inventarit",
      en: "Unable to save inventory adjustment",
    },
    successOverview: { sq: "Përmbledhja u ruajt", en: "Overview saved" },
    errorOverview: {
      sq: "Nuk mund të ruhet përmbledhja",
      en: "Unable to save overview",
    },
    successStructure: {
      sq: "Struktura e katalogut u ruajt",
      en: "Catalog structure persisted",
    },
    successStructureCreated: {
      sq: "{count} variant(e) të reja",
      en: "{count} new variant(s)",
    },
    successStructureRestored: {
      sq: "{count} të rikthyer",
      en: "{count} restored",
    },
    successStructureArchived: {
      sq: "{count} të arkivuar",
      en: "{count} archived",
    },
    successStructureNextSteps: {
      sq: "Vazhdoni me stokun dhe imazhet nëse është e nevojshme.",
      en: "Continue with stock and images below if needed.",
    },
    errorStructure: {
      sq: "Nuk mund të ruhet struktura e katalogut",
      en: "Unable to persist catalog structure",
    },
    successVariants: {
      sq: "Rrjeti i varianteve u ruajt",
      en: "Variant grid saved",
    },
    errorVariants: {
      sq: "Nuk mund të ruhen variantet",
      en: "Unable to save variants",
    },
    errorUploadMedia: {
      sq: "Nuk mund të ngarkohet media",
      en: "Unable to upload media",
    },
    successMedia: { sq: "Media u ruajt", en: "Media saved" },
    errorMedia: { sq: "Nuk mund të ruhet media", en: "Unable to save media" },
    successPublished: { sq: "Produkti u publikua", en: "Product published" },
    successUnpublished: {
      sq: "Produkti u hoq nga storefront, por mbetet i shitshëm në POS",
      en: "Product removed from storefront but remains sellable in POS",
    },
    successStatus: { sq: "Produkti {status}", en: "Product {status}" },
    errorPublishing: {
      sq: "Nuk mund të ndryshohet gjendja e publikimit",
      en: "Unable to change publishing state",
    },
    errorNoPrintable: {
      sq: "Nuk ka barkode variantësh të printueshëm për këtë veprim.",
      en: "No printable variant barcodes are available for this action.",
    },
    errorRestockNoBarcode: {
      sq: "Variantet e rimbushura ende nuk kanë barkode të printueshme.",
      en: "The restocked variants do not have printable barcodes yet.",
    },
    successBarcodePrint: {
      sq: "Etiketat e barkodit u hapën për printim.",
      en: "Barcode labels opened for printing.",
    },
    variantFallback: { sq: "Varianti {id}", en: "Variant {id}" },

    // ── Create wizard shell ────────────────────────────────────────────
    wizardTitle: { sq: "Shto produkt", en: "Add product" },
    wizardSubtitle: {
      sq: "Krijo një produkt të ri në katalogun tënd. Ndiq hapat për ta përfunduar.",
      en: "Create a new product in your catalog. Follow the steps to finish.",
    },
    wizardReviewSubtitle: {
      sq: "Kontrollo gjithçka edhe njëherë para se ta krijosh produktin.",
      en: "Check everything once more before creating the product.",
    },
    wizardBackToProducts: { sq: "Kthehu te produktet", en: "Back to products" },
    wizardStepsAria: { sq: "Hapat e krijimit të produktit", en: "Product creation steps" },
    wizardStepProduct: { sq: "Produkti", en: "Product" },
    wizardStepProductHint: { sq: "Informacioni bazë", en: "Basic information" },
    wizardStepVariants: { sq: "Ngjyrat & madhësitë", en: "Colors & sizes" },
    wizardStepVariantsHint: { sq: "Krijo variantet", en: "Create variants" },
    wizardStepPhotosStock: { sq: "Fotot & stoku", en: "Photos & stock" },
    wizardStepPhotosStockHint: {
      sq: "Ngarko foto dhe vendos stokun",
      en: "Upload photos and set stock",
    },
    wizardStepReview: { sq: "Kontrollo & publiko", en: "Review & publish" },
    wizardStepReviewHint: { sq: "Shiko përmbledhjen", en: "See the summary" },
    wizardPhotosUploaded: { sq: "Ngarkuar {count} foto", en: "{count} photos uploaded" },
    wizardNoPhotos: { sq: "Pa foto", en: "No photos" },
    wizardStockSet: { sq: "Stok i vendosur", en: "Stock set" },
    wizardStockEmpty: { sq: "Pa stok", en: "No stock" },
    wizardBack: { sq: "Mbrapa", en: "Back" },
    wizardNext: { sq: "Vazhdo", en: "Continue" },
    wizardCancel: { sq: "Anulo", en: "Cancel" },
    wizardSaveDraft: { sq: "Ruaj si draft", en: "Save as draft" },
    wizardCreatePublish: { sq: "Krijo & publiko", en: "Create & publish" },
    wizardCreatePosOnly: { sq: "Krijo – vetëm në shitore", en: "Create – shop only" },
    wizardSubmitting: { sq: "Duke ruajtur…", en: "Saving…" },
    wizardResumedNotice: {
      sq: "Vazhdove një produkt të filluar më parë — puna jote e mëparshme është ruajtur.",
      en: "You're resuming a product you started earlier — your previous work was kept.",
    },
    wizardOptional: { sq: "(opsionale)", en: "(optional)" },
    wizardHowItWorks: { sq: "Si funksionon?", en: "How does it work?" },

    // Matrix phrases (stepper, summaries, review)
    matrixBoth: { sq: "{colors} ngjyra × {sizes} madhësi", en: "{colors} colors × {sizes} sizes" },
    matrixColorOnly: { sq: "{colors} ngjyra", en: "{colors} colors" },
    matrixSizeOnly: { sq: "{sizes} madhësi", en: "{sizes} sizes" },
    matrixNone: { sq: "Pa ngjyra ose madhësi", en: "No colors or sizes" },
    variantsCount: { sq: "{count} variante", en: "{count} variants" },
    variantsCountOne: { sq: "1 variant", en: "1 variant" },

    // ── Stage-failure retry banner ─────────────────────────────────────
    wizardStageFailedDraft: {
      sq: "Produkti nuk u krijua. Provo përsëri.",
      en: "The product could not be created. Try again.",
    },
    wizardStageFailedCore: {
      sq: "Produkti u krijua, por të dhënat bazë nuk u ruajtën. Provo përsëri.",
      en: "The product was created, but its basic details were not saved. Try again.",
    },
    wizardStageFailedStructure: {
      sq: "Produkti u krijua, por ngjyrat dhe madhësitë nuk u ruajtën. Provo përsëri.",
      en: "The product was created, but colors and sizes were not saved. Try again.",
    },
    wizardStageFailedVariants: {
      sq: "Produkti u krijua, por disa ndryshime të varianteve nuk u ruajtën. Provo përsëri.",
      en: "The product was created, but some variant changes were not saved. Try again.",
    },
    wizardStageFailedMedia: {
      sq: "Produkti u krijua, por fotot nuk u ruajtën. Provo përsëri.",
      en: "The product was created, but the photos were not saved. Try again.",
    },
    wizardStageFailedInventory: {
      sq: "Produkti u krijua, por stoku nuk u ruajt. Provo përsëri.",
      en: "The product was created, but stock was not saved. Try again.",
    },
    wizardStageFailedPublishing: {
      sq: "Produkti u ruajt si draft, por publikimi dështoi. Provo përsëri.",
      en: "The product was saved as a draft, but publishing failed. Try again.",
    },
    wizardStageFailedGeneric: {
      sq: "Diçka shkoi keq. Provo përsëri.",
      en: "Something went wrong. Try again.",
    },
    wizardRetry: { sq: "Provo përsëri", en: "Retry" },

    // ── Step 1 — Produkti ───────────────────────────────────────────────
    step1CardTitle: { sq: "Informacioni bazë", en: "Basic information" },
    step1CardCopy: {
      sq: "Shto detajet kryesore të produktit. Fushat me * janë të obligueshme.",
      en: "Add the product's main details. Fields marked * are required.",
    },
    step1Name: { sq: "Emri i produktit", en: "Product name" },
    step1NamePlaceholder: { sq: "P.sh. Classic Runner", en: "E.g. Classic Runner" },
    step1Category: { sq: "Kategoria", en: "Category" },
    step1Brand: { sq: "Marka", en: "Brand" },
    step1BrandPlaceholder: { sq: "Zgjidh markën (opsionale)", en: "Choose a brand (optional)" },
    step1Type: { sq: "Lloji i produktit", en: "Product type" },
    step1TypePlaceholder: { sq: "Zgjidh llojin (opsionale)", en: "Choose a type (optional)" },
    step1TypeHint: {
      sq: "Lloji ndihmon të sugjerohen madhësitë e duhura.",
      en: "The type helps suggest the right sizes.",
    },
    step1Price: { sq: "Çmimi", en: "Price" },
    step1ComparePrice: { sq: "Çmimi krahasues", en: "Compare-at price" },
    step1ComparePriceHint: { sq: "Çmimi origjinal (opsionale)", en: "Original price (optional)" },
    step1Cost: { sq: "Kosto", en: "Cost" },
    step1CostHint: { sq: "Kosto e blerjes (opsionale)", en: "Purchase cost (optional)" },
    step1ShortDescription: { sq: "Përshkrim i shkurtër", en: "Short description" },
    step1DescriptionPlaceholder: {
      sq: "Një përshkrim i shkurtër për produktin…",
      en: "A short description of the product…",
    },
    step1MetaCatalog: { sq: "Përfshi në Meta Catalog", en: "Include in Meta Catalog" },
    step1MetaCatalogHint: {
      sq: "Kontrollon nëse ky produkt dërgohet në katalogun e Facebook/Instagram.",
      en: "Controls whether this product is sent to the Facebook/Instagram catalog.",
    },
    step1WebshopDetailsSection: { sq: "Detaje për webshop", en: "Webshop details" },
    step1WebshopDetailsCopy: {
      sq: "Shto histori, material, përmbajtje, kujdesi, theksime dhe më shumë.",
      en: "Add story, material, composition, care, highlights and more.",
    },
    step1AdvancedSection: { sq: "Cilësime të avancuara", en: "Advanced settings" },
    step1AdvancedCopy: {
      sq: "SKU bazë dhe adresa (slug) e produktit.",
      en: "Base SKU and the product's address (slug).",
    },

    // ── Step 2 — Ngjyrat & madhësitë ─────────────────────────────────────
    step2Title: { sq: "Ngjyrat & madhësitë", en: "Colors & sizes" },
    step2Copy: {
      sq: "Zgjidh ngjyrat dhe madhësitë për këtë produkt. Variantet do të krijohen automatikisht.",
      en: "Pick the colors and sizes for this product. Variants are created automatically.",
    },
    step2HowCopy: {
      sq: "Zgjidh ngjyrat dhe madhësitë dhe sistemi do të krijojë automatikisht të gjitha variantet (p.sh. 2 ngjyra × 5 madhësi = 10 variante).",
      en: "Pick colors and sizes and the system creates every variant automatically (e.g. 2 colors × 5 sizes = 10 variants).",
    },
    step2ColorsTitle: { sq: "Zgjidh ngjyrat", en: "Choose colors" },
    step2ColorsCopy: {
      sq: "Kërko dhe zgjidh ngjyrat që i ka ky produkt.",
      en: "Search and pick the colors this product comes in.",
    },
    step2ColorSearchPlaceholder: {
      sq: "Kërko ngjyrë (p.sh. Taba, Zi, Bordo…)",
      en: "Search colors (e.g. Tan, Black, Burgundy…)",
    },
    step2AddNewColor: { sq: "Shto ngjyrë të re", en: "Add new color" },
    step2SuggestedColors: { sq: "Ngjyra të sugjeruara", en: "Suggested colors" },
    step2NoColorMatch: {
      sq: "Asnjë ngjyrë nuk përputhet. Shtoje si ngjyrë të re.",
      en: "No color matches. Add it as a new color.",
    },
    step2NoColorsSelected: {
      sq: "Asnjë ngjyrë e zgjedhur — produkti do të jetë pa ngjyra.",
      en: "No colors selected — the product will have no colors.",
    },
    step2SizesTitle: { sq: "Zgjidh madhësitë", en: "Choose sizes" },
    step2SizesCopy: {
      sq: "Përzgjidh madhësitë e disponueshme për këtë produkt.",
      en: "Pick the sizes available for this product.",
    },
    step2NoSizesForType: {
      sq: "Ky lloj produkti zakonisht nuk ka madhësi.",
      en: "This kind of product usually has no sizes.",
    },
    step2SizeSystem: { sq: "Lloji i madhësive", en: "Size system" },
    step2SizeSystemLetters: { sq: "Shkronja (XS – 3XL)", en: "Letters (XS – 3XL)" },
    step2SizeSystemNumeric: { sq: "Numra (36 – 50)", en: "Numbers (36 – 50)" },
    step2SizeSystemJeans: { sq: "Farmerka (26 – 36)", en: "Jeans (26 – 36)" },
    step2QuickPick: { sq: "Zgjidh shpejt", en: "Quick pick" },
    step2QuickPickPlaceholder: { sq: "Zgjidh një diapazon", en: "Choose a range" },
    step2AddCustomSize: { sq: "Shto madhësi tjetër", en: "Add another size" },
    step2CustomSizePlaceholder: { sq: "P.sh. 43 ose XXL", en: "E.g. 43 or XXL" },
    step2Add: { sq: "Shto", en: "Add" },
    step2SummaryTitle: { sq: "Përmbledhje e varianteve", en: "Variant summary" },
    step2SummaryCopy: {
      sq: "Sistemi do të krijojë automatikisht të gjitha kombinimet e ngjyrave dhe madhësive.",
      en: "The system creates every color and size combination automatically.",
    },
    step2VariantsToCreate: { sq: "variante do të krijohen", en: "variants will be created" },
    step2VariantToCreateOne: { sq: "variant do të krijohet", en: "variant will be created" },
    step2ColorsSelected: { sq: "ngjyra të zgjedhura", en: "colors selected" },
    step2SizesSelected: { sq: "madhësi të zgjedhura", en: "sizes selected" },
    step2ReadyTitle: { sq: "Gati për hapin tjetër", en: "Ready for the next step" },
    step2ReadyCopy: {
      sq: "Në hapin tjetër do të ngarkosh fotot dhe do të vendosësh stokun për secilin variant.",
      en: "Next you'll upload photos and set stock for each variant.",
    },
    step2BlockedTitle: { sq: "Shumë kombinime", en: "Too many combinations" },
    step2SkuAutoNote: {
      sq: "SKU-të dhe barkodet do të gjenerohen automatikisht.",
      en: "SKUs and barcodes will be generated automatically.",
    },
    step2SoftLimitWarning: {
      sq: "Ky plan krijon {count} variante — konsidero uljen e kombinimeve për lehtësi menaxhimi.",
      en: "This plan creates {count} variants — consider narrowing it for easier management.",
    },
    step2HardLimitWarning: {
      sq: "Ky kombinim krijon {count} variante, mbi kufirin prej 250. Zvogëlo ngjyrat ose madhësitë.",
      en: "This combination creates {count} variants, over the limit of 250. Reduce the colors or sizes.",
    },
    step2DimensionValueLimitWarning: {
      sq: "Mund të shtosh deri në 50 ngjyra dhe 50 madhësi.",
      en: "You can add up to 50 colors and 50 sizes.",
    },

    // ── Step 3 — Fotot & stoku ───────────────────────────────────────────
    step3Title: { sq: "Fotot & stoku", en: "Photos & stock" },
    step3Copy: {
      sq: "Ngarko fotot për çdo ngjyrë dhe vendos stokun për madhësitë. Fotot ndihmojnë klientët të shohin produktin më qartë.",
      en: "Upload photos for each color and set stock per size. Photos help customers see the product clearly.",
    },
    step3HowCopy: {
      sq: "Çdo ngjyrë ka fotot e veta. Fotoja me etiketën «Kopertina» shfaqet kur klienti zgjedh atë ngjyrë. «Ngjyra kryesore» jep foton kryesore të produktit.",
      en: "Each color has its own photos. The photo marked “Cover” is shown when a customer picks that color. The “main color” provides the product's main photo.",
    },
    step3NoColorSectionTitle: { sq: "Fotot & stoku", en: "Photos & stock" },
    step3UploadHint: { sq: "Ngarko të paktën 1 foto", en: "Upload at least 1 photo" },
    step3PhotoCount: { sq: "{count} foto", en: "{count} photos" },
    step3SetPrimaryColor: { sq: "Vendos si ngjyrë kryesore", en: "Set as main color" },
    step3PrimaryColor: { sq: "Ngjyra kryesore", en: "Main color" },
    step3RemoveColor: { sq: "Hiq ngjyrën", en: "Remove color" },
    step3RemoveColorConfirm: {
      sq: "Të hiqet ngjyra {color}? Fotot e kësaj ngjyre do të hiqen nga produkti.",
      en: "Remove {color}? This color's photos will be removed from the product.",
    },
    step3UploadPhoto: { sq: "Ngarko foto", en: "Upload photo" },
    step3UploadFormats: { sq: "JPG, PNG, WebP", en: "JPG, PNG, WebP" },
    step3UploadMax: { sq: "Maks. 20MB", en: "Max 20MB" },
    step3AddMorePhotos: { sq: "Shto më shumë foto", en: "Add more photos" },
    step3CoverBadge: { sq: "Kopertina", en: "Cover" },
    step3ProductCoverBadge: { sq: "Kryesore", en: "Main" },
    step3PhotoMenu: { sq: "Veprime për foton", en: "Photo actions" },
    step3MenuSetColorCover: { sq: "Vendos si kopertinë", en: "Set as cover" },
    step3MenuSetProductCover: { sq: "Vendos si foto kryesore", en: "Set as main photo" },
    step3MenuMoveLeft: { sq: "Lëviz majtas", en: "Move left" },
    step3MenuMoveRight: { sq: "Lëviz djathtas", en: "Move right" },
    step3MenuRemove: { sq: "Fshi foton", en: "Delete photo" },
    step3StockPerSize: { sq: "Stoku për madhësitë", en: "Stock per size" },
    step3StockSingle: { sq: "Stoku", en: "Stock" },
    step3SameStockAll: {
      sq: "Vendos stokun njëjtë për të gjitha",
      en: "Set the same stock for all",
    },
    step3Apply: { sq: "Apliko", en: "Apply" },
    step3ClearStock: { sq: "Pastro stokun", en: "Clear stock" },
    step3StockLocation: { sq: "Vendndodhja e stokut", en: "Stock location" },
    step3TotalVariants: { sq: "{count} variante gjithsej", en: "{count} variants in total" },
    step3AllCompleteTitle: {
      sq: "Të gjitha variantet kanë foto dhe stok",
      en: "Every variant has photos and stock",
    },
    step3IncompleteTitle: {
      sq: "Disa variante janë pa foto ose pa stok",
      en: "Some variants have no photos or no stock",
    },
    step3IncompleteCopy: {
      sq: "Mund të vazhdosh te hapi tjetër edhe pa foto/stok, por rekomandojmë t'i plotësosh.",
      en: "You can continue without photos/stock, but we recommend filling them in.",
    },

    // ── Step 4 — Kontrollo & publiko ─────────────────────────────────────
    step4SummaryTitle: { sq: "Përmbledhje e produktit", en: "Product summary" },
    step4SummaryCopy: {
      sq: "Shiko të gjitha informacionet që ke plotësuar.",
      en: "See everything you've filled in.",
    },
    step4Edit: { sq: "Redakto", en: "Edit" },
    step4DraftBadge: { sq: "Draft", en: "Draft" },
    step4InCatalogBadge: { sq: "Në katalog", en: "In catalog" },
    step4Price: { sq: "Çmimi", en: "Price" },
    step4ComparePrice: { sq: "Çmimi krahasues", en: "Compare-at price" },
    step4Cost: { sq: "Kosto", en: "Cost" },
    step4Brand: { sq: "Marka", en: "Brand" },
    step4Category: { sq: "Kategoria", en: "Category" },
    step4Type: { sq: "Lloji i produktit", en: "Product type" },
    step4VariantsCard: { sq: "Ngjyrat & madhësitë", en: "Colors & sizes" },
    step4StockTotal: { sq: "Stok total: {count}", en: "Total stock: {count}" },
    step4PhotosCard: { sq: "Fotot", en: "Photos" },
    step4PhotosTotal: { sq: "{count} foto gjithsej", en: "{count} photos in total" },
    step4MorePhotos: { sq: "të tjera", en: "more" },
    step4NoPhotos: { sq: "Asnjë foto ende.", en: "No photos yet." },
    step4MetaIncluded: { sq: "I përfshirë", en: "Included" },
    step4MetaExcluded: { sq: "Jo i përfshirë", en: "Not included" },
    step4MetaIncludedCopy: {
      sq: "Produkti do të dërgohet në katalogun e Facebook/Instagram.",
      en: "The product will be sent to the Facebook/Instagram catalog.",
    },
    step4MetaExcludedCopy: {
      sq: "Produkti nuk do të dërgohet në katalogun e Facebook/Instagram.",
      en: "The product won't be sent to the Facebook/Instagram catalog.",
    },
    step4WebshopFilledOne: { sq: "1 fushë e plotësuar", en: "1 field filled in" },
    step4WebshopFilled: { sq: "{count} fusha të plotësuara", en: "{count} fields filled in" },
    step4WebshopEmpty: { sq: "Asnjë fushë e plotësuar", en: "No fields filled in" },
    step4WebshopCopy: { sq: "Histori, material, kujdesi, etj.", en: "Story, material, care, etc." },
    step4ChecksTitle: { sq: "Kontrollo për probleme", en: "Check for problems" },
    step4ChecksOk: {
      sq: "Ne kemi kontrolluar të gjitha të dhënat. Mund të vazhdosh.",
      en: "We've checked everything. You can continue.",
    },
    step4ChecksWarn: {
      sq: "Mund të vazhdosh, por disa gjëra mund të plotësohen.",
      en: "You can continue, but a few things could be filled in.",
    },
    step4ChecksBlocked: {
      sq: "Plotëso fushat e detyrueshme para se të vazhdosh.",
      en: "Fill in the required fields before continuing.",
    },
    step4CheckBasicOk: { sq: "Informacioni bazë është i plotë", en: "Basic information is complete" },
    step4CheckNameMissing: { sq: "Mungon emri i produktit", en: "The product name is missing" },
    step4CheckPriceMissing: { sq: "Mungon një çmim i vlefshëm", en: "A valid price is missing" },
    step4CheckVariantsOk: {
      sq: "Ngjyrat dhe madhësitë janë të konfiguruara",
      en: "Colors and sizes are configured",
    },
    step4CheckVariantsTooMany: {
      sq: "Shumë kombinime ngjyrash dhe madhësish (mbi 250)",
      en: "Too many color and size combinations (over 250)",
    },
    step4CheckSkuReady: {
      sq: "SKU-të dhe barkodet do të gjenerohen automatikisht",
      en: "SKUs and barcodes will be generated automatically",
    },
    step4CheckPhotosOk: { sq: "Janë ngarkuar fotot", en: "Photos are uploaded" },
    step4CheckNoPhotos: { sq: "Produkti nuk ka asnjë foto", en: "The product has no photos yet" },
    step4CheckStockOk: { sq: "Stoku është i vendosur", en: "Stock is set" },
    step4CheckZeroStock: { sq: "Stoku është 0 për të gjitha variantet", en: "Stock is 0 for every variant" },
    step4CheckColorCoversOk: { sq: "Çdo ngjyrë ka kopertinë", en: "Every color has a cover photo" },
    step4CheckMissingColorCover: {
      sq: "Disa ngjyra nuk kanë kopertinë",
      en: "Some colors don't have a cover photo",
    },
    step4CheckWebshopOk: { sq: "Detajet për webshop janë plotësuar", en: "Webshop details are filled in" },
    step4CheckIncompleteWebshop: { sq: "Detajet për webshop janë bosh", en: "Webshop details are empty" },
    step4GoodToKnowTitle: { sq: "Gjëra për t'u ditur", en: "Good to know" },
    step4GoodToKnowDraft: {
      sq: "Produktin mund ta ruash si draft dhe ta editosh më vonë.",
      en: "You can save the product as a draft and edit it later.",
    },
    step4GoodToKnowNoPhotos: {
      sq: "Mund ta publikosh edhe pa foto ose stok.",
      en: "You can publish even without photos or stock.",
    },
    step4GoodToKnowStudio: {
      sq: "Pas krijimit mund ta menaxhosh te Product Studio.",
      en: "After creating it you can manage it in Product Studio.",
    },

    // ── Preview panel ────────────────────────────────────────────────────
    previewTitleWebshop: { sq: "Pamja në webshop", en: "Webshop view" },
    previewTitle: { sq: "Pamje paraprake", en: "Preview" },
    previewCopyProduct: {
      sq: "Kështu do të duket produkti për klientët.",
      en: "This is how customers will see the product.",
    },
    previewCopyVariants: {
      sq: "Kështu do të duket produkti me variantet e zgjedhura.",
      en: "This is how the product looks with the chosen variants.",
    },
    previewCopyReview: {
      sq: "Kështu do të duket produkti në dyqan.",
      en: "This is how the product will look in the store.",
    },
    previewNoImage: { sq: "Pa foto", en: "No photo" },
    previewUntitled: { sq: "Emri i produktit", en: "Product name" },
    previewDraft: { sq: "Draft", en: "Draft" },
    previewAddToCart: { sq: "Shto në shportë", en: "Add to cart" },
    previewNote: {
      sq: "Kjo është vetëm një pamje paraprake. Detajet mund të ndryshojnë pas publikimit.",
      en: "This is only a preview. Details may change after publishing.",
    },
    previewColors: { sq: "Ngjyrat ({count})", en: "Colors ({count})" },
    previewSizes: { sq: "Madhësitë ({count})", en: "Sizes ({count})" },
    previewPrevImage: { sq: "Fotoja e mëparshme", en: "Previous photo" },
    previewNextImage: { sq: "Fotoja tjetër", en: "Next photo" },
    previewNextStepTitle: { sq: "Fotot dhe stoku", en: "Photos and stock" },
    previewNextStepCopy: {
      sq: "Në hapin tjetër do të ngarkosh fotot dhe do të vendosësh stokun për secilin variant.",
      en: "Next you'll upload photos and set stock for each variant.",
    },
    previewStockSummary: { sq: "Përmbledhje e stokut", en: "Stock summary" },
    previewStockTotal: { sq: "Gjithsej", en: "Total" },
    previewUnits: { sq: "{count} copë", en: "{count} pcs" },
    previewStockNoteCopy: {
      sq: "Mund ta publikosh produktin edhe pa foto ose pa stok, por ai do të shfaqet pa imazh ose pa stok në webshop.",
      en: "You can publish without photos or stock, but the product will then show without an image or stock in the webshop.",
    },
    previewPublishStatus: { sq: "Statusi i publikimit", en: "Publishing status" },
    previewReady: { sq: "Gati për publikim", en: "Ready to publish" },
    previewReadyCopy: {
      sq: "Produkti do të jetë i dukshëm në dyqan pas publikimit.",
      en: "The product will be visible in the store once published.",
    },
    previewNotReady: { sq: "Mungojnë fusha të detyrueshme", en: "Required fields are missing" },
  },
  collections: {
    catalog: { sq: "Katalogu", en: "Catalog" },
    title: { sq: "Koleksionet", en: "Collections" },
    newCollection: { sq: "Koleksion i ri", en: "New collection" },
    searchPlaceholder: {
      sq: "Kërko sipas emrit ose slug-ut",
      en: "Search by name or slug",
    },
    loadError: {
      sq: "Nuk mund të ngarkohen koleksionet.",
      en: "Could not load collections.",
    },
    loading: { sq: "Duke ngarkuar koleksionet…", en: "Loading collections…" },
    empty: {
      sq: "Ende nuk ka koleksione. Krijo një për të kuruar produktet.",
      en: "No collections yet. Create one to start curating products.",
    },
    colName: { sq: "Emri", en: "Name" },
    colSlug: { sq: "Slug", en: "Slug" },
    colStatus: { sq: "Statusi", en: "Status" },
    colHomepage: { sq: "Faqja kryesore", en: "Homepage" },
    colProducts: { sq: "Produktet", en: "Products" },
    colActions: { sq: "Veprimet", en: "Actions" },
    featuredPosition: {
      sq: "I veçuar · #{position}",
      en: "Featured · #{position}",
    },
    manageProducts: { sq: "Menaxho produktet", en: "Manage products" },
    edit: { sq: "Ndrysho", en: "Edit" },
    publish: { sq: "Publiko", en: "Publish" },
    moveToDraft: { sq: "Kalo në draft", en: "Move to draft" },
    archive: { sq: "Arkivo", en: "Archive" },
    statusDraft: { sq: "Draft", en: "Draft" },
    statusActive: { sq: "Aktiv", en: "Active" },
    statusArchived: { sq: "Arkivuar", en: "Archived" },
    nameRequired: {
      sq: "Emri i koleksionit është i detyrueshëm (min. 2 karaktere).",
      en: "Collection name is required (min 2 characters).",
    },
    slugRequired: {
      sq: "Slug-u është i detyrueshëm (min. 2 karaktere).",
      en: "Slug is required (min 2 characters).",
    },
    created: { sq: "Koleksioni u krijua.", en: "Collection created." },
    updated: { sq: "Koleksioni u përditësua.", en: "Collection updated." },
    saveError: {
      sq: "Koleksioni nuk u ruajt.",
      en: "Could not save collection.",
    },
    statusUpdated: {
      sq: "Statusi i koleksionit u përditësua.",
      en: "Collection status updated.",
    },
    statusUpdateError: {
      sq: "Statusi nuk u përditësua.",
      en: "Could not update status.",
    },
    invalidProductId: {
      sq: "Jep një ID të vlefshme produkti katalogu.",
      en: "Provide a valid catalog product id.",
    },
    productAdded: { sq: "Produkti u shtua.", en: "Product added." },
    productAddError: {
      sq: "Produkti nuk u shtua.",
      en: "Could not add product.",
    },
    productRemoved: { sq: "Produkti u hoq.", en: "Product removed." },
    productRemoveError: {
      sq: "Produkti nuk u hoq.",
      en: "Could not remove product.",
    },
    positionError: {
      sq: "Pozicioni nuk u përditësua.",
      en: "Could not update position.",
    },
    modalNew: { sq: "Koleksion i ri", en: "New collection" },
    modalEdit: { sq: "Ndrysho koleksionin #{id}", en: "Edit collection #{id}" },
    fieldName: { sq: "Emri", en: "Name" },
    fieldSlug: { sq: "Slug", en: "Slug" },
    slugAuto: {
      sq: "gjenerohet automatikisht nga emri",
      en: "auto-generated from name",
    },
    fieldDescription: { sq: "Përshkrimi", en: "Description" },
    descriptionHint: {
      sq: "Shënim kuratorial i shkurtër (opsional)",
      en: "Short curatorial note (optional)",
    },
    fieldHeroImage: { sq: "URL e imazhit hero", en: "Hero image URL" },
    fieldPosition: { sq: "Pozicioni", en: "Position" },
    featuredOnHomepage: {
      sq: "I veçuar në faqen kryesore",
      en: "Featured on homepage",
    },
    featuredPositionLabel: {
      sq: "Pozicioni i veçuar",
      en: "Featured position",
    },
    productsIn: { sq: 'Produktet në "{name}"', en: 'Products in "{name}"' },
    collectionLabel: { sq: "Koleksioni", en: "Collection" },
    catalogProductId: {
      sq: "ID e produktit në katalog",
      en: "Catalog product id",
    },
    positionOptional: { sq: "Pozicioni (opsional)", en: "Position (optional)" },
    addToCollection: { sq: "Shto në koleksion", en: "Add to collection" },
    noProductsInCollection: {
      sq: "Ky koleksion ende nuk ka produkte.",
      en: "This collection has no products yet.",
    },
    colCatalogProduct: { sq: "Produkti në katalog", en: "Catalog product" },
    remove: { sq: "Hiq", en: "Remove" },
  },
};

/**
 * Gets the current language from localStorage, defaults to 'sq' (Albanian)
 * @returns {string} Current language code ('sq' or 'en')
 */
export const getCurrentLanguage = () => {
  if (typeof window !== "undefined") {
    return localStorage.getItem("language") || "sq";
  }
  return "sq";
};

/**
 * Sets the current language in localStorage
 * @param {string} lang - Language code ('sq' or 'en')
 */
export const setLanguage = (lang) => {
  if (typeof window !== "undefined" && (lang === "sq" || lang === "en")) {
    localStorage.setItem("language", lang);
  }
};

/**
 * Gets translation for a given key
 * @param {string} key - Translation key in dot notation (e.g., 'common.save' or 'navigation.dashboard')
 * @param {string} [lang] - Optional language code ('sq' or 'en'). If not provided, uses current language from localStorage
 * @returns {string} Translated text, or the key if translation not found
 */
export const getTranslation = (key, lang = null) => {
  const currentLang = lang || getCurrentLanguage();

  // Split the key by dots to navigate through the translations object
  const keys = key.split(".");
  let value = translations;

  // Navigate through the object using the keys
  for (const k of keys) {
    if (value && typeof value === "object" && k in value) {
      value = value[k];
    } else {
      // If key path doesn't exist, return the original key
      console.warn(`Translation key "${key}" not found`);
      return key;
    }
  }

  // If we found a translation object with language keys
  if (value && typeof value === "object" && currentLang in value) {
    return value[currentLang];
  }

  // Fallback: if the value is directly a string (shouldn't happen with current structure)
  if (typeof value === "string") {
    return value;
  }

  // If no translation found, return the key
  console.warn(
    `Translation for key "${key}" and language "${currentLang}" not found`,
  );
  return key;
};

/**
 * Gets all translations for a specific namespace
 * @param {string} namespace - Namespace key (e.g., 'common', 'navigation')
 * @param {string} [lang] - Optional language code ('sq' or 'en')
 * @returns {object} Object with all translations in the namespace
 */
export const getTranslations = (namespace, lang = null) => {
  const currentLang = lang || getCurrentLanguage();
  const namespaceTranslations = translations[namespace];

  if (!namespaceTranslations) {
    console.warn(`Translation namespace "${namespace}" not found`);
    return {};
  }

  const result = {};
  Object.keys(namespaceTranslations).forEach((key) => {
    if (namespaceTranslations[key] && namespaceTranslations[key][currentLang]) {
      result[key] = namespaceTranslations[key][currentLang];
    }
  });

  return result;
};

// Export translations object for direct access if needed
export { translations };
